<template>
  <div class="c-box mb-16 mt-px">
    <ModalError :visible="showModalError" :errorType="errorType"></ModalError>
    <RakutenLogin
      v-if="isConfirm"
      @rakutenConfirm="setConfirm"
      @isLogin="loginRakuten"
    />
    <div class="p-pnt">
      <div class="menu-main-content">
        <section>
          <div class="main-top">
            <div class="main-top-left pb-4">
              <a
                class="inline-flex items-center"
                href="javascript:void(0)"
                @click="backPath"
              >
                <i class="icon icon-bor-arrow-left pr-2" style="font-size: 10px" />
                <span class="text-black">プラン一覧に戻る</span>
              </a>
            </div>

            <!-- TODO: 次回フェーズで使用する可能性があるためコメントアウト -->
            <!-- ご利用方法 -->
            <!-- <div class="main-top-right">
              <a href="#intro" v-smooth-scroll="{ offset: -20 }" class="sm:hidden">
                <button class="c-btn btn-white btn-sm">
                  <i class="icon icon-bor-circle-question pr-2" />
                  <span>ご利用方法</span>
                </button>
              </a>
            </div> -->

          </div>
        </section>

        <!-- /* Carousel */ -->
        <section class="main-plan">
          <div class="pnl-title flex items-start">
            <div class="label label-primary mt-2 mr-4" v-if="checkFiveDay()">NEW</div>
            <h3 class="two-lines-ellipsis" v-if="planBasicInfo">
              {{ planBasicInfo.planNm }}
            </h3>
          </div>
          <div class="main-demo">
            <div class="menu-carousel">
              <!--            <CarouselThumbnail class="mb-4 lg:hidden" :slides="planBasicInfo.slides"-->
              <!--                                :slidesToShow="planBasicInfo.planImages.length"-->
              <!--                                v-if="planBasicInfo && Array.isArray(planBasicInfo.planImages)"/>-->

              <BasicCarousel
                class="lg:hidden"
                :images="get(planBasicInfo, 'slides', [])"
                :isShowIndicator="false"
                :numberThumbnail="5"
              />

              <div
                class="slide-images-mobile hidden lg:flex overflow-x-auto object-contain"
                v-if="
                  planBasicInfo &&
                  Array.isArray(planBasicInfo.slides) &&
                  planBasicInfo.slides.length > 0
                "
              >
                <img
                  :src="img.imageUrl"
                  :alt="img.imageExplanation"
                  v-for="(img, idx) in planBasicInfo.slides"
                  :key="`plan-img-${idx}`"
                />
              </div>
            </div>
            <div class="menu-calendar">

              <!-- Plan Detail -->
              <div class="plan-detail">
                <div class="plan-detail__iconWrap">
                  <ul
                    class="plan-detail__iconList"
                  >
                    <li v-for="(flag, index) in getUsageDetails" :key="`usage-flag-${index}`">
                      <Tag
                        size="small"
                        :class="[
                          flag.label === 'カフェ' || flag.label === '補助クーポン'
                            ? 'cafe-icon plan-icon'
                            : '',
                          flag.label === 'ベネポ貯まる' || flag.label === 'ベネポ使える'
                            ? 'tag-yellow plan-icon'
                            : '',
                          flag.label === 'オンラインカード決済可' || flag.label === 'オンラインカード決済'
                            ? 'online-payment-icon plan-icon'
                            : ''
                        ]"
                        v-if="flag.label && isDisplayBenepoTamaru(flag.label)"
                      >
                        {{ flag.label }}
                      </Tag>
                    </li>
                  </ul>

                  <p class="plan-detail__planId" v-if="planBasicInfo && planBasicInfo.planId">
                    [プランID:{{ planBasicInfo.planId }}]
                  </p>

                  <div class="plan-detail__couponSocial">
                    <Share
                      :facebook="false"
                      :twitter="false"
                      :line="false"
                      :email="false"
                      :social="false"
                      :favorite="false"
                      size="large"
                      :copyLabel="copyLabel"
                    />
                  </div>
                </div>
                <SectionContentTitle lineType="v-line" titleContent="プランの詳細" />
                <div class="plan-detail__wrap">
                  <div class="">

                    <div class="room-detail-content">
                      <div
                        class="slide-images-mobile hidden lg:flex overflow-x-auto object-contain sm:hidden"
                        v-if="planBasicInfo && planBasicInfo.planImages"
                      >
                        <img
                          :src="planImg.imageUrl"
                          :alt="planImg.imageExplanation"
                          v-for="(planImg, index) in planBasicInfo.planImages"
                          :key="`plan-slide-${index}`"
                        />
                      </div>

                      <BoxViewMore class="">
                        <div
                          class="plan-detail__basicInfo whitespace-pre-wrap mb-4"
                          v-if="planBasicInfo && planBasicInfo.planLeadCopy"
                          v-html="planBasicInfo.planLeadCopy"
                        ></div>

                        <!-- TODO: 次回フェーズで使用する可能性があるためコメントアウト -->
                        <!-- ご利用方法 -->
                        <!-- <div class="sm:hidden" style="min-height: 130px">
                          <div class="room-detail-footer mt-5">
                            <span class="flex items-center">
                              <i class="icon icon-bor-circle-question pr-2" />
                              ご利用方法
                            </span>
                          </div>
                          <div class="room-detail-footer mt-2">
                            <div class="item-intro">
                              <div>
                                <a
                                  href="https://faq.benefit-one.co.jp/memberfaq/s/article/00373"
                                  target="_blank"
                                  class="mr-2"
                                  >申込み手順</a
                                >
                                <a-divider type="vertical" />
                              </div>
                              <div>
                                <a
                                  href="https://faq.benefit-one.co.jp/memberfaq/s/article/00337"
                                  target="_blank"
                                  class="mr-2"
                                  >受付開始時間になっても申込みができない場合</a
                                >
                                <a-divider type="vertical" />
                              </div>
                              <div>
                                <a
                                  href="https://faq.benefit-one.co.jp/memberfaq/s/article/00121"
                                  target="_blank"
                                  class="mr-2"
                                  >受付開始日の確認方法</a
                                >
                                <a-divider type="vertical" />
                              </div>
                              <div>
                                <a
                                  href="https://faq.benefit-one.co.jp/memberfaq/s/article/00374"
                                  target="_blank"
                                  class="mr-2"
                                  >提携プランを全て確認する方法</a
                                >
                              </div>
                            </div>
                          </div>
                        </div> -->

                      </BoxViewMore>
                    </div>
                  </div>
                </div>
              </div>

              <div class="coupons-meta">
                <div class="room-left">
                  <img
                    src="@/assets/images/recomment-rakuten.png"
                    alt="demo"
                    v-if="menuInformation && menuInformation.extSystemCd == 'RakutenT'"
                  />
                  <img
                    src="@/assets/images/bene-log.png"
                    alt="demo"
                    v-if="!menuInformation || menuInformation.extSystemCd != 'RakutenT'"
                  />
                  <div class="services-offer">
                    <div class="flex items-center item">
                      <img
                        src="~@/assets/images/food.svg"
                        alt="person icon"
                        class="flex mr-1 w-4 h-4"
                      />
                      <span>
                        {{ roomEatServiceDesc }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="flex items-center text-status">
                  <img
                    src="~@/assets/images/room-status.svg"
                    alt="person icon"
                    class="flex mr-2 w-5 h-5"
                  />
                  <span>
                    チェックイン
                    <span v-if="planUsage && planUsage.usageDetailStay">
                      {{ planUsage.usageDetailStay.checkInTm | formatTimeOnly }}
                      <span v-if="!planUsage.usageDetailStay.lastCheckInTm">～</span>
                      <span v-if="planUsage.usageDetailStay.lastCheckInTm"
                        >-
                        {{
                          planUsage.usageDetailStay.lastCheckInTm | formatTimeOnly
                        }}</span
                      >
                    </span>
                    ／ チェックアウト
                    <span v-if="planUsage && planUsage.usageDetailStay">
                      {{ planUsage.usageDetailStay.checkOutTm | formatTimeOnly }}
                    </span>
                  </span>
                </div>

                <div
                  class="pb-4 sm:pb-2 sm:text-xs"
                  v-if="menuInformation && menuInformation.extSystemCd == 'RakutenT'"
                >
                  <div class="text-red-500">
                    プランにより記載の時間と異なる場合があります。
                  </div>
                  <div class="text-red-500">プラン詳細も合わせてご確認ください。</div>
                </div>
              </div>

              <div
                class="box-notify mb-4 mt-4"
                v-if="usageLimitInformation && usageLimitInformation[0].usageLimitCont"
              >
                <span>
                  {{ usageLimitInformation[0].usageLimitCont }}
                </span>
              </div>

            </div>
          </div>
        </section>

        <!-- Box Text availability -->
        <section>
          <div class="main-availability" ref="calendar">
            <SectionContentTitle lineType="v-line" titleContent="空室状況" />
            <p class="mb-6 sm:hidden">カレンダーから宿泊日を指定してください。</p>
            <div class="form-book">
              <div class="calendar-wrap">
                <div class="cm-calendar">
                  <Calendar
                    :value="tmpVariables.stayDay"
                    @input="onSelectDay"
                    :selectedDays="getDisplaySelectedDays"
                    :dayOpens="filterOpenDays"
                    :dayOpenDecorator="dayOpenDecorator"
                    :dayFewLefts="filterFewLeftDays"
                    :fewLeftDecorator="fewLeftDecorator"
                    :dayCloses="filterCloseDays"
                    :dayClosedDecorator="dayClosedDecorator"
                    :dateCellExtraContent="dateCellExtraContent"
                    :disabledDate="checkDisabledDate"
                    :disabledPrev="calendarDisabledPrev"
                    @changeRange="onChangeRange"
                    :rangeMode="rangeMode"
                    :enableNextMonth="enableNextMonth"
                  />
                </div>
                <div v-if="status != 'CC'" class="flex gap-x-2">
                  <span>【○】空室あり【×】販売終了【ー】販売設定なし【Ｒ】リクエスト</span>
                </div>
              </div>
              <div class="form-wrap sm:border-t sm:border-b" id="planSelection">
                <div class="form-frame p-4">
                  <div class="form-title v-line">
                    <p>予約内容</p>
                  </div>
                  <div class="required-title" >
                    <p><b>期間</b></p>
                    <p><span class="ml-2 px-1 required">必須</span></p>
                  </div>
                  <div v-if="isUnspecifiedCheckInDate">
                    <p class="form-caution-text">
                      宿泊日を指定せず検索した場合、直近で空室がある日付が自動で選択されます。
                    </p>
                  </div>
                  <div class="field flex-nowrap date-picker">
                    <span v-if="tmpVariables.stayDay">
                      {{ tmpVariables.stayDay.format("YYYY/MM/DD") }}
                      <span class="pl-2 whitespace-nowrap">から</span>
                    </span><span v-else>
                      日付未選択　
                    </span>

                    <a-select v-model="tmpVariables.stayNights" class="pl-2 w-16 sm:pl-1" @change="onChangeStayNights">
                      <a-select-option v-for="(el, index) in nightOptions"
                      :value="el.value" :key="`room-${index}`"
                      :disabled="maxSelectableNight !== null && el.value > maxSelectableNight"
                      >{{ el.label }}{{ isMobile() ? '泊' : '' }}
                      </a-select-option>
                    </a-select>
                    <span class="pl-2 sm:hidden">泊</span>

                    <a-select
                      v-model="tmpVariables.stayRooms"
                      class="pl-2 w-24 sm:text-center sm:hidden"
                      @change="onChangeStayRoom"
                    >
                      <a-select-option
                        :value="el.value"
                        v-for="(el, index) in roomOptions"
                        :key="`room-${index}`"
                        :disabled="
                          maxSelectableRoom !== null && el.value > maxSelectableRoom
                        "
                      >
                        {{ el.label }}
                      </a-select-option>
                    </a-select>
                    <span class="pl-2 sm:hidden">部屋</span>

                  </div>
                  <div class="required-title" >
                    <p><b>部屋数</b></p>
                    <p><span class="ml-2 px-1 required">必須</span></p>
                  </div>
                  <div class="field">
                    <a-select
                      v-model="tmpVariables.stayRooms"
                      class="w-16 sm:text-center hidden sm:block"
                      @change="onChangeStayRoom"
                    >
                      <a-select-option
                        :value="el.value"
                        v-for="(el, index) in roomOptions"
                        :key="`room-${index}`"
                        :disabled="maxSelectableRoom !== null && el.value > maxSelectableRoom"
                      >
                        {{ el.label }}
                      </a-select-option>
                    </a-select>
                  </div>
                  <div class="field mb-8 lg:mb-6 hidden">
                    <span class="pr-2">大人</span>
                    <a-select
                      v-model="tmpVariables.stayAdults"
                      class="w-20"
                      @change="onChangeStayAdult"
                    >
                      <a-select-option
                        :value="el.value"
                        v-for="(el, index) in peopleOptions"
                        :key="`people-${index}`"
                        :disabled="
                          maxSelectablePeople !== null && el.value > maxSelectablePeople
                        "
                      >
                        {{ el.label }}
                      </a-select-option>
                    </a-select>
                    <span class="pl-2 pr-4">人</span>

                    <a-popover
                      v-model="showAttachChildren"
                      placement="bottom"
                      trigger="click"
                      class="children-attach"
                    >
                      <button class="font-bold">
                        子どもを追加する<span v-if="countTotalChildren">
                          ({{ countTotalChildren }})</span
                        >
                        <i class="icon icon-bor-circle-plus pl-2" />
                      </button>
                      <div slot="content" class="children-attach-content">
                        <div class="popover-block-first">
                          <div class="block-first-title">小学生</div>
                          <div class="block-first-content">
                            <div class="set-value-group">
                              <div class="set-value-name">高学年</div>
                              <Stepper
                                v-model="tmpVariables.attachChildren.childrenType10"
                                size="large"
                                unit="人"
                                @keyup="inputChildren('childrenType10')"
                                max="19"
                              />
                            </div>
                            <div class="set-value-group">
                              <div class="set-value-name">低学年</div>
                              <Stepper
                                v-model="tmpVariables.attachChildren.childrenType15"
                                size="large"
                                unit="人"
                                @keyup="inputChildren('childrenType15', $event)"
                                max="19"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="popover-block-second">
                          <div class="block-second-title">幼児</div>
                          <div class="block-second-content">
                            <div class="set-value-group">
                              <div class="set-value-name">食事・布団付</div>
                              <Stepper
                                v-model="tmpVariables.attachChildren.childrenType20"
                                size="large"
                                unit="人"
                                @keyup="inputChildren('childrenType20', $event)"
                                max="19"
                              />
                            </div>
                            <div class="set-value-group">
                              <div class="set-value-name">食事のみ</div>
                              <Stepper
                                v-model="tmpVariables.attachChildren.childrenType30"
                                size="large"
                                unit="人"
                                max="19"
                                @keyup="inputChildren('childrenType30', $event)"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="popover-block-three">
                          <div class="block-three-content">
                            <div class="set-value-group">
                              <div class="set-value-name">布団のみ</div>
                              <Stepper
                                v-model="tmpVariables.attachChildren.childrenType40"
                                size="large"
                                unit="人"
                                @keyup="inputChildren('childrenType40', $event)"
                                max="19"
                              />
                            </div>
                            <div class="set-value-group">
                              <div class="set-value-name">食事・布団不要</div>
                              <Stepper
                                v-model="tmpVariables.attachChildren.childrenType50"
                                size="large"
                                unit="人"
                                max="19"
                                @keyup="inputChildren('childrenType50', $event)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </a-popover>
                  </div>
                  <PeoplePlan
                    :planData="planDetail"
                    :stayDay="tmpVariables.stayDay ? tmpVariables.stayDay : stayDay"
                    :stayNights="tmpVariables.stayNights"
                    :stayRooms="tmpVariables.stayRooms"
                    :vacancyCalendar="vacancyCalendar"
                    :peopleDetails="peopleDetails"
                    @change="onChangePeoplePlan"
                    @checkConditionBookRoom="checkCondition"
                    class="mb-4"
                  />
                  <div class="divider mb-2 mt-4 hidden sm:h-0.5 sm:block" />
                  <div class="plan-price">
                    <div v-if="!isSelectedOutStockDay" class="plan-price-left">
                      <div>
                        <label>合計料金</label>
                      </div>
                      <div class="plan-price-left_inner">
                        <span>税込</span>
                        <span class="price">
                          {{ calculateMemberAmount | formatCurrency }}
                        </span>
                      </div>
                    </div>
                    <div v-if="!isSelectedOutStockDay" class="plan-price-right">
                      <label>ビジター価格</label>
                      <div class="plan-price-left_inner">
                        <span>税込</span>
                        <span class="price">
                          {{ computeVisitorAmount | formatCurrency }}
                        </span>
                      </div>
                    </div>
                    <p
                      class="menu-item__point w-full pt-5 pb-1 sm:py-1"
                      v-if="isTargetGrantedBenepo"
                    >
                      獲得予定ベネポ：<span class="menu-item__point--point">
                        <strong class="menu-item__point--number">{{ grantedBenepo | formatDecimal }}</strong>p
                      </span>
                      <span class="menu-item__point--rakuten" v-if="menuInformation && menuInformation.extSystemCd == 'RakutenT'">＋楽天ポイント<span class="menu-item__point--point"><strong class="menu-item__point--number">1</strong>%〜</span></span>
                    </p>
                    <div
                      class="price-min"
                      v-show="!checkPriceRoom && +minRoomPrice !== 0 && +item.totalPerson > 0"
                      v-for="(item, index) in arrPriceMin"
                      :key="`price-min-${index}`"
                    >
                      <span v-show="item.value > 0">
                        <span v-show="item.value">{{ item.title }}</span>
                        <span v-show="item.value"
                          ><span class="font-bold"
                            >{{ item.value | formatInteger }}円</span
                          >～</span
                        >
                      </span>
                      <span v-show="+item.value === 0">
                        <span>{{ item.title }}</span>
                        <span><span class="font-bold">0円</span>～</span>
                      </span>
                    </div>
                    <div v-show="checkPriceRoom && minRoomPrice !== 0">
                      <span>1人あたりの料金 　税込 </span>
                      <span
                        ><span class="font-bold">{{ todayPrice }}円</span>～</span
                      >
                    </div>
                    <div class="w-full mt-2">
                      <div
                        class="box-stay-request-memo"
                        v-show="isStayRequest()"
                      >
                        <p class="stay-request-memo-title">※このプランはリクエスト申込みです</p>
                        <p class="stay-request-memo-content">施設への空室確認後、メールにて回答いたします<br/>
                        空室状況によってはご予約が承れない場合がございますので、あらかじめご了承ください</p>
                        <p class="stay-request-memo-title">※リクエスト申込み時のご注意</p>
                        <p class="stay-request-memo-content">空室確認時に手配が可能で合った場合は、そのまま予約が確定となります<br/>
                        そのため、ご利用日が既にキャンセル規定の該当日である場合は<br/>
                        お申込みいただいた時点でキャンセル・変更料金が発生いたしますのでご注意ください</p>
                      </div>
                    </div>
                    <div class="w-full mt-2">
                      <!-- Box Coupons -->
                      <div
                        class="box-coupons"
                        v-show="availableSubsidy"
                      >
                        <div class="box-coupons-left text-center">
                          <i class="icon icon-bor-coupons text-primary" />
                          <p class="lg:block">補助クーポン</p>
                          <p>利用可能</p>
                        </div>
                        <a-divider type="vertical" class="coupon-divider" />
                        <div class="coupons-contents">
                          <!-- PC表示 -->
                          <SubsidyGroupDetail class="sm:hidden"
                            :subsidy="subsidyCouponGroupList"
                            :subsidyShow="expandCouponList == true"
                          />
                          <SubsidyDetail class="sm:hidden"
                            v-for="(subsidy, index) in subsidyCouponList"
                            :key="`subsidy-${subsidy.availableData.subsidyDetailId}`"
                            :subsidy="subsidy"
                            v-show="(subsidyCouponGroupList.length == 0 && index === 0) || expandCouponList == true"
                          >
                          </SubsidyDetail>

                          <!-- SP表示 -->
                          <!-- グループ補助金： グループ補助金の上部にグループ補助金情報を表示 -->
                          <div class="hidden sm:block"
                            v-for="(groupSubsidy, gIndex) in subsidyCouponGroupList"
                            :key="`subsidy-${groupSubsidy.availableData.subsidyDetailId}-sm`"
                            v-show="gIndex === 0 || expandCouponList == true"
                          >
                            <template v-if="groupSubsidy.availableData.groupInfo != null && groupSubsidy.displayGroupInfoFlg">
                              <div v-show="groupSubsidy.dispFlag || expandCouponList == true" class="coupon-card">
                                <!-- グループ補助金名称 -->
                                <div
                                  class="flex-cols-2 sm:flex-col items-end sm:items-start mb-2 sm:text-center"
                                >
                                  <strong class="py-0.5">{{ groupSubsidy.availableData.groupInfo.groupName }}</strong>
                                </div>
                                <!-- グループ補助金：保有枚数 -->
                                <!-- 利用制限単位（usedLimUnit）が[02：契約ID毎][03：契約ID合計毎]の場合、非表示とする -->
                                <div
                                  v-if="groupSubsidy.availableData.usedLimUnit != '02' && groupSubsidy.availableData.usedLimUnit != '03'
                                      && groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value >= 0 && groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value !== null"
                                >
                                  <span>保有枚数&nbsp;</span>
                                  <!-- 上限枚数と残枚数が設定されている場合：「X/Y枚」 -->
                                  <div v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxCnt !== null">
                                    {{ groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value | formatInteger }}
                                    /{{groupSubsidy.availableData.groupInfo.parsonalUsedMaxCnt | formatInteger}}
                                    枚
                                  </div>
                                  <!-- 上限枚数未設定かつ残枚数が設定されている場合：「X枚」 -->
                                  <div v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxCnt == null">
                                    {{ groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value | formatInteger }}
                                    枚
                                  </div>
                                </div>
                                <!-- グループ補助金：利用可能残金額 -->
                                <div
                                  v-if="groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value >= 0 && groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value !== null"
                                >
                                  <span>利用可能残金額&nbsp;</span>
                                  <!-- 上限金額と残金が設定されている場合：「X/Y円」 -->
                                  <div v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxTotalAmt !== null">
                                    {{ groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value | formatInteger }}
                                    /{{groupSubsidy.availableData.groupInfo.parsonalUsedMaxTotalAmt | formatInteger}}
                                    円
                                  </div>
                                  <!-- 上限金額が未設定かつ残金が設定されている場合：「X円」 -->
                                  <div v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxTotalAmt == null">
                                    {{ groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value | formatInteger }}
                                    円
                                  </div>
                                </div>
                                <!-- グループ補助金：申込期間 -->
                                <p
                                  v-if="
                                    groupSubsidy.availableData.groupInfo.receptionDateFrom != null ||
                                    groupSubsidy.availableData.groupInfo.receptionDateTo != null
                                  "
                                >
                                  申込期間（受付期間）
                                  <span v-if="groupSubsidy.availableData.groupInfo.receptionDateFrom != null">
                                    {{ $moment(groupSubsidy.availableData.groupInfo.receptionDateFrom).format('YYYY/MM/DD') }}
                                  </span>
                                  <span v-if="groupSubsidy.availableData.groupInfo.receptionDateTo != null">
                                    ～{{$moment(groupSubsidy.availableData.groupInfo.receptionDateTo).format('YYYY/MM/DD') }}
                                  </span>
                                </p>
                                <!-- グループ補助金内容説明 -->
                                <div v-if="infoGroupTexts(groupSubsidy)" v-html="infoGroupTexts(groupSubsidy)" />
                                <!-- グループ補助金用のWeb注記コメント -->
                                <div>{{ groupSubsidy.availableData.groupInfo.dispNoteComment }}</div>
                                <!-- グループに紐づく補助金表示 -->
                                <!-- 再度ループして、上階層ループのグループIDと同一のものを表示する -->
                                <div
                                  v-for="(subsidy) in subsidyCouponGroupList"
                                  :key="`subsidy-${subsidy.availableData.subsidyDetailId}-sm`"
                                >
                                  <div
                                    v-if="subsidy.availableData.groupInfo.groupId == groupSubsidy.availableData.groupInfo.groupId"
                                    v-show="gIndex === 0 || expandCouponList == true"
                                  >
                                    <details class="accordion-wrapper ">
                                      <summary class="name-coupon font-size-medium accordion-summary ">
                                        <span>
                                          <strong class="py-0.5">{{ get(subsidy, 'availableData.dispSubsidyNm') }}</strong>
                                        </span>
                                      </summary>
                                      <div v-if="subsidy.availableData.groupInfo.groupId == groupSubsidy.availableData.groupInfo.groupId">
                                        <!-- 1. -->
                                        <div v-if="get(subsidy, 'listPrice')">
                                          補助単価
                                          <div v-for="(couponsItem, idx) in get(subsidy, 'listPrice')" :key="idx">
                                            {{ couponsItem.ageType }} {{ couponsItem.price | formatCurrency('円') }}
                                            <div v-if=" couponsItem.limApplicableDateFrom || couponsItem.limApplicableDateTo ">
                                              有効期限
                                              <span v-if="couponsItem.limApplicableDateFrom">
                                                {{
                                                  couponsItem.limApplicableDateFrom
                                                }}
                                              </span>
                                              <span v-if="couponsItem.limApplicableDateTo">
                                                ~{{ couponsItem.limApplicableDateTo }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>

                                        <!-- 企業補助金 -->
                                        <div v-if="isCorporate(subsidy.availableData)">
                                          <!-- 保有枚数 -->
                                          <div v-if="
                                            (subsidy.availableData.parsonalUsedMaxCnt && subsidy.availableRemainingCount) ||
                                            (subsidy.availableData.parsonalUsedMaxCnt && subsidy.availableRemainingCount === 0)
                                          ">
                                            <span>保有枚数&nbsp;</span>
                                            <span>
                                              {{ subsidy.availableRemainingCount | formatInteger }}/{{subsidy.availableData.parsonalUsedMaxCnt | formatInteger }}枚
                                            </span>
                                          </div>

                                          <!-- 利用可能残金額 -->
                                          <div v-if="
                                            (subsidy.availableRemainingAmount && subsidy.availableData.parsonalUsedMaxTotalAmt ) ||
                                            (subsidy.availableRemainingAmount === 0 && subsidy.availableData.parsonalUsedMaxTotalAmt )
                                            ">
                                              <span>利用可能残金額&nbsp;</span>
                                              <span>
                                                {{ subsidy.availableRemainingAmount | formatInteger }}/{{ subsidy.availableData.parsonalUsedMaxTotalAmt | formatInteger }}円
                                              </span>
                                          </div>
                                        </div>

                                        <!-- 健保補助金 -->
                                        <div v-else>
                                          <!-- 保有枚数 -->
                                          <div v-if="remainingCountLabel(subsidy) && remainingCountLabel(subsidy).length > 0">
                                              <span>保有枚数&nbsp;</span>
                                              <span
                                                style="margin-right: 15px"
                                                v-for="(value, idx) in remainingCountLabel(subsidy)"
                                                :key="idx"
                                                >
                                                {{ value }}枚
                                              </span>
                                          </div>

                                          <!-- 保有金額 -->
                                          <div v-if="remainingAmountLabel(subsidy) && remainingAmountLabel(subsidy).length > 0">
                                              <span>保有金額&nbsp;</span>
                                              <span
                                                style="margin-right: 15px"
                                                v-for="(value, idx) in remainingAmountLabel(subsidy)"
                                                :key="idx"
                                              >
                                              {{ value }}円
                                            </span>
                                          </div>
                                        </div>

                                        <p>
                                          ※宿泊日によって補助金額が異なる場合があります。詳細はマイページをご確認下さい。
                                        </p>

                                        <p
                                          v-if="
                                            get(subsidy, 'availableData.receptionDateFrom') ||
                                            get(subsidy, 'availableData.receptionDateTo')
                                          "
                                        >
                                          申込期間（受付期間）
                                          <span
                                            v-if="get(subsidy, 'availableData.receptionDateFrom')"
                                          >
                                            {{
                                              get(subsidy, 'availableData.receptionDateFrom')
                                            }}</span
                                          >
                                          <span v-if="get(subsidy, 'availableData.receptionDateTo')"
                                            >～{{
                                              get(subsidy, 'availableData.receptionDateTo')
                                            }}</span
                                          >
                                        </p>

                                        <!-- 利用制限期間（年） -->
                                        <p class="planDetail" v-if="get(subsidy, 'availableData.usedLimTerm') == '01'">
                                          上記適用期間内での制限適用となります
                                        </p>
                                        <!-- 利用制限期間（月） -->
                                        <p class="planDetail" v-if="get(subsidy, 'availableData.usedLimTerm') == '02'">
                                          月の利用制限となります
                                        </p>

                                        <!-- 健保補助金：続柄と利用上限メッセージ表示 -->
                                        <template v-if="getRequestTypeCoupon(subsidy) == '02'">

                                          <!--  利用上限枚数が1枚以上で設定されている場合、最大枚数を表示 -->
                                          <div v-if="isShowUsedMaxCntInsurance01(subsidy) > 0 && !isShowUsedMaxTotalAmt(subsidy)">
                                            {{
                                              (get(subsidy,'availableData.applicableDegreeCnt') | formatInteger) + '親等までを対象者として、1対象者あたり最大' +
                                              (get(subsidy,'availableData.parsonalUsedMaxCnt') | formatInteger) + `枚までご利用いただけます。`
                                            }}
                                          </div>

                                          <!--  利用上限金額が1円以上で設定されている場合、最大金額を表示 -->
                                          <div v-if="isShowUsedMaxTotalAmt(subsidy) > 0 && !isShowUsedMaxCntInsurance01(subsidy)">
                                            {{
                                              (get(subsidy, 'availableData.applicableDegreeCnt') | formatInteger) + '親等までを対象者として、1対象者あたり最大' +
                                              (get(subsidy, 'availableData.parsonalUsedMaxTotalAmt') | formatInteger) + `円までご利用いただけます。`
                                            }}
                                          </div>

                                          <!--  利用上限金額と利用上限枚数がどちらもが1円・1枚以上で設定されている場合、最大金額を表示 -->
                                          <div v-if="isShowUsedMaxTotalAmt(subsidy) > 0 && isShowUsedMaxTotalAmt(subsidy) > 0">
                                            {{
                                              (get(subsidy, 'availableData.applicableDegreeCnt') | formatInteger) + '親等までを対象者として、1対象者あたり最大' +
                                              (get(subsidy,'availableData.parsonalUsedMaxCnt') | formatInteger) + `枚、` +
                                              (get(subsidy, 'availableData.parsonalUsedMaxTotalAmt') | formatInteger) + `円までご利用いただけます。`
                                            }}
                                          </div>

                                          <!-- ＠info:補助金取得処理時点で該当データはフィルタされて存在しないはずのため不要と思われるためコメントアウト
                                          保有金額設定（残金設定）時の場合、
                                          ＜条件＞
                                          利用上限金額が0円の場合（使い切っている場合）または利用上限金額がNULL（上限なし）
                                          かつ
                                          保有金額が1円以上存在する場合 -->
                                          <!-- <div
                                            v-if="
                                              (isShowUsedMaxTotalAmt(subsidy) == 0 || !isShowUsedMaxTotalAmt(subsidy)) &&
                                              subsidy.availableRemainingAmount > 0
                                            "
                                          >
                                            {{
                                              (get(subsidy, 'availableData.applicableDegreeCnt') | formatInteger) +
                                              '親等までを対象者として、1対象者あたり最大' +
                                              (subsidy.availableRemainingAmount | formatInteger) +
                                              '円までご利用いただけます'
                                            }}
                                          </div> -->

                                          <div
                                            v-if="
                                              get(
                                                subsidy,
                                                'scrennDisplayItemList.remainingCountLabel'
                                              )
                                            "
                                          >
                                            下記は、過去に利用した対象者の保有枚数を表示しています。
                                            未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
                                            {{
                                              get(
                                                subsidy,
                                                'scrennDisplayItemList.remainingCountLabel'
                                              ) | formatInteger
                                            }}
                                          </div>
                                        </template>

                                        <!-- <div v-else> 項目非表示 </div> -->
                                        <!-- usedMaxCnt -->
                                        <p
                                          class="planDetail"
                                          v-if="get(subsidy, 'availableData.usedMaxCnt')"
                                        >
                                          所属団体様内で先着{{
                                            get(subsidy, 'availableData.usedMaxCnt') | formatInteger
                                          }}枚まで
                                        </p>

                                        <!-- usedMaxTotalAmt -->
                                        <p
                                          class="planDetail"
                                          v-if="get(subsidy, 'availableData.usedMaxTotalAmt')"
                                        >
                                          ※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。
                                        </p>

                                        <!-- minChargeAmt -->
                                        <p
                                          class="planDetail"
                                          v-if="get(subsidy, 'availableData.minChargeAmt') === 1"
                                        >
                                          必ず自己負担が必要になります。
                                        </p>

                                        <p
                                          class="planDetail"
                                          v-if="get(subsidy, 'availableData.minChargeAmt') > 1"
                                        >
                                          {{
                                            get(subsidy, 'availableData.minChargeAmt')
                                          }}円以上のご負担が必要となります。
                                        </p>
                                        <!-- <p v-if="!get(subsidy, 'availableData.minChargeAmt')">項目非表示</p> -->
                                        <!-- 実費未満投入可否 -->
                                        <template>
                                          <p
                                            class="planDetail"
                                            v-if="
                                              !get(subsidy, 'availableData.minChargeAmt') &&
                                              get(subsidy, 'availableData.costUnderChargeableFlg') ==
                                                '0'
                                            "
                                          >
                                            利用金額が補助金額に満たない場合は利用不可
                                          </p>
                                        </template>

                                        <!-- 重複可否 -->

                                        <p
                                          class="planDetail"
                                          v-if="get(subsidy, 'availableData.minTgtAge')"
                                        >
                                          {{
                                            get(subsidy, 'availableData.minTgtAge') | formatInteger
                                          }}歳以上が対象
                                        </p>
                                        <p
                                          class="planDetail"
                                          v-if="
                                            get(subsidy, 'availableData.personAccompanyFlg') === '1'
                                          "
                                        >
                                          家族会員のみでの利用不可
                                        </p>
                                        <p
                                          class="planDetail"
                                          v-if="
                                            get(subsidy, 'availableData.multipleUnusableFlg') === '0'
                                          "
                                        >
                                          併用可
                                        </p>
                                        <p
                                          class="planDetail"
                                          v-if="
                                            get(subsidy, 'availableData.multipleUnusableFlg') === '1'
                                          "
                                        >
                                          併用不可
                                        </p>
                                        <p
                                          class="planDetail"
                                          v-if="get(subsidy, 'availableData.usedFormDiv') === '01'"
                                        >
                                          対象メニューの申込で自動で利用できます
                                        </p>
                                        <p
                                          class="planDetail"
                                          v-if="get(subsidy, 'availableData.usedFormDiv') === '02'"
                                        >
                                          利用申請があった場合のみ利用できます
                                        </p>
                                        <div>
                                          {{ subsidy.availableData.dispNoteComment }}
                                        </div>
                                        <div class="mb-2"></div>
                                      </div>
                                    </details>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                          <div class="hidden sm:block"
                            v-for="(subsidy, index) in subsidyCouponList"
                            :key="`subsidy-${subsidy.availableData.subsidyDetailId}-sm`"
                            v-show="(subsidyCouponGroupList.length == 0 && index === 0) || expandCouponList == true"
                          >
                            <div class="flex-cols-2 sm:flex-col items-end sm:items-start mb-2 sm:text-center">
                              <strong class="py-0.5">{{ get(subsidy, 'availableData.dispSubsidyNm') }}</strong>
                            </div>
                            <!-- 1. -->
                            <!-- 補助単価表示：SP -->
                            <span>補助単価</span>
                            <div v-for="(price) in subsidyList[index].availableData.priceList" :key="price.id">

                              <!-- 企業補助金の場合 -->
                              <span v-if="isCorporate(subsidyList[index].availableData)">
                                <div v-if="price.priceType !== '一律'">{{ price.priceType }}</div>
                                <div v-if="price.ageType !== '一律'">{{ price.ageType }}</div>
                                <span>{{ price.price | formatInteger }}円</span>
                              </span>

                              <!-- 健保補助金の場合 -->
                              <span v-else>
                                {{ price.priceType !== '一律' ? `${price.priceType}（${price.ageType}） ` : ''}}{{ price.price | formatCurrency('円') }}
                              </span>

                              <!-- 有効期限 -->
                              <div v-if=" price.limApplicableDateFrom || price.limApplicableDateTo ">
                                有効期限
                                <span v-if="price.limApplicableDateFrom">
                                  {{
                                    price.limApplicableDateFrom
                                  }}
                                </span>
                                <span v-if="price.limApplicableDateTo">
                                  ~{{ price.limApplicableDateTo }}
                                </span>
                              </div>
                            </div>

                            <!-- 企業補助金 -->
                            <div v-if="isCorporate(subsidy.availableData)">
                              <!-- 保有枚数 -->
                              <div v-if="
                                (subsidy.availableData.parsonalUsedMaxCnt && subsidy.availableRemainingCount) ||
                                (subsidy.availableData.parsonalUsedMaxCnt && subsidy.availableRemainingCount === 0)
                              ">
                                <span>保有枚数&nbsp;</span>
                                <span>
                                  {{ subsidy.availableRemainingCount | formatInteger }}/{{subsidy.availableData.parsonalUsedMaxCnt | formatInteger }}枚
                                </span>
                              </div>

                              <!-- 利用可能残金額 -->
                              <div v-if="
                                (subsidy.availableRemainingAmount && subsidy.availableData.parsonalUsedMaxTotalAmt ) ||
                                (subsidy.availableRemainingAmount === 0 && subsidy.availableData.parsonalUsedMaxTotalAmt )
                                ">
                                  <span>利用可能残金額&nbsp;</span>
                                  <span>
                                    {{ subsidy.availableRemainingAmount | formatInteger }}/{{ subsidy.availableData.parsonalUsedMaxTotalAmt | formatInteger }}円
                                  </span>
                              </div>
                            </div>

                            <!-- 健保補助金 -->
                            <div v-else>
                              <!-- 保有枚数 -->
                              <div v-if="remainingCountLabel(subsidy) && remainingCountLabel(subsidy).length > 0">
                                  <span>保有枚数&nbsp;</span>
                                  <span
                                    style="margin-right: 15px"
                                    v-for="(value, idx) in remainingCountLabel(subsidy)"
                                    :key="idx"
                                    >
                                    {{ value }}枚
                                  </span>
                              </div>

                              <!-- 保有金額 -->
                              <div v-if="remainingAmountLabel(subsidy) && remainingAmountLabel(subsidy).length > 0">
                                  <span>保有金額&nbsp;</span>
                                  <span
                                    style="margin-right: 15px"
                                    v-for="(value, idx) in remainingAmountLabel(subsidy)"
                                    :key="idx"
                                  >
                                  {{ value }}円
                                </span>
                              </div>
                            </div>

                            <p>
                              ※宿泊日によって補助金額が異なる場合があります。詳細はマイページをご確認下さい。
                            </p>

                            <p
                              v-if="
                                get(subsidy, 'availableData.receptionDateFrom') ||
                                get(subsidy, 'availableData.receptionDateTo')
                              "
                            >
                              申込期間（受付期間）
                              <span
                                v-if="get(subsidy, 'availableData.receptionDateFrom')"
                              >
                                {{
                                  get(subsidy, 'availableData.receptionDateFrom')
                                }}</span
                              >
                              <span v-if="get(subsidy, 'availableData.receptionDateTo')"
                                >～{{
                                  get(subsidy, 'availableData.receptionDateTo')
                                }}</span
                              >
                            </p>

                            <!-- 利用制限期間（年） -->
                            <p class="planDetail" v-if="get(subsidy, 'availableData.usedLimTerm') == '01'">
                              上記適用期間内での制限適用となります
                            </p>
                            <!-- 利用制限期間（月） -->
                            <p class="planDetail" v-if="get(subsidy, 'availableData.usedLimTerm') == '02'">
                              月の利用制限となります
                            </p>

                            <!-- 健保補助金：続柄と利用上限メッセージ表示 -->
                            <template v-if="getRequestTypeCoupon(subsidy) == '02'">

                              <!--  利用上限枚数が1枚以上で設定されている場合、最大枚数を表示 -->
                              <div v-if="isShowUsedMaxCntInsurance01(subsidy) > 0 && !isShowUsedMaxTotalAmt(subsidy)">
                                {{
                                  (get(subsidy,'availableData.applicableDegreeCnt') | formatInteger) + '親等までを対象者として、1対象者あたり最大' +
                                  (get(subsidy,'availableData.parsonalUsedMaxCnt') | formatInteger) + `枚までご利用いただけます。`
                                }}
                              </div>

                              <!--  利用上限金額が1円以上で設定されている場合、最大金額を表示 -->
                              <div v-if="isShowUsedMaxTotalAmt(subsidy) > 0 && !isShowUsedMaxCntInsurance01(subsidy)">
                                {{
                                  (get(subsidy, 'availableData.applicableDegreeCnt') | formatInteger) + '親等までを対象者として、1対象者あたり最大' +
                                  (get(subsidy, 'availableData.parsonalUsedMaxTotalAmt') | formatInteger) + `円までご利用いただけます。`
                                }}
                              </div>

                              <!--  利用上限金額と利用上限枚数がどちらもが1円・1枚以上で設定されている場合、最大金額を表示 -->
                              <div v-if="isShowUsedMaxTotalAmt(subsidy) > 0 && isShowUsedMaxTotalAmt(subsidy) > 0">
                                {{
                                  (get(subsidy, 'availableData.applicableDegreeCnt') | formatInteger) + '親等までを対象者として、1対象者あたり最大' +
                                  (get(subsidy,'availableData.parsonalUsedMaxCnt') | formatInteger) + `枚、` +
                                  (get(subsidy, 'availableData.parsonalUsedMaxTotalAmt') | formatInteger) + `円までご利用いただけます。`
                                }}
                              </div>

                              <!-- ＠info:補助金取得処理時点で該当データはフィルタされて存在しないはずのため不要と思われるためコメントアウト
                              保有金額設定（残金設定）時の場合、
                              ＜条件＞
                              利用上限金額が0円の場合（使い切っている場合）または利用上限金額がNULL（上限なし）
                              かつ
                              保有金額が1円以上存在する場合 -->
                              <!-- <div
                                v-if="
                                  (isShowUsedMaxTotalAmt(subsidy) == 0 || !isShowUsedMaxTotalAmt(subsidy)) &&
                                  subsidy.availableRemainingAmount > 0
                                "
                              >
                                {{
                                  (get(subsidy, 'availableData.applicableDegreeCnt') | formatInteger) +
                                  '親等までを対象者として、1対象者あたり最大' +
                                  (subsidy.availableRemainingAmount | formatInteger) +
                                  '円までご利用いただけます'
                                }}
                              </div> -->

                              <div
                                v-if="
                                  get(
                                    subsidy,
                                    'scrennDisplayItemList.remainingCountLabel'
                                  )
                                "
                              >
                                下記は、過去に利用した対象者の保有枚数を表示しています。
                                未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
                                {{
                                  get(
                                    subsidy,
                                    'scrennDisplayItemList.remainingCountLabel'
                                  ) | formatInteger
                                }}
                              </div>
                            </template>

                            <!-- <div v-else> 項目非表示 </div> -->
                            <!-- usedMaxCnt -->
                            <p
                              class="planDetail"
                              v-if="get(subsidy, 'availableData.usedMaxCnt')"
                            >
                              所属団体様内で先着{{
                                get(subsidy, 'availableData.usedMaxCnt') | formatInteger
                              }}枚まで
                            </p>

                            <!-- usedMaxTotalAmt -->
                            <p
                              class="planDetail"
                              v-if="get(subsidy, 'availableData.usedMaxTotalAmt')"
                            >
                              ※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。
                            </p>

                            <!-- minChargeAmt -->
                            <p
                              class="planDetail"
                              v-if="get(subsidy, 'availableData.minChargeAmt') === 1"
                            >
                              必ず自己負担が必要になります。
                            </p>

                            <p
                              class="planDetail"
                              v-if="get(subsidy, 'availableData.minChargeAmt') > 1"
                            >
                              {{
                                get(subsidy, 'availableData.minChargeAmt')
                              }}円以上のご負担が必要となります。
                            </p>
                            <!-- <p v-if="!get(subsidy, 'availableData.minChargeAmt')">項目非表示</p> -->
                            <!-- 実費未満投入可否 -->
                            <template>
                              <p
                                class="planDetail"
                                v-if="
                                  !get(subsidy, 'availableData.minChargeAmt') &&
                                  get(subsidy, 'availableData.costUnderChargeableFlg') ==
                                    '0'
                                "
                              >
                                利用金額が補助金額に満たない場合は利用不可
                              </p>
                            </template>

                            <!-- 重複可否 -->

                            <p
                              class="planDetail"
                              v-if="get(subsidy, 'availableData.minTgtAge')"
                            >
                              {{
                                get(subsidy, 'availableData.minTgtAge') | formatInteger
                              }}歳以上が対象
                            </p>
                            <p
                              class="planDetail"
                              v-if="
                                get(subsidy, 'availableData.personAccompanyFlg') === '1'
                              "
                            >
                              家族会員のみでの利用不可
                            </p>
                            <p
                              class="planDetail"
                              v-if="
                                get(subsidy, 'availableData.multipleUnusableFlg') === '0'
                              "
                            >
                              併用可
                            </p>
                            <p
                              class="planDetail"
                              v-if="
                                get(subsidy, 'availableData.multipleUnusableFlg') === '1'
                              "
                            >
                              併用不可
                            </p>
                            <p
                              class="planDetail"
                              v-if="get(subsidy, 'availableData.usedFormDiv') === '01'"
                            >
                              対象メニューの申込で自動で利用できます
                            </p>
                            <p
                              class="planDetail"
                              v-if="get(subsidy, 'availableData.usedFormDiv') === '02'"
                            >
                              利用申請があった場合のみ利用できます
                            </p>
                            <div>
                              {{ subsidy.availableData.dispNoteComment }}
                            </div>
                            <div class="mb-2"></div>
                          </div>
                          <div
                            class="expand-icon"
                            @click="expandCouponList = !expandCouponList"
                            v-show="subsidyList && (subsidyCouponList.length + subsidyGroupList.length) > 1"
                          >
                            {{
                              expandCouponList
                                ? '閉じる'
                                : `他${subsidyCouponList.length + subsidyGroupList.length - 1}種の補助クーポンがあります`
                            }}<i
                              class="icon icon-bor-triangle-down"
                              :class="expandCouponList ? 'rotate' : ''"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="availableSubsidy"
                      class="available-coupon-balloon"
                    >
                      <p>利用できる補助クーポンがあります</p>
                    </div>
                    <Button
                      class="c-btn w-full"
                      size="large"
                      type="dark"
                      :loading="loading"
                      @click="setConfirm(true)"
                      v-if="
                        menuInformation &&
                        menuInformation.extSystemCd == 'RakutenT' &&
                        !isLoginedRakuten
                      "
                    >楽天会員IDでログイン
                    </Button>
                    <Button
                      class="c-btn w-full"
                      size="large"
                      type="dark"
                      :loading="loading"
                      @click="goNext"
                      v-else
                      >予約内容の申込画面へ
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Room Detail -->
        <section>
          <div class="room-detail">
            <SectionContentTitle lineType="v-line" titleContent="お部屋の詳細" />
            <div class="room-detail-wrap">
              <div class="room-detail-left">
                <div class="recommended-right" v-show="roomIcons">
                  <span v-for="(icon, index) in roomIcons" :key="index">
                    <div class="label label-grey-200 mr-3" v-if="icon.iconNm">
                      {{ icon.iconNm }}
                    </div>
                  </span>
                </div>

                <div class="room-detail-title">
                  <h3 v-if="roomBasicInfo && roomBasicInfo.roomNm">
                    {{ roomBasicInfo.roomNm }}
                  </h3>
                </div>

                <div class="hotel-meta-wrap">
                  <div class="hotel-meta">
                    <!-- <div class="meta-item" v-for="(info, index) in getRoomBasicInfoList" :key="`room-basic-info-${index}`">
                    <i class="icon icon-bor-people" />
                    {{info.label}} <span v-if="roomBasicInfo && roomBasicInfo.maxStayCapacity">{{info.value}}</span>名
                  </div> -->
                    <div class="meta-item">
                      <img
                        src="~@/assets/images/person-icon.svg"
                        alt="person icon"
                        class="sm:flex mr-2 w-5 h-5"
                      />
                      定員
                      <span
                        class="mx-1"
                        v-if="roomBasicInfo && roomBasicInfo.maxStayCapacity"
                        >{{ roomBasicInfo.maxStayCapacity | formatInteger }}</span
                      >名
                    </div>
                    <div class="meta-item">
                      <img
                        style="height: 13.96px"
                        src="~@/assets/images/bed-icon.svg"
                        alt="bed icon"
                        class="sm:flex mr-2 w-4"
                      />
                      <span
                        class="mx-1"
                        v-if="roomBasicInfo && roomBasicInfo.roomCondNm"
                        >{{ roomBasicInfo.roomCondNm }}</span
                      >
                    </div>
                    <div class="meta-item" 
                      v-if="menuInformation && menuInformation.extSystemCd != 'RakutenT' && 
                            roomBasicInfo && roomBasicInfo.roomSizeTxt"
                    >
                      <img
                        src="~@/assets/images/room-size-icon.svg"
                        alt="room-size icon"
                        class="sm:flex mr-2 w-4 h-4"
                      />
                      部屋のサイズ
                      <span
                        class="mx-1"
                        >{{ roomBasicInfo.roomSizeTxt }}</span
                      >
                    </div>
                    <div class="meta-item">
                      <img
                        src="~@/assets/images/no-smoking-icon.svg"
                        alt="no-smoking icon"
                        class="sm:flex mr-2 w-4 h-4"
                      />
                      <span>{{ smokingDiv }}</span>
                    </div>
                  </div>
                </div>

                <BoxViewMore class="">
                  <div
                    class="plan-detail__basicInfo whitespace-pre-wrap mb-4"
                    v-if="roomBasicInfo && roomBasicInfo.note"
                    v-html="roomBasicInfo.note"
                  ></div>

                  <div
                    class="plan-detail__basicInfo whitespace-pre-wrap mb-4"
                    v-if="roomBasicInfo && roomBasicInfo.roomSizeNote"
                    v-html="roomBasicInfo.roomSizeNote"
                  ></div>
                </BoxViewMore>

                <div
                  class="slide-images-mobile hidden lg:flex overflow-x-auto object-contain"
                  v-if="roomBasicInfo && roomBasicInfo.roomImages"
                >
                  <img
                    :src="roomImg.imageUrl"
                    :alt="roomImg.imageExplanation"
                    v-for="(roomImg, index) in roomBasicInfo.roomImages"
                    :key="`room-slide-${index}`"
                    @click="previewPlanImage(roomImg)"
                  />
                </div>
              </div>
              <div class="room-detail-right lg:hidden">
                <BasicCarousel
                  class="mb-4 lg:hidden"
                  :images="get(roomBasicInfo, 'roomImages', [])"
                  :isShowIndicator="false"
                  :numberThumbnail="5"
                  :isRoomImage="true"
                />
              </div>
            </div>
          </div>
          <div class="divider mb-2 mt-4 divider-custom" />
        </section>

        <!-- TODO: 次回フェーズで使用する可能性があるためコメントアウト -->
        <!-- ご利用方法 -->
        <!-- <section class="sm:hidden">
          <div class="room-detail-footer mt-4">
            <span class="flex items-center" id="intro">
              <i class="icon icon-bor-circle-question pr-2" />
              ご利用方法
            </span>
            <div class="flex gap-x-2">
              <div>
                <a
                  href="https://faq.benefit-one.co.jp/memberfaq/s/article/00373"
                  target="_blank"
                  class="mr-2"
                  >申込み手順</a
                >
                <a-divider type="vertical" />
              </div>
              <div>
                <a
                  href="https://faq.benefit-one.co.jp/memberfaq/s/article/00337"
                  target="_blank"
                  class="mr-2"
                  >受付開始時間になっても申込みができない場合</a
                >
                <a-divider type="vertical" />
              </div>
              <div>
                <a
                  href="https://faq.benefit-one.co.jp/memberfaq/s/article/00121"
                  target="_blank"
                  class="mr-2"
                  >受付開始日の確認方法</a
                >
                <a-divider type="vertical" />
              </div>
              <div>
                <a
                  href="https://faq.benefit-one.co.jp/memberfaq/s/article/00374"
                  target="_blank"
                  class="mr-2"
                  >提携プランを全て確認する方法</a
                >
              </div>
            </div>
          </div>
          <div class="divider mb-2 mt-4 divider-custom" />
        </section> -->

        <section class="mt-4 content__info">
          <div class="item-row">
            <div class="col-left">予約受付期間</div>
            <div class="col-right border-b-0">
              <span v-if="rsvReceptSttDtTxt">
                {{ rsvReceptSttDtTxt }}
              </span>
            </div>
          </div>
          <div class="item-row">
            <div class="col-left">予約受付締切日</div>
            <div class="col-right">
              <span>
                {{ rsvReceptEndDtTxt || '当日' }}
              </span>
            </div>
          </div>
          <div class="item-row">
            <div class="col-left">お支払い方法</div>
            <div class="col-right">
              <div>
                {{ paymentMethodLabel }}
              </div>
              <div v-if="paymentNote">
                ※{{ paymentNote }}
              </div>

            </div>
          </div>

          <div
            class="item-row"
            v-for="(ele, index) in cancelPolicy.cancelPolicies"
            :key="`cancel-policy-1-${index}`"
          >
            <div class="col-left" v-if="ele && ele.cancelTitle">
              {{ ele.cancelTitle }}
            </div>
            <div class="col-right" v-if="cancelPolicy && cancelPolicy.cancelPolicies">
              <div>
                <div v-if="ele && ele.cancelNote1">{{ ele.cancelNote1 }}</div>
                <div v-if="ele && ele.cancelNote2">{{ ele.cancelNote2 }}</div>
                <div v-show="checkCancelFlag">※キャンセル料金は利用料金の税抜金額に対して発生します</div>
                <div class="mini-table" v-if="Array.isArray(ele.cancelPolicyTable) && ele.cancelPolicyTable.length > 0">
                <div class="hidden sm:table-row t-row">
                    <span class="t-col font-bold w-1/2 t-row-header"> キャンセル日 </span>
                    <span class="t-col font-bold w-1/2 t-row-header"> 規定率 </span>
                  </div>
                  <div class="t-row"
                    v-for="(e, index) in ele.cancelPolicyTable"
                    :key="`cancel-policy-2-${index}`"
                  >
                    <span class="t-col font-bold"> {{ e.cancelRule }} </span>
                    <span class="t-col"> {{ e.cancelCond }} </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="item-row" v-if="childPriceInfo.childInfos.length >= 1">
            <div class="col-left">子ども料金の目安について</div>
            <div class="col-right border-b-0">
              <!-- SP screen to match XD -->
              <!-- <div
                class="right-child-table"
                v-for="(ele, index) in childPriceInfo.childInfos"
                :key="`child-info-${index}`"
              >
                <div class="left">{{ ele.childDivLabel }}</div>
                <div class="content">{{ ele.content }}</div>
                <div class="right">大人料金の{{ ele.priceReference }}</div>
              </div> -->
              <div class="mini-table">
                <div
                class="t-row content__element"
                v-for="(ele, index) in childPriceInfo.childInfos"
                :key="`child-info-${index}`"
              >
                <div class="t-col w-1/4">{{ ele.childDivLabel }}</div>
                <div class="t-col w-1/4">大人料金の {{ ele.priceReference }}</div>
              </div>
              </div>
              <!-- END - SP screen to match XD -->
              <div class="flex justify-end">
                <a @click="openChildrenNotification">
                  <span class="text-black">お子様連れの方へ</span>
                  <i class="icon icon-bor-arrow-right text-xs pl-2" />
                </a>
              </div>
            </div>
          </div>
          <div
            class="item-row"
            v-for="(item, index) in getStayTaxInfo"
            :key="`stay-tax-info-${index}`"
          >
            <div class="col-left">{{ item.title }}</div>
            <div class="col-right border-b-0">
              <div>
                <div>
                  <p class="whitespace-pre-wrap" v-html="item.content" />
                </div>
                <div class="flex justify-end">
                  <a
                    @click="openTaxLink"
                    target="_blank"
                  >
                    <span class="text-black">{{
                      item.linkNm ? item.linkNm : item.linkUrl
                    }}</span>
                    <i
                      v-if="item.linkNm"
                      class="icon icon-bor-arrow-right text-xs pl-2"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="item-row"
            v-if="
             !!planDetail && !!planDetail.vacancyCalendar && !!planDetail.vacancyCalendar.priceRemarks
            "
          >
            <div class="col-left">料金特記事項</div>
            <div class="col-right">{{ planDetail.vacancyCalendar.priceRemarks }}</div>
          </div>
          <div class="row-last"></div>
        </section>

        <section v-if="planInfomation && Array.isArray(planInfomation)">
          <div class="accommodation-tax cancel-policy">
            <SectionContentTitle lineType="v-line" titleContent="インフォメーション " />
            <div
              class="main-description"
              v-for="(info, index) in planInfomation"
              :key="`info-${index}`"
            >
              <BoxView @open="openView($event, index)">
                <h3>
                  {{ info.title }}
                </h3>
                <p
                  class="mb-3 view-more"
                  :class="info.loadMore ? 'three-lines-ellipsis' : 'view-more-open'"
                  v-html="info.content.replaceAll('\n', '<br/>')"
                ></p>
                <p>
                  <a
                    :href="info.linkUrl"
                    target="_blank"
                    class="blue"
                    v-if="info && info.linkUrl && info.linkNm"
                    >{{ info.linkNm }}</a
                  >
                </p>
              </BoxView>
            </div>
          </div>
          <!-- Divider -->
          <div class="divider mb-4 mt-8 sm:my-1"></div>
        </section>

        <!-- bath tax -->
        <section
          class="pb-8"
          v-if="menuInformation && menuInformation.extSystemCd == 'RakutenT'"
        >
          <div class="accommodation-tax cancel-policy">
            <div>
              <SectionContentTitle lineType="v-line" titleContent="ご利用について" />
              ・料金は施設に直接お支払いください。<br />
              ・Bene楽天トラベルでは「クレジットカード決済」のみの宿泊プランを予約できません。あらかじめご了承ください。<br />
              ・Bene楽天トラベルでは楽天トラベルクーポンの使用は出来ません。<br />
              ・各提携先の予約センターや直接施設へご予約された場合、会員料金・ベネポなどの会員特典は適用されません。<br />
              ・予約開始日は、原則として宿泊日の3ヵ月前の同日からとなります。<br />
              (施設や宿泊プランにより異なる場合がございます。)<br />
              ・直前でのご予約はお受けできない場合がありますので、お早めにお申込みください。<br />
              ・1回の申込みに対し、最長6泊とさせていただきます。<br />
              (施設や宿泊プランにより異なる場合がございます。) <br />
            </div>
          </div>
        </section>

        <section
          class="pb-8"
          v-if="menuInformation && menuInformation.extSystemCd == 'RakutenT'"
        >
          <div class="accommodation-tax cancel-policy">
            <div>
              <SectionContentTitle lineType="v-line" titleContent="注意事項" />
              ・楽天ポイントは、予約時に認証された楽天ユーザーIDへ付与されます。（料金および補助金の額を除いた金額で産出されます。）なお、楽天ポイントやその他割引券（クーポン・補助券・サービス券など）はご利用になれません。<br />
              ・楽天ポイントは、チェックアウト日の翌日から起算して10日後までに付与されます。<br />
              ・ベネポは、チェックアウト日の翌日から起算して5日後に付与いたします。<br />
              ・予約手続き完了と共に宿泊プラン内容やその他明記される宿泊条件および「<a
                href="http://travel.rakuten.co.jp/info/agreement.html"
                >楽天トラベル利用規約</a
              >」「<a
                href="http://travel.rakuten.co.jp/info/yakkan/tehai.html"
                >旅行業約款 手配旅行の部</a
              >」「<a
                href="http://travel.rakuten.co.jp/info/condition/domestic.html"
                >旅行条件書</a
              >」に同意するものとします。<br />
              ・予約手続き完了後は、必ず予約完了メール/ご利用履歴にて予約の成立をご確認ください。<br />
              ・「Bene楽天トラベル」で表示される宿泊料金などは宿泊施設側で設定されています。なお、同じ宿泊プランでも予約日や宿泊日により料金が異なる場合があります。料金は変動制となりますが、「成立した時点での料金がお客様の制約料金として確定」されます。原則として、料金変動が伴う予約取り直しはお断りさせていただきます。<br />
              ・ホテル税・入湯税などの諸税、および特記事項（特別な事由で宿泊料金などに含まれない料金など）について、予約成立時の宿泊料金等とは別に、宿泊施設より請求される場合があります。<br />
              ・各種クレジットカードやデビットカードなどを現地宿泊施設の支払いに利用できない場合があります。<br />
              ・予約時に選択されたチェックイン時間を厳守してください。チェックイン時間を過ぎるとキャンセルされる場合があります。万一、遅れての到着になる場合は直接宿泊施設へ事前に連絡してご相談ください。<br />
              ・楽天トラベル宿泊予約センター・グループ予約専用ダイヤルのご利用はできません。会員特典が適用されませんので、ご注意ください。<br />
              ・日によって、食事設定の条件が異なる場合がございます。「宿泊予約申込み画面」にて再度ご確認ください。<br />
              ・プランによっては食事場所が、アイコンで表示されている食事場所とは違う場合がございますのでご注意ください。<br />
            </div>
          </div>
        </section>

        <div class="footer-detail pb-20 sm:pb-10">
          <a href="#planSelection" v-smooth-scroll="{ offset: -120 }">
          <button class="c-btn btn-black">
            <span class="mr-3">
              <i class="icon icon-bor-arrow-up-icon icon-xss"></i>
            </span>空室状況を確認する</button></a>
        </div>
      </div>
      <GalleryViewPopup
        :visible="showGallery"
        v-model="galleryData"
        @ok="showGallery = false"
        @close="showGallery = false"
      />

      <!-- Image Preview -->
      <Modal
        :visible="showPreviewImg"
        size="large"
        @cancel="showPreviewImg = false"
        @ok="showPreviewImg = false"
      >
        <div class="w-full" v-if="previewImage">
          <img :src="previewImage.imageUrl" class="image-preview" />
        </div>
      </Modal>
      <ConfirmDialog
        :visible="showPopUp"
        :confirmData="identificationNotice"
        @cancel="showPopUp = false"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable vue/no-unused-components */
import moment from 'moment'
import _ from 'lodash'
import isEqual from 'lodash/isEqual'
import pickBy from 'lodash/pickBy'
import { get, isEmpty, minBy } from 'lodash'
import plan_utils from '@/mixins/plan_utils'
import func_utils from '@/mixins/func_utils'
import {
  MenuNavigation,
  CarouselThumbnail,
  SectionContentTitle
} from '@/components/compound'
import BoxView from './components/BoxViewMore'
import BoxViewMore from '@/components/organisms/BoxViewMore'
import { Button, Tag, Calendar, Stepper, Modal } from '@/components/primitive'
import GalleryViewPopup from '../../menu/GalleryViewPopup'
import PeoplePlan from './components/PeoplePlan'
import ConfirmDialog from './components/ConfirmDialog'
import SubsidyDetail from './components/SubsidyDetail';
import SubsidyGroupDetail from './components/SubsidyGroupDetail';
import RakutenLogin from "@/components/RakutenLogin";
import {
  BASE_ON_PRICE,
  SAVE_CUSTOMER_PLAN,
  SAVE_PLAN_DETAIL
} from '@/store/modules/plan/actions'
import {
  SAVE_DATA_BS_APP_02_001,
  GET_MENU_STAY_PARAMS,
  GET_PROFILE,
} from '@/store/modules/bs_app/actions'
import { PLAN_BASE_ON_PRICE } from '@/constants/plan'
import { ROOM_INFO_PUBLIC_ATTRS, ROOM_INFO_LABEL } from '@/constants/room'
import { COUPON_PRICE_TYPE } from '@/constants/coupon'
import { createSetCookie , getCookieValue } from '@/utils/cookie'
const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')

const CHANGE_CONTROL = {
  ROOM: 'room',
  ADULT: 'adult'
}

const TOAST_OPTION = {
  duration: 30000
}
export default {
  name: 'PlanDetail',
  mixins: [plan_utils, func_utils],
  components: {
    RakutenLogin,
    Button,
    BoxViewMore,
    Calendar,
    CarouselThumbnail,
    MenuNavigation,
    Tag,
    Stepper,
    SectionContentTitle,
    GalleryViewPopup,
    Modal,
    PeoplePlan,
    ConfirmDialog,
    BoxView,
    SubsidyDetail,
    SubsidyGroupDetail
  },
  data() {
    return {
      showModalError: false,
      errorType: '',
      cookieApply: null,
      acptDtlNo: null,
      loading: false,
      expandCouponList: false,
      showPreviewImg: false,
      previewImage: [
        {
          imageUrl: '',
          imageExplanation: ''
        }
      ],
      dateFormat: 'YYYY/MM/DD',
      dateFormat2: 'YYYY-MM-DD',
      instockDayMap: {},
      fewLeftDayMap: {},
      outstockDayMap: {},
      planDetail: null,
      cancelPolicy: {},
      menuInformation: null,
      planBasicInfo: null,
      planIcons: null,
      roomIcons: null,
      planInfomation: null,
      planUsage: null,
      planUsageLimit: null,
      usageLimitInformation: null,
      roomBasicInfo: null,
      displayVacancyCalendar: null,
      vacancyCalendar: null,
      baseOnPrice: null,
      stayDay: moment(new Date()),
      stayNights: 1,
      stayRooms: 1,
      stayAdults: 1,
      memberAdults: 1,
      visitorAdults: 0,
      status: null,
      tmpVariables: {
        stayDay: null,
        stayNights: 1,
        stayRooms: 1,
        stayAdults: 1,
        memberAdults: 1,
        visitorAdults: 0,
        attachChildren: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        },
        memberChldDetails: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        },
        visitorChldDetails: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        }
      },
      changeControl: {
        init: true,
        key: null
      },
      planRcSttDt: null,
      maxStayCapacity: null,
      minStayCapacity: 1,
      attachChildren: {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      },
      memberChldDetails: {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      },
      visitorChldDetails: {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      },
      showGallery: false,
      galleryData: [],
      showAttachChildren: false,
      selectedDaysInfo: [],
      limitNights: 6,
      limitRooms: 10,
      limitPeoples: 10,
      maxSelectablePeople: null,
      maxSelectableRoom: null,
      maxSelectableNight: null,
      checkConditionBookRoom: true,
      childPriceInfo: {
        childInfos: []
      },
      subsidyList: [],
      subsidyCouponList: [],
      subsidyCouponGroupList: [],
      subsidyGroupList: [],
      peopleDetails: null,
      isLoginedRakuten: false,
      grantedBenepo: null,
      arrPriceMin: [],
      minRoomPrice: 0,
      isRanged: true,
      rangeMode: true,
      countMonthPrevAble: 0,
      countYearPrevAble: 0,
      applLimits: null,
      yearCrosses: false,
      payMthdInfo: null,
      identificationType: [
        {
          code: 1,
          message: 'メールアドレスが未登録です。<br>登録ページへ移動します。',
          confirmLink: `${process.env.VUE_APP_URL_SSO}/account/identification/MailAddressRegister`
        },
        {
          code: 2,
          message: '電話番号が未登録です。<br>登録ページへ移動します。',
          confirmLink: `${process.env.VUE_APP_URL_SSO}/account/identification/PhoneNumberRegister`
        },
        {
          code: 3,
          message: '電話番号とメールアドレスが未登録です。<br>登録ページに遷移します。',
          confirmLink: `${process.env.VUE_APP_URL_SSO}/account/portal/LoginSecuritySettings`
        },
        // CRM汎用独自対応
        {
          code: 4,
          message: '氏名が未登録です。<br>登録ページへ移動します。',
          confirmLink: `${process.env.VUE_APP_URL_SSO}/account/profiles/info`
        },
        {
          code: 5,
          message: '氏名と電話番号が未登録です。<br>登録ページへ移動します。',
          confirmLink: `${process.env.VUE_APP_URL_SSO}/account/portal/AccountManagementPortal`
        },
        {
          code: 6,
          message: '氏名とメールアドレスが未登録です。<br>登録ページに遷移します。',
          confirmLink: `${process.env.VUE_APP_URL_SSO}/account/portal/AccountManagementPortal`
        },
        {
          code: 7,
          message: '氏名と電話番号とメールアドレスが未登録です。<br>登録ページに遷移します。',
          confirmLink: `${process.env.VUE_APP_URL_SSO}/account/portal/AccountManagementPortal`
        }
      ],
      identificationNotice: {},
      showPopUp: false,
      familySerialNumber: 0,
      bodyEmail: {},
      equipServiceBathTax: null,
      equipServiceBathTaxNm: null,
      menuNo: null,
      roomId: null,
      openViewMore: false,
      reserveId: null,
      endDtPlan: null,
      sttDtPlan: null,
      applFlag: '1',
      skipWatchStayDay: false,
      isConfirm: false,
      isUnspecifiedCheckInDate: true,
      useCustomerPlan: false,
    }
  },
  beforeRouteEnter(to, from, next) {
    const registerPath = ["/register-rooms", "/register-confirmation"]
    next(vm =>{
      if(registerPath.includes(from?.path)){
        vm.useCustomerPlan = true
      }else{
        vm.useCustomerPlan = false
      }
      console.log("from_path", from?.path)
      console.log("vm customerPlan", vm.useCustomerPlan)
    })
  },
  beforeCreate() {
    if (this.$route.query.fromR !== '1') {
      return;
    }

    const callBackUrl = sessionStorage.getItem('rakutenLoginCallBackUrl');
    if (!callBackUrl) {
      return;
    }
    //sessionStorageからrakutenLoginCallBackUrlを削除
    sessionStorage.removeItem('rakutenLoginCallBackUrl');

    const url = new URL(callBackUrl, window.location.origin);
    const params = new URLSearchParams(url.search);
    // fromRが削除
    params.delete('fromR');
    const newSearch = params.toString();
    url.search = newSearch ? `?${newSearch}` : '';
    const redirectUrl = url.toString();
    // fromR を削除した後、リダイレクトする
    if(redirectUrl){
      window.location.href = redirectUrl;
    }
  },
  async created() {
    const bsjsessionid = getCookieValue(process.env.VUE_APP_SSO_COOKIE_NAME);
    this.status = bsjsessionid?.slice(0, 2);
    this.changeControl.init = true

    let query = this.$route.query;
    let checkInDate = _.get(query, 'checkInDate');

    // checkInDateが日付型で存在すればチェック開始
    if(checkInDate && moment(checkInDate,this.dateFormat2).isValid()) {
      // #52096 日付指定がない場合は、注記文言を非表示とする
      this.isUnspecifiedCheckInDate = false;

      const checkInMoment = moment(checkInDate, this.dateFormat2).startOf('day'); // チェックイン日付
      const todayMoment = moment().startOf('day'); // 今日の日付

      // checkInDateが過去日の場合、在庫チェックせずに売り切れ画面
      if (checkInMoment.isBefore(todayMoment)) {
        this.errorType = 'outOfStock'
        this.showModalError = true
        return;
      }

      const isStock = await this.isStockOnCheckInDay(query);

      // 在庫がない場合売り切れ画面へ遷移
      if(!isStock) {
        this.errorType = 'outOfStock'
        this.showModalError = true
        return;
      }
    }

    this.loadInitData()
    this.$loading.show()
    this.getPlanDetail(async (planResult) => {
      if (!planResult || (planResult.status && planResult.status !== 200)) {
        this.$loading.hide()
        this.$page.errorHandler(planResult, { navigate: true })
        return
      }

      // CHECK IS RAKUTEN
      if (get(planResult, 'menuInformation.extSystemCd') === 'RakutenT') {
        // check login rakuten
        this.$repositories('login')
          .checkLoginRakuten()
          .then((response) => {
            this.isLoginedRakuten = Boolean(get(response, 'data.login'))
          })
      }

      // 総人数が19人を超える場合は申し込み不可
      const peopleDetails = this.peopleDetails;
      const totalPeopleCount =
        (peopleDetails?.memberAdults || 0) +
        (peopleDetails?.visitorAdults || 0) +
        (peopleDetails?.memberChldDetails?.childrenType10 || 0) +
        (peopleDetails?.memberChldDetails?.childrenType15 || 0) +
        (peopleDetails?.memberChldDetails?.childrenType20 || 0) +
        (peopleDetails?.memberChldDetails?.childrenType30 || 0) +
        (peopleDetails?.memberChldDetails?.childrenType40 || 0) +
        (peopleDetails?.memberChldDetails?.childrenType50 || 0);
      if (totalPeopleCount > 19) {
        this.errorType = 'appliy'
        this.showModalError = true
        return;
      }

      // 連泊
      // stayLimitMin, stayLimitMaxがnullかundefinedの場合はデフォルトの値を設定
      const stayLimitMin = planResult.planUsage.usageDetailStay.stayLimitMin ?? "1";
      const stayLimitMax = this.checkStayLimitMax(planResult.planUsage.usageDetailStay.stayLimitMax);

      if ((Number(this.tmpVariables.stayNights) < Number(stayLimitMin)) || (Number(this.tmpVariables.stayNights) > Number(stayLimitMax))) {
        this.errorType = 'appliy'
        this.showModalError = true
        return;
      }
      await this.getVacancy(planResult)
    })
  },
  mounted() {
    // チェックイン、アウト日付をクエリパラメータから取得
    const query = this.$route.query
    const checkInDate = _.get(query, 'checkInDate')
    const checkOutDate = _.get(query, 'checkOutDate')
    const stayNights = _.get(query, 'stayNights')

    // 日付型チェック・チェックアウト日付存在チェック
    if (moment(checkInDate).isValid()) {
      this.tmpVariables.stayDay = moment( checkInDate );
      if ( checkOutDate && moment(checkOutDate).isValid()) {
      // チェックインからチェックアウトまでの差分取得
      const dateDiff = moment(checkOutDate).diff(moment(checkInDate), 'day');
      // 差分日付を宿泊日にセット
      this.tmpVariables.stayNights = dateDiff || 1;
      }
    } else {
      // checkOutDateの値がない場合に、負の値になるのを回避する
      this.tmpVariables.stayNights = _.get(query, 'stayNights') || 1;
    }
    const menuNo = this.$route.params.menuNo
    this.roomId = this.$route.params.roomId
    this.menuNo = menuNo
    this.$repositories('plan')
      .getServiceDetail(menuNo)
      .then(
        (response) => {
          const equipServDetail2 = _.get(
            response[0],
            'equipServDetail1[0].equipServDetail2',
            null
          )
          const equipServiceBath1 = equipServDetail2?.filter((item) => {
            return item.equipServCd2 === 'A100000107'
          })
          const equipServiceBath2 = equipServDetail2?.filter((item) => {
            return item.equipServCd2 === 'A100000108'
          })
          this.equipServiceBathTax = _.get(equipServiceBath1[0], 'equipServValue2', null)
          if (this.equipServiceBathTax) {
            this.equipServiceBathTax = parseInt(this.equipServiceBathTax)
          }
          this.equipServiceBathTaxNm = _.get(
            equipServiceBath2[0],
            'equipServValue2',
            null
          )
        },
        (error) => {}
      )
  },
  watch: {
    calculateMemberAmount(val) {
        if ((this.rangeMode && this.isRanged) || !this.rangeMode) {
          this.getGrantedBenepoStay(val);
        }
    },
    isRanged(val) {
      if (this.rangeMode && val) {
        this.getGrantedBenepoStay(this.calculateMemberAmount)
      }
    },
    stayDay(val, old) {
      const currentMonth = moment(val).month()
      const currentDate = moment(val).date()
      if (currentMonth === 2 && currentDate + this.stayNights > 31) {
        this.yearCrosses = true
      } else {
        this.yearCrosses = false
      }
      // GET ROOM PRICE FOR SELECTED MONTH
      if (val && !val.isSame(old, 'month')) {
        if(this.skipWatchStayDay) this.skipWatchStayDay =false;
        else {
          this.$nextTick(() => {
          this.displayVacancyCalendar = null
          this.getVacancyCalendar()
          this.getStayParam()
        })
        }
      }

      this.getPriceMin()
    },
    errorType: {
      immediate: true,
      handler(error) {
        // 在庫切れエラー画面からは検索条件画面に遷移可能なため、遷移時にプラン詳細画面の条件が復旧されるよう修正
        if(error === 'outOfStock'){
          this.$router['referrer'] = this.$route;
        }
      }
    },
  },
  computed: {
    domainTop() {
      return process.env.VUE_APP_TOP_DOMAIN;
    },
    isUnavaibleCheckInDate(){
      const query = this.$route.query
      let checkInDate = _.get(query, 'checkInDate');
      if(!checkInDate) return true;
      checkInDate= checkInDate.replaceAll('-','/')
      const stayDay =  moment(this.tmpVariables.stayDay).format(this.dateFormat)
      return ((!this.instockDayMap[checkInDate] || !this.instockDayMap[stayDay]) && this.getReservationDiv() != "20")
    },
    isPlanDetailView() {
      const { menuNo, planId, roomId } = this.$route.params
      return (
        menuNo &&
        planId &&
        roomId &&
        this.$route.path === `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`
      )
    },
    copyLabel() {
      let label = ''
      let menuNm = this.menuInformation?.menuNm
      if (this.isPlanDetailView) {
        const planDetail = this.$store.getters.planDetail
        label = planDetail?.planBasicInfo?.planNm
      }
      return [menuNm, label].filter(Boolean).join('\n')
    },
    checkRakuten() {
      return !this.isRakuten || (this.isRakuten && !this.isLoginedRakuten)
    },
    isStayTaxInfo() {
      return (
        this.planDetail &&
        this.planDetail.vacancyCalendar &&
        get(this.planDetail, 'vacancyCalendar.stayTaxInfo')
      )
    },
    isJapaneseStyleRoom() {
      return this.roomBasicInfo && this.roomBasicInfo.roomCondNm === '和室'
    },
    loggedIn() {
      // return true
      return this.$auth.loggedIn
    },
    loggedRakuten() {
      return this.$auth.loggedRakuten
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    profileMe() {
      return this.$store.getters['auth/get'].profileMe
    },
    isRakuten() {
      return get(this.menuInformation, 'extSystemCd') == 'RakutenT'
    },
    // baseOnPrice() {
    //   return this.$store.getters.baseOnPrice
    // },
    checkPriceRoom () {
      return this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM
    },
    nightOptions() {
      const nights = []
      const stayLimitMin = _.get(this.planUsage, 'usageDetailStay.stayLimitMin', null)
      for (let i = Number(stayLimitMin) - 1; i < this.limitNights; i++) {
        if(i+1 > 0){
          nights.push({
          label: i + 1,
          value: i + 1
        })
        }
      }
      return nights
    },
    roomOptions() {
      const rooms = []
      for (let i = 0; i < this.limitRooms; i++) {
        rooms.push({
          label: i + 1,
          value: i + 1
        })
      }
      return rooms
    },
    peopleOptions() {
      const peoples = []

      const maxAdultPeople = this.maxStayCapacity * this.limitRooms
      for (let i = 0; i < maxAdultPeople; i++) {
        peoples.push({
          label: i + 1,
          value: i + 1
        })
      }
      return peoples
    },
    getCustomerPlan() {
      return this.$store.getters.customerPlan
    },
    countPeople() {
      let count = +this.stayAdults
      Object.keys(this.attachChildren).forEach((key) => {
        if (!['childrenType30', 'childrenType50'].includes(key)) {
          count += +this.attachChildren[key]
        }
      })
      return count
    },
    maxSlotRemaining() {
      let remainSlots = this.maxStayCapacity * this.stayRooms
      remainSlots -= this.stayAdults
      Object.keys(this.attachChildren).forEach((key) => {
        if (!['childrenType30', 'childrenType50'].includes(key)) {
          remainSlots -= this.attachChildren[key]
        }
      })
      return remainSlots
    },
    minDatePicker() {
      return moment(new Date())
    },
    getDisplaySelectedDays() {
      if (this.tmpVariables.stayDay) {
        const stayDay = moment.isMoment(this.tmpVariables.stayDay) ? this.tmpVariables.stayDay.format(this.dateFormat) : moment(this.tmpVariables.stayDay).format(this.dateFormat);
        const selectedDays = [stayDay]
        for (let i = 1; i <= this.tmpVariables.stayNights; i++) {
          selectedDays.push(moment(stayDay).add(i, 'days').format(this.dateFormat))
        }
        return selectedDays
      }
      return []
    },
    getSelectedDays() {
      if (this.stayDay) {
        const stayDay = this.stayDay.format(this.dateFormat)
        const selectedDays = [stayDay]
        for (let i = 1; i <= this.stayNights; i++) {
          selectedDays.push(moment(stayDay).add(i, 'days').format(this.dateFormat))
        }
        return selectedDays
      }
      return []
    },
    filterOpenDays() {
      return this.getOpenDays()
    },
    filterFewLeftDays() {
      return this.getFewDays()
    },
    filterCloseDays() {
      this.outstockDayMap = {}
      const lastDay = this.getDataMoment(this.stayDay).endOf('month').date()
      const lastDayNextMonth = this.getDataMoment(this.stayDay).add(1, 'month').endOf('month').date()
      const vacancyCalendars =
        this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
          ? this.displayVacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars
        .filter((e) => e.stock && e.stock >= this.stayRooms)
        .map((e) => e.stayDay)
      const closeDays = []
      const firstDayCurMonth = this.getDataMoment(this.stayDay).startOf('month')
      for (let i = 0; i < lastDay + lastDayNextMonth; i++) {
        const day = firstDayCurMonth.clone().add(i, 'days').format(this.dateFormat)
        if (!inStockDays.includes(day)) {
          this.outstockDayMap[day] = true
          closeDays.push(day)
        }
      }
      return closeDays
    },
    enableNextMonth() {
      if (
        moment(this.tmpVariables.stayDay)
          .add(this.tmpVariables.stayNights - 1, 'days')
          .isAfter(this.tmpVariables.stayDay, 'month')
      ) {
        return true
      }
      return false
    },
    getPricePlan() {
      const currentDay = moment(this.stayDay).format(this.dateFormat)
      const listVacancy = get(this.planDetail, 'vacancyCalendar.vacancyCalendars')
      if (isEmpty(listVacancy)) return 0
      else {
        const currentCalendar = listVacancy?.find(
          (calendar) => calendar.stayDay === currentDay
        )
        if (!isEmpty(currentCalendar)) {
          let curentPrice = currentCalendar?.roomPrice ?? currentCalendar?.price
          return curentPrice || 0
        } else {
          const min = minBy(listVacancy, 'price')
          return min?.price || 0
        }
      }
    },
    todayPrice() {
      // SHOW LOWEST PRICE IN SELECTED RANGE
      const stayDay = moment(this.stayDay)
      const selectedDates = []
      for (let i = 0; i < this.stayNights; i++) {
        selectedDates.push(moment(stayDay).add(i, 'days').format(this.dateFormat))
      }
      const vacancyCalendars =
        this.vacancyCalendar && Array.isArray(this.vacancyCalendar.vacancyCalendars)
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const childPriceInfo =
        this.vacancyCalendar &&
        this.vacancyCalendar.childPriceInfo &&
        this.vacancyCalendar.childPriceInfo.childInfos
          ? this.vacancyCalendar.childPriceInfo.childInfos
          : []

      let vacancyTodays = []
      if (!this.tmpVariables.stayDay) {
        vacancyTodays = vacancyCalendars
      } else {
        vacancyTodays = vacancyCalendars.filter((v) =>
          selectedDates.includes(v.stayDay)
        )
        if (!vacancyTodays || !vacancyTodays.length) {
          return 0 || this.getPricePlan
        }
      }

      if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
        let count = this.tmpVariables.stayAdults
        let result = 0

        childPriceInfo.map((info) => {
          if (info.calc == '1') {
            if (info.childDiv == 10) {
              count += this.tmpVariables.memberChldDetails.childrenType10
            } else if (info.childDiv == 15) {
              count += this.tmpVariables.memberChldDetails.childrenType15
            } else if (info.childDiv == 20) {
              count += this.tmpVariables.memberChldDetails.childrenType20
            } else if (info.childDiv == 30) {
              count += this.tmpVariables.memberChldDetails.childrenType30
            } else if (info.childDiv == 40) {
              count += this.tmpVariables.memberChldDetails.childrenType40
            } else if (info.childDiv == 50) {
              count += this.tmpVariables.memberChldDetails.childrenType50
            }
          }
        })
        result = this.calculateMemberAmount
        count = count * this.stayRooms
        return Math.round(result / count) || this.getPricePlan
      }

      return Math.min(...vacancyTodays.map((v) => v.price || 0)) || this.getPricePlan
    },
    roomImagePreview() {
      const roomImage = _.get(this.roomBasicInfo, 'roomImages[0]', null)
      if (roomImage) {
        return roomImage
      }
      return {
        imageUrl: PLACEHOLDER_IMG
      }
    },
    smokingDiv() {
      const smokingDiv = _.get(this.roomBasicInfo, 'smokingDiv', null)
      if (smokingDiv === this.CONST_DATA.SMOKING_DIV.NO_SMOKING) {
        return '禁煙'
      }
      if (smokingDiv === this.CONST_DATA.SMOKING_DIV.SMOKING) {
        return '喫煙'
      }
      if (smokingDiv === this.CONST_DATA.SMOKING_DIV.LEAVE) {
        return 'おまかせ'
      }
      return null
    },

    planImagePreview() {
      const planImage = _.get(this.planBasicInfo, 'planImages[0].imageUrl', null)
      if (planImage) {
        return planImage
      }
      return PLACEHOLDER_IMG
    },
    roomEatServiceDesc() {
      const breakfastFlag = +_.get(this.planUsage, 'usageDetailStay.breakfastFlag', 0)
      const dinnerFlag = +_.get(this.planUsage, 'usageDetailStay.dinnerFlag', 0)
      if (breakfastFlag && dinnerFlag) {
        return '朝食・夕食つき'
      } else if (breakfastFlag) {
        return '朝食のみ'
      } else if (dinnerFlag) {
        return 'ディナーのみ'
      }
      return '食事なし'
    },

    //ベネポ付与率表示の処理？　要素を削除したのでjsも削除しても良い？
    roomGrantedBenepoReturn() {
      const benepoReturnDiv1 = this.planDetail?.benepoReturnInfo?.benepoReturnDiv1
      const benepoReturnDiv2 = this.planDetail?.benepoReturnInfo?.benepoReturnDiv2
      if (benepoReturnDiv1 == '10' && benepoReturnDiv2 == '10') {
        const rate1 = this.planDetail?.benepoReturnInfo?.benepoReturnRate1
        const rate2 = this.planDetail?.benepoReturnInfo?.benepoReturnRate2
        return rate1 && rate2
          ? `ベネポ${Number(rate2)}%付与（１名１室利用：${Number(rate1)}％）`
          : null
      } else if (benepoReturnDiv1 == '20' && benepoReturnDiv2 == '20') {
        const fixed1 = this.planDetail?.benepoReturnInfo?.benepoReturnFixed1
        const fixed2 = this.planDetail?.benepoReturnInfo?.benepoReturnFixed2
        return fixed1 && fixed2
          ? `ベネポ${Number(fixed2)}ポイント付与（１名１室利用：${Number(
              fixed1
            )}ポイント）`
          : null
      } else return null
    },
    getUsageDetails() {
      const planIcons = _.get(this.planDetail, 'planIcons', [])
      const extSystemCd = _.get(this.menuInformation, 'extSystemCd', null)
      const PAYMENT_ICONS = {
        '20': 'オンラインカード決済',
        '30': 'オンラインカード決済可'
      };

      if (extSystemCd !== 'RakutenT') {
        const paymentType = _.get(this.payMthdInfo, 'payeeDiv', null);
        if (paymentType && paymentType in PAYMENT_ICONS) {
          // 既存のアイコンに同じ名前のものがないかチェック
          const paymentIconExists = planIcons.some(icon =>
            icon.iconNm === PAYMENT_ICONS[paymentType]
          );

          // 存在しない場合のみ追加
          if (!paymentIconExists) {
            planIcons.push({
              iconCD: 'online_payment',
              iconNm: PAYMENT_ICONS[paymentType]
            });
          }
        }
      }

      if (!planIcons || !planIcons.length) return []

      const activeFlags = []
      for (const icon of planIcons) {
        if (!icon) continue;

        // アイコンの重複チェック
        const iconNm  = icon.iconNm
        if ( activeFlags.findIndex(i => i.value === iconNm) == -1){
          // 重複していない場合、activeFlags に追加
          activeFlags.push({ label: iconNm, value: iconNm })
        }
      }

      return activeFlags
    },
    getRoomBasicInfoList() {
      const roomBasicInfo = this.roomBasicInfo ? this.roomBasicInfo : {}
      Object.keys(roomBasicInfo)
        .filter(
          (key) =>
            ROOM_INFO_PUBLIC_ATTRS[key] !== undefined &&
            ROOM_INFO_PUBLIC_ATTRS[key] !== null
        )
        .map((key) => {
          return {
            label: ROOM_INFO_LABEL[key],
            value: roomBasicInfo[key],
            attr: key
          }
        })

      return []
    },
    countTotalChildren() {
      return (
        this.attachChildren.childrenType10 +
        this.attachChildren.childrenType15 +
        this.attachChildren.childrenType20 +
        this.attachChildren.childrenType30 +
        this.attachChildren.childrenType40 +
        this.attachChildren.childrenType50
      )
    },
    calculateTotalAmount() {
      const selectedDays = _.cloneDeep(this.getSelectedDays)
      selectedDays.splice(-1)
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      let netAmount = 0
      selectedDays.forEach((day) => {
        vacancyCalendars.forEach((vacancy) => {
          if (moment(day).isSame(moment(vacancy.stayDay), 'day')) {
            if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
              netAmount += this.stayRooms * vacancy.roomPrice
            } else {
              const memberPrice = vacancy.price ? vacancy.price : 0
              const visitorPrice = vacancy.adultPrice ? vacancy.adultPrice : 0
              netAmount +=
                (this.memberAdults * memberPrice + this.visitorAdults * visitorPrice) *
                this.stayRooms
              Object.keys(this.memberChldDetails).forEach((key) => {
                if (this.memberChldDetails[key]) {
                  netAmount +=
                    this.memberChldDetails[key] *
                    this.getMemberChildPrice(key, vacancy.childrenPriceTable) *
                    this.stayRooms
                }
              })

              Object.keys(this.visitorChldDetails).forEach((key) => {
                if (this.visitorChldDetails[key]) {
                  netAmount +=
                    this.visitorChldDetails[key] *
                    this.getVisitorChildPrice(key, vacancy.childrenPriceTable) *
                    this.stayRooms
                }
              })
            }
          }
        })
      })
      return netAmount
    },
    calculateMemberAmount() {
      let netAmount = 0
      let vacancyCalendars = this.vacancyCalendar?.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      if (!this.tmpVariables?.stayDay) {
        // 日付未指定の場合
        vacancyCalendars = vacancyCalendars.filter((e) => e.stock && e.stock >= this.stayRooms)
        vacancyCalendars = minBy(vacancyCalendars, 'price')
        if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
          const roomPrice = vacancyCalendars?.price ? vacancyCalendars.price : 0
          netAmount += this.stayRooms * roomPrice
        } else {
          const memberPrice = vacancyCalendars?.price ? vacancyCalendars.price : 0
          netAmount += this.memberAdults * memberPrice * this.stayRooms
          Object.keys(this.memberChldDetails).forEach((key) => {
            if (this.memberChldDetails[key]) {
              netAmount +=
                this.memberChldDetails[key] *
                this.getMemberChildPrice(key, vacancyCalendars?.childrenPriceTable) *
                this.stayRooms
            }
          })
        }
      } else {
        const selectedDays = _.cloneDeep(this.getSelectedDays)
        selectedDays.splice(-1)
        selectedDays.forEach((day) => {
          vacancyCalendars
            .filter((e) => e.stock && e.stock >= this.stayRooms)
            .forEach((vacancy) => {
              if (moment(day).isSame(moment(vacancy.stayDay), 'day')) {
                if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
                  const roomPrice = vacancy.price ? vacancy.price : 0
                  netAmount += this.stayRooms * roomPrice
                } else {
                  const memberPrice = vacancy.price ? vacancy.price : 0
                  netAmount += this.memberAdults * memberPrice * this.stayRooms
                  Object.keys(this.memberChldDetails).forEach((key) => {
                    if (this.memberChldDetails[key]) {
                      netAmount +=
                        this.memberChldDetails[key] *
                        this.getMemberChildPrice(key, vacancy.childrenPriceTable) *
                        this.stayRooms
                    }
                  })
                }
              }
            })
        })
      }
      return netAmount ? Math.round(netAmount) : netAmount
    },
    computeVisitorAmount() {
      let netAmount = 0
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      if (!this.tmpVariables.stayDay) {
        // 日付未指定の場合
        vacancyCalendars = vacancyCalendars.filter((e) => e.stock && e.stock >= this.stayRooms)
        vacancyCalendars = minBy(vacancyCalendars, 'adultPrice')
        if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
          const roomPrice = vacancyCalendars?.roomPrice ? vacancyCalendars.roomPrice : 0
          netAmount += this.stayRooms * roomPrice
        } else {
          const visitorPrice = vacancyCalendars?.adultPrice ? vacancyCalendars.adultPrice : 0
          netAmount += this.memberAdults * visitorPrice * this.stayRooms
          Object.keys(this.memberChldDetails).forEach((key) => {
            if (this.memberChldDetails[key]) {
              netAmount +=
                this.memberChldDetails[key] *
                this.getMemberChildPrice(key, vacancy.childrenPriceTable) *
                this.stayRooms
            }
          })
        }
      } else {
        const selectedDays = _.cloneDeep(this.getSelectedDays)
        selectedDays.splice(-1)
        selectedDays.forEach((day) => {
          vacancyCalendars.forEach((vacancy) => {
            if (moment(day).isSame(moment(vacancy.stayDay), 'day')) {
              if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
                const roomPrice = vacancy.roomPrice ? vacancy.roomPrice : 0
                netAmount += this.stayRooms * roomPrice
              } else {
                const visitorPrice = vacancy.adultPrice ? vacancy.adultPrice : 0
                netAmount += this.memberAdults * visitorPrice * this.stayRooms
                Object.keys(this.memberChldDetails).forEach((key) => {
                  if (this.memberChldDetails[key]) {
                    netAmount +=
                      this.memberChldDetails[key] *
                      this.getVisitorChildPrice(key, vacancy.childrenPriceTable) *
                      this.stayRooms
                  }
                })
              }
            }
          })
        })
      }
      return netAmount ? Math.round(netAmount) : netAmount
    },
    calendarDisabledPrev() {
      const now = moment(new Date())
      return this.stayDay.isSameOrBefore(now, 'month')
    },
    // planIconLabel() {
    //   return (this.planIcons || []).map(i => i.iconNm).join('／')
    // },
    planIconHighlight() {
      return _.get(this.planIcons, '[0].iconSuppl', null)
    },
    rsvReceptSttDtTxt() {
      let rsvReceptSttDtTxt = _.get(
        this.planUsage,
        'usageDetailStay.rsvReceptSttDtTxt',
        null
      )

      return rsvReceptSttDtTxt
    },
    rsvReceptEndDtTxt() {
      let rsvReceptEndDtTxt = _.get(
        this.planUsage,
        'usageDetailStay.rsvReceptEndDtTxt',
        null
      )
      return rsvReceptEndDtTxt
    },
    paymentMethodLabel() {
      const payeeDiv = _.get(this.payMthdInfo, 'payeeDiv');
      let label = ''
      switch (payeeDiv) {
        case '10':
          label = '現地でお支払い'
          break
        case '20':
          label = '予約時クレジットカード決済'
          break
        case '30':
          label = '現地でお支払いまたは予約時クレジットカード決済'
          break
        case '40':
          label = '支払なし'
          break
        default:
          break
      }
      return label
    },
    paymentNote(){
      return _.get(this.payMthdInfo, 'payeeNote');
    },
    getStayTaxInfo() {
      const stayTaxInfo = get(this.planDetail, 'vacancyCalendar.stayTaxInfo') || []
      return _.cloneDeep(stayTaxInfo).sort((a, b) =>
        a.title == '入湯税について' ? 1 : -1
      )
    },
    checkCancelFlag(){
      if(this.cancelPolicy?.canclTaxExcChrgFlag == 1) return true;
      return false;
    },
    isSelectedOutStockDay() {
      let isSelected = true
      for (let i = 0; i < this.stayNights; i++) {
        const checkDay = this.getDataMoment(this.stayDay).add(i, 'days')
        const checkingDate = checkDay.format(this.dateFormat)
        if (!this.isFilterClosedDays(checkingDate)) {
          isSelected = false
        }
      }
      return isSelected
    },
    isTargetGrantedBenepo() {
      return this.calculateMemberAmount && this.grantedBenepo != null
    },
    totalPerson(){
      let count = this.tmpVariables?.stayAdults || 0;
      const childPriceInfo = this.vacancyCalendar?.childPriceInfo?.childInfos ?? [];
        childPriceInfo.map((info) => {
          if (info.calc == '1') {
            if (info.childDiv == 10) {
              count += this.tmpVariables.memberChldDetails.childrenType10
            } else if (info.childDiv == 15) {
              count += this.tmpVariables.memberChldDetails.childrenType15
            } else if (info.childDiv == 20) {
              count += this.tmpVariables.memberChldDetails.childrenType20
            } else if (info.childDiv == 30) {
              count += this.tmpVariables.memberChldDetails.childrenType30
            } else if (info.childDiv == 40) {
              count += this.tmpVariables.memberChldDetails.childrenType40
            } else if (info.childDiv == 50) {
              count += this.tmpVariables.memberChldDetails.childrenType50
            }
          }
        });
      return count
    },
    totalPeopleCnt() {
      // #71362 大人1人×子ども1名かつ、ベネポ付与種別：一律のパターンで表示・付与に誤りがあるため
      // 正しい人数算出処理になるよう src\views\BS_APP_02_001\index.vue をもとに実装
      const totalAdultPeople = this.tmpVariables?.stayAdults || 0;
      const totalChildren = Object.keys(this.tmpVariables.memberChldDetails)
        .map((key) => this.tmpVariables.memberChldDetails[key])
        .reduce((a, b) => a + b, 0);
      return totalAdultPeople + totalChildren;
    },
    availableSubsidy() {
      return this.subsidyList && this.subsidyList.length && this.loggedIn;
    }
  },
  methods: {
    get,
    setConfirm(value) {
      this.isConfirm = value
    },
    isShowParsonalUsedMaxCnt(subsidy) {
      return (
        subsidy.availableData.parsonalUsedMaxCnt > 0 &&
        subsidy.availableData.parsonalUsedMaxTotalAmt > 0
      )
    },
    openTaxLink(){
      let params = document.documentElement.lang === 'en' ?  'about_tax_en' : 'travel_about_tax_jp'
       window.open(
        `${this.domainTop}/otherPage?other_id=${params}`
      )
    },
    isShowUsedMaxCntInsurance01(subsidy) {
      return _.get(subsidy, 'availableData.parsonalUsedMaxCnt')
    },
    isShowUsedMaxTotalAmt(subsidy) {
      return _.get(subsidy, 'availableData.parsonalUsedMaxTotalAmt', null)
    },
    isShowRemainingAmtCntLabelInsur(subsidy) {
      return (
        _.get(subsidy, 'scrennDisplayItemList.remainingCountLabel') &&
        _.get(subsidy, 'scrennDisplayItemList.remainingAmountLabel')
      )
    },
    getRequestTypeCoupon(coupon) {
      return _.get(coupon, 'availableData.requestType')
    },
    async getVacancy(planResult) {
      this.mountData(planResult)
      const vacancyResult = await this.getVacancyCalendar({ onInit: true, loading: true })
      this.$loading.hide()
      if (vacancyResult?.status || !vacancyResult?.vacancyCalendars || vacancyResult?.vacancyCalendars?.length == 0) {
        this.errorType = 'appliy'
        this.showModalError = true
        return
      }
    },
    getDttPlan() {
      const startDate = _.get(this.planDetail, 'planBasicInfo.planRcSttDt', null)
      const endDate = _.get(this.planDetail, 'planBasicInfo.planRcEndDt', null)
      if (moment(startDate).isValid()) {
        this.sttDtPlan = moment(startDate).format('YYYY/MM/DD')
      }
      if (moment(endDate).isValid()) {
        this.endDtPlan = moment(endDate).format('YYYY/MM/DD')
      }
    },
    openView($event, index) {
      const planInfomation = _.cloneDeep(this.planInfomation)
      planInfomation.map((item, i) => {
        if (i === index && Boolean($event)) {
          item.loadMore = false
        } else if (i === index && !Boolean($event)) {
          item.loadMore = true
        }
        return item
      })
      this.planInfomation = planInfomation
    },
    getBodyEmail() {
      this.bodyEmail = {
        memberName: _.get(this.$store, 'getters.bs_app.info_user.username', ''),
        menuNo: _.get(this.planDetail, 'menuInformation.menuNo', null),
        menuNm: _.get(this.planDetail, 'menuInformation.menuNm', null),
        planId: _.get(this.planDetail, 'planBasicInfo.planId', null),
        roomId: _.get(this.planDetail, 'roomBasicInfo.roomId', null),
        planNm: _.get(this.planDetail, 'planBasicInfo.planNm', null)
      }
    },
    loadInitData() {
      const { menuNo, planId, roomId } = this.$route.params
      const query = _.cloneDeep(this.$route.query)
      const queryParamKeys = ['checkInDate', 'stayNights', 'roomCnt', 'adultHeadCnt','exUpperGradesHeadCnt',
    'exLowerGradesHeadCnt','youjiAHeadCnt','youjiBHeadCnt','youjiCHeadCnt','youjiDHeadCnt']

      // CLEAR FLOW DATA
      const menuStayParams = _.cloneDeep(_.get(this.$store.state.bs_app, 'bs_app.bs_app_02_001.menuStayParams', null))
      if(menuStayParams && (menuStayParams.menuBasicInfo.menuNo != menuNo || menuStayParams.planBasicInfo.planId != planId)){
        const userInfo = _.cloneDeep(_.get(this.$store.state.bs_app, 'bs_app.userInfo', null))
        this.$store.commit('RESET_STATE')
        this.$store.commit('SET_INFO_USER', userInfo)
      }
      if (!query.adultHeadCnt) {
        // ライフエール独自対応
        // this.cookieApply = JSON.parse(getCookieValue('selected_option_plan')) ;
        if(this.cookieApply){
          query.adultHeadCnt = this.cookieApply.adultHeadCnt || 1
          query.roomCnt = this.cookieApply.roomCnt || 1
          query.exUpperGradesHeadCnt = this.cookieApply.exUpperGradesHeadCnt || 0
          query.exLowerGradesHeadCnt = this.cookieApply.exLowerGradesHeadCnt || 0
          query.youjiAHeadCnt = this.cookieApply.youjiAHeadCnt || 0
          query.youjiBHeadCnt = this.cookieApply.youjiBHeadCnt || 0
          query.youjiCHeadCnt = this.cookieApply.youjiCHeadCnt || 0
          query.youjiDHeadCnt = this.cookieApply.youjiDHeadCnt || 0
          query.checkInDate = this.cookieApply.checkInDate || moment()
          this.stayAdults = this.cookieApply.adultHeadCnt || 0
          this.stayDay = moment(this.cookieApply.checkInDate) || moment()
          this.stayNights = this.cookieApply.stayNights || 1
          this.stayRooms =this.cookieApply.roomCnt || 1
        }else{
          query.adultHeadCnt = 1
        }
      }
      const customerPlan = this.getCustomerPlan
      if (customerPlan && this.useCustomerPlan) { //customerPlanが存在し、申込画面からの遷移の場合
        const stayDay = (customerPlan.stayDay || query.checkInDate).replaceAll("/",'-');
        this.tmpVariables.stayDay = stayDay ? moment(stayDay) : moment();
        this.tmpVariables.stayNights = customerPlan.stayNights || 1
        this.tmpVariables.stayRooms = customerPlan.stayRooms
        this.tmpVariables.stayAdults = customerPlan.memberAdults
        this.tmpVariables.attachChildren = customerPlan.attachChildren
        this.tmpVariables.memberChldDetails = customerPlan.memberChldDetails
        this.tmpVariables.visitorChldDetails = customerPlan.visitorChldDetails
        this.peopleDetails = {
          memberAdults: this.tmpVariables.stayAdults,
          visitorAdults: 0,
          memberChldDetails: customerPlan.memberChldDetails,
          visitorChldDetails: customerPlan.visitorChldDetails
        }

        this.updateQueryParams({
          checkInDate: moment(customerPlan.stayDay).format(this.dateFormat2),
          stayNights: customerPlan.stayNights || 1,
          roomCnt: customerPlan.stayRooms,
          adultHeadCnt: customerPlan.memberAdults,
          exUpperGradesHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType10),
          exLowerGradesHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType15),
          youjiAHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType20),
          youjiBHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType30),
          youjiCHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType40),
          youjiDHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType50)
          })
      } else {
        if (
          query &&
          query.checkInDate &&
          moment(query.checkInDate).isSameOrAfter(moment(), 'day')
        ) {
          this.tmpVariables.stayDay = moment(query.checkInDate)
          this.stayDay = moment(query.checkInDate)
        }
        if (query.stayNights) {
          if (query.stayNights < 1) {
            this.tmpVariables.stayNights = 1
            this.stayNights = 1
          } else {
            this.tmpVariables.stayNights = query.stayNights || 1
            this.stayNights = query.stayNights || 1
          }
        }
        if (query.adultHeadCnt) {
          this.tmpVariables.stayAdults = +query.adultHeadCnt
          this.stayAdults = +query.adultHeadCnt
        }
        if (query.roomCnt) {
          this.tmpVariables.stayRooms = +query.roomCnt
          this.stayRooms = +query.roomCnt
        }
        let exUpperGradesHeadCnt = 0
        let exLowerGradesHeadCnt = 0
        let youjiAHeadCnt = 0
        let youjiBHeadCnt = 0
        let youjiCHeadCnt = 0
        let youjiDHeadCnt = 0
        if (query.exUpperGradesHeadCnt) {
          exUpperGradesHeadCnt = query.exUpperGradesHeadCnt
        }
        if (query.exLowerGradesHeadCnt) {
          exLowerGradesHeadCnt = query.exLowerGradesHeadCnt
        }
        if (query.youjiAHeadCnt) {
          youjiAHeadCnt = query.youjiAHeadCnt
        }
        if (query.youjiBHeadCnt) {
          youjiBHeadCnt = query.youjiBHeadCnt
        }
        if (query.youjiCHeadCnt) {
          youjiCHeadCnt = query.youjiCHeadCnt
        }
        if (query.youjiDHeadCnt) {
          youjiDHeadCnt = query.youjiDHeadCnt
        }
        if (queryParamKeys.filter((key) => !query[key])) {
          this.updateQueryParams({
            checkInDate: this.stayDay ? moment(this.stayDay).format(this.dateFormat2) : null,
            stayNights: this.stayNights ||1,
            roomCnt: this.stayRooms,
            adultHeadCnt: this.stayAdults,
            exUpperGradesHeadCnt: exUpperGradesHeadCnt,
            exLowerGradesHeadCnt: exLowerGradesHeadCnt,
            youjiAHeadCnt: youjiAHeadCnt,
            youjiBHeadCnt: youjiBHeadCnt,
            youjiCHeadCnt: youjiCHeadCnt,
            youjiDHeadCnt: youjiDHeadCnt
          })
        }
        const memberChldDetails = {
          childrenType10: parseInt(query.exUpperGradesHeadCnt)
            ? parseInt(query.exUpperGradesHeadCnt)
            : 0,
          childrenType15: parseInt(query.exLowerGradesHeadCnt)
            ? parseInt(query.exLowerGradesHeadCnt)
            : 0,
          childrenType20: parseInt(query.youjiAHeadCnt)
            ? parseInt(query.youjiAHeadCnt)
            : 0,
          childrenType30: parseInt(query.youjiBHeadCnt)
            ? parseInt(query.youjiBHeadCnt)
            : 0,
          childrenType40: parseInt(query.youjiCHeadCnt)
            ? parseInt(query.youjiCHeadCnt)
            : 0,
          childrenType50: parseInt(query.youjiDHeadCnt)
            ? parseInt(query.youjiDHeadCnt)
            : 0
        }

        this.peopleDetails = {
          memberAdults: this.tmpVariables.stayAdults,
          visitorAdults: 0,
          memberChldDetails: memberChldDetails,
          visitorChldDetails: null
        }
      }
      // this.getVacancyCalendar({ onInit: true })
      // GET acptDtlNo
      // if (!this.acptDtlNo) {
      //   this.getAcptDtlNo()
      // }
    },
    getReservationDiv() {
      const vacancyCalendars =
        this.vacancyCalendar && Array.isArray(this.vacancyCalendar.vacancyCalendars)
          ? this.vacancyCalendar.vacancyCalendars
          : []
      if (vacancyCalendars && vacancyCalendars[0]) {
        return vacancyCalendars[0].reservationDiv;
      }
      return null;
    },
    mountData(planResult) {
      this.applLimits = planResult.applLimits
      this.$store.dispatch(SAVE_PLAN_DETAIL, planResult)
      this.planDetail = planResult
      if (this.planDetail) {
        this.getDttPlan()
      }
      const cancelPolicy = _.cloneDeep(_.get(this.planDetail, 'cancelPolicy', null))
      if (cancelPolicy && Array.isArray(cancelPolicy.cancelPolicies)) {
        cancelPolicy.cancelPolicies = cancelPolicy.cancelPolicies.map((cancel, index) => {
          cancel.id = `cancelPolicy-${index + 1}`
          if (cancel.cancelPolicyTable) {
            cancel.cancelPolicyTable = cancel.cancelPolicyTable.map((el, idx) => {
              if (!el.id) {
                el.id = `cancelPolicyTable-${idx + 1}`
              }
              return el
            })
          }
          return cancel
        })
      }
      this.cancelPolicy = cancelPolicy
      this.menuInformation = this.planDetail.menuInformation
      this.planBasicInfo = this.planDetail.planBasicInfo
      this.checkOutOfPlanRcDt()
      if (this.planBasicInfo) {
        if (
          !Array.isArray(get(this.planBasicInfo, 'planImages')) ||
          !this.planBasicInfo.planImages.length
        ) {
          this.planBasicInfo.planImages = [
            {
              imageUrl: PLACEHOLDER_IMG,
              imageExplanation: ''
            }
          ]
        }
        for (let i = 0; i < this.planBasicInfo.planImages.length; i++) {
          if (
            this.planBasicInfo.planImages &&
            (this.planBasicInfo.planImages[i].imageUrl === '' ||
              this.planBasicInfo.planImages[i].imageUrl === null)
          ) {
            this.planBasicInfo.planImages[i].imageUrl = PLACEHOLDER_IMG
          }
        }
        this.planBasicInfo.slides = this.planBasicInfo.planImages.map((item) => {
          return {
            imageUrl: item.imageUrl,
            label: item.imageExplanation
          }
        })
      }
      this.planRcSttDt = this.planDetail.planBasicInfo.planRcSttDt
      this.planIcons = this.planDetail.planIcons
      this.planInfomation = this.planDetail.planInfomation
      if (this.planInfomation) {
        this.planInfomation.map((item) => {
          return (item.loadMore = true)
        })
      }
      this.planUsage = this.planDetail.planUsage
      const stayLimitMax = _.get(this.planUsage, 'usageDetailStay.stayLimitMax', null)
      this.applFlag = _.get(this.planUsage, 'applFlag', '1')
      this.checkRsvReceptEnd()
      this.limitNights = this.checkStayLimitMax(stayLimitMax)
      this.usageLimitInformation = this.planDetail.usageLimitInformation
      this.roomBasicInfo = this.planDetail.roomBasicInfo
      this.roomIcons = _.get(this.planDetail, 'roomIcons', '')
      this.maxStayCapacity =
        this.roomBasicInfo && this.roomBasicInfo.maxStayCapacity
          ? this.roomBasicInfo.maxStayCapacity
          : null
      this.minStayCapacity =
        this.roomBasicInfo && this.roomBasicInfo.minStayCapacity !== null
          ? this.roomBasicInfo.minStayCapacity
          : null

      this.setLimitRoomCapacity()
      this.calculateStayAmount()
      this.getStayParam()
      if (this.loggedIn) {
        this.getSubsidyCoupons()
      }

      // プランで利用可能な補助金一覧
      this.getCafeIcon();

      this.$nextTick(() => {
        if (_.cloneDeep(_.get(this.$store.state, 'plan.scrollCalendar', null)) === true) {
          this.gotoCalendar()
        }
      })
      if (this.planDetail) {
        this.getBodyEmail()
      }
    },
    async getPlanDetail(callback = null) {
      const { menuNo, planId, roomId } = this.$route.params
      const query = JSON.parse(JSON.stringify(this.$route.query))
      const today = moment()
      let response
      // queryに値がなければデフォルト値をセットする
      query.checkInDay = query.checkInDate
        ? query.checkInDate
        : today.clone().format('YYYY-MM-DD')
      query.checkOutDay = query.checkOutDate
        ? query.checkOutDate
        : today.clone().add(1, 'days').format('YYYY-MM-DD')
      query.roomCnt = _.get(query, 'roomCnt') || 1
      query.adultHeadCnt = _.get(query, 'adultHeadCnt') || 1
      query.exUpperGradesHeadCnt = _.get(query, 'exUpperGradesHeadCnt') || 0
      query.exLowerGradesHeadCnt = _.get(query, 'exLowerGradesHeadCnt') || 0
      query.youjiAHeadCnt = _.get(query, 'youjiAHeadCnt') || 0
      query.youjiBHeadCnt = _.get(query, 'youjiBHeadCnt') || 0
      query.youjiCHeadCnt = _.get(query, 'youjiCHeadCnt') || 0
      query.youjiDHeadCnt = _.get(query, 'youjiDHeadCnt') || 0
      response = await this.$repositories('plan')
        .getPlanDetail(menuNo, planId, roomId, query)
        .then(
          (result) => result,
          (error) => {
            if (+error.status === 401) {
              this.errorType = 'plan'
              this.showModalError = true
            } else if(+error.status === 404) {
              this.showModalError = true
            }
          }
        )
      if (callback) {
        callback(response)
      }
      return response
    },
    async checkRoomLimit(data) {
      return await this.$repositories('plan')
        .checkRoomLimit(data)
        .then(
          (result) => result,
          (error) => error
        )
    },
    async onSelectDay($event, options) {
      // check stock
      const now = moment(new Date())
      this.isRanged = !options?.isRanging
      const clonedStayDay = this.getDataMoment(this.tmpVariables.stayDay,this.stayDay)
      if ($event.isBefore(now, 'day')) {
        this.tmpVariables.stayDay = now
      } else {
        this.tmpVariables.stayDay = $event
      }
      if (!clonedStayDay.isSame($event, 'month') || (this.isOutstockDay($event) && this.getReservationDiv() == "20")) {
        await this.getVacancyCalendar()
        await this.getStayParam()
        this.getSubsidyCoupons()
        this.$toasted.clear()
      } else if (this.isOutstockDay($event) && this.getReservationDiv() !== "20") {
        // check all stay-range
        // check selected date is valid
        this.$nextTick(() => {
          this.$toasted.clear()
          this.$toasted.error(
            'ご指定された条件ではご利用いただけません。<br>日程またはご利用人数を設定し直すか、他のプランをご利用ください。',
            TOAST_OPTION
          )
          this.tmpVariables.stayDay = clonedStayDay
        })
      } else {
        this.$toasted.clear()
      }
    },
    onChangeStayDayPicker(val) {
      this.onSelectDay(val)
    },
    onChangeRange($event) {
      this.isRanged = true
      let nights = $event.diff
      if (this.isInValidMaxNights(nights)) {
        nights = this.limitNights
        this.$toasted.error(`${this.limitNights}泊まで選択可能です。`)
      }
      if (
        (!this.stayDay.isSame(this.tmpVariables.stayDay, 'day') ||
          this.stayNights !== nights) &&
        this.onChangeStayNights(nights)
      ) {
        this.$nextTick(() => {
          this.tmpVariables.stayNights = nights
          if (this.loggedIn) {
            this.getSubsidyCoupons()
          }
        })
      }
    },
    isInValidMaxNights(nights) {
      return nights > this.limitNights
    },
    async onChangeStayNights($event) {
      let eventValue = Number($event) ?  Number($event) : this.tmpVariables.stayNights;
      this.tmpVariables.stayNights =  eventValue;
      await this.getVacancyCalendar()
      this.getSubsidyCoupons()
      // check stock of each days
      let nightCnt = 0
      let isValidRange = true
      for (let i = 0; i < eventValue; i++) {
        if (this.isOutstockDay(this.stayDay.clone().add(i, 'days')) && this.getReservationDiv() !== "20") {
          this.$nextTick(() => {
            if (nightCnt > 0) {
              this.tmpVariables.stayNights = nightCnt
              this.stayNights = nightCnt
            }
          })
          this.$toasted.clear()
          this.$toasted.error(
            'ご指定された条件ではご利用いただけません。<br>日程またはご利用人数を設定し直すか、他のプランをご利用ください。',
            TOAST_OPTION
          )
          isValidRange = false
          break
        } else {
          this.$toasted.clear()
        }
        nightCnt += 1
      }
      this.getPriceMin()
      return isValidRange
    },
    onChangeStayRoom($event) {
      if (this.changeControl.key === null) {
        this.changeControl.key = CHANGE_CONTROL.ROOM
        this.getVacancyCalendar()
        this.$nextTick(() => {
          this.changeControl.key = null
        })
      }
    },
    onChangeStayAdult($event) {
      if (this.changeControl.key === null) {
        this.changeControl.key = CHANGE_CONTROL.ADULT
        this.getStayParam()
        this.getVacancyCalendar()
        this.$nextTick(() => {
          this.changeControl.key = null
        })
      }
    },
    setLimitRoomCapacity() {
      if (_.get(this.menuInformation, 'extSystemCd') === 'RakutenT') {
        this.limitRooms = 10
      } else if (_.get(this.menuInformation, 'extSystemCd') === 'ToyokoInn') {
        this.limitRooms = 9
      } else {
        this.limitRooms = 19
      }
    },
    checkCondition($event) {
      this.checkConditionBookRoom = $event;
    },
    inputChildren(type, $event) {
      // if ($event.key === 'Backspace') {
      //   this.errorControl.tryCount = 0
      //   return
      // }
      // this.$nextTick(() => {
      //   if (type === 'childrenType30' || type === 'childrenType50') {
      //     if (this.attachChildren[type] >= 19) {
      //       this.$toasted.error(`追加できるのは「${this.getChildTypeName(type)}」の${this.attachChildren[type]}人までです。`)
      //     }
      //     return
      //   }
      //   if (this.maxSlotRemaining <= 0) {
      //     if (this.errorControl.tryCount > 0) {
      //       this.$toasted.error(`追加できるのは「${this.getChildTypeName(type)}」の${this.attachChildren[type]}人までです。`)
      //     }
      //     this.errorControl.tryCount++
      //   } else if (this.errorControl.tryCount !== 0) {
      //     this.errorControl.tryCount = 0
      //   }
      // })
    },
    async getPriceMin() {
      const dayArr = []
      for (let index = 0; index < this.stayNights; index++) {
        const day = this.getDataMoment(this.stayDay).add(index, 'days').format('YYYY/MM/DD')
        dayArr.push(day)
      }
      let dayArrSelected = []
      const vacancyCalendars = _.get(this.vacancyCalendar, 'vacancyCalendars', null)
      if (dayArr && vacancyCalendars) {
        dayArr.forEach((el) => {
          vacancyCalendars.forEach((el1) => {
            const dayVacancy = _.get(el1, 'stayDay', null)
            if (+(moment(el) - moment(dayVacancy)) === 0) {
              dayArrSelected.push(el1)
            }
          })
        })
      }
      this.minRoomPrice = null
      let minPriceAdult = 0
      let minPriceVisitor = 0
      let minPriceChildMemberA = 0
      let minPriceChildMemberB = 0
      let minPriceChildMemberC = 0
      let minPriceChildMemberD = 0
      let minPriceChildMemberE = 0
      let minPriceChildMemberF = 0
      let minPriceChildVisitA = 0
      let minPriceChildVisitB = 0
      let minPriceChildVisitC = 0
      let minPriceChildVisitD = 0
      let minPriceChildVisitE = 0
      let minPriceChildVisitF = 0
      this.arrPriceMin = []
      if (dayArrSelected) {
        if (!this.$route.query.checkInDate) {
          // 日付未指定の場合
          dayArrSelected = dayArrSelected.slice(0, 0)
          dayArrSelected[0] = minBy(vacancyCalendars, 'price')
          this.minRoomPrice = _.get(dayArrSelected[0], 'price', 0)
        } else {
          dayArrSelected.forEach((it) => {
            let price = 0
            price = _.get(it, 'price', 0)
            if (this.minRoomPrice === null) {
              this.minRoomPrice = +price
            } else if (+this.minRoomPrice > 0 && +price < this.minRoomPrice) {
              this.minRoomPrice = +price
            }
          })
        }
        if (this.baseOnPrice === PLAN_BASE_ON_PRICE.PEOPLE) {
          // minPriceAdult = _.get(dayArrSelected[0], 'adultPrice', 0)
          // minPriceVisitor = minPriceAdult + _.get(dayArrSelected[0], 'boneSubsidy', 0)
          minPriceAdult =
            _.get(dayArrSelected[0], 'adultPrice', 0) -
            _.get(dayArrSelected[0], 'boneSubsidy', 0)
          minPriceVisitor = _.get(dayArrSelected[0], 'adultPrice', 0)

          dayArrSelected.forEach((el2) => {
            // const adultPrice = _.get(el2, 'adultPrice', 0)
            // const visitorPrice = adultPrice + _.get(el2, 'boneSubsidy', 0)
            const adultPrice = _.get(el2, 'adultPrice', 0) - _.get(el2, 'boneSubsidy', 0)
            const visitorPrice = _.get(el2, 'adultPrice', 0)

            const childrenPriceTable = _.get(el2, 'childrenPriceTable', null)
            if (+minPriceAdult === 0 && +adultPrice > 0) {
              minPriceAdult = +adultPrice
            } else if (+adultPrice < +minPriceAdult) {
              minPriceAdult = +adultPrice
            }
            if (+minPriceVisitor === 0 && +visitorPrice > 0) {
              minPriceVisitor = +visitorPrice
            } else if (+visitorPrice < +minPriceVisitor) {
              minPriceVisitor = +visitorPrice
            }
            if (childrenPriceTable) {
              childrenPriceTable.forEach((el3) => {
                const childDiv = _.get(el3, 'childDiv', 0)
                const childPrice = _.get(el3, 'price', 0)
                const boneSubsidy = _.get(el3, 'boneSubsidy', 0)
                const childVisitPrice = _.get(el3, 'childPrice', 0)
                if (+childDiv === 10 && +minPriceChildMemberA === 0) {
                  minPriceChildMemberA = childPrice
                } else if (+childDiv === 10 && +childPrice < minPriceChildMemberA) {
                  minPriceChildMemberA = childPrice
                }
                if (+childDiv === 15 && +minPriceChildMemberB === 0) {
                  minPriceChildMemberB = childPrice
                } else if (+childDiv === 15 && +childPrice < minPriceChildMemberB) {
                  minPriceChildMemberB = childPrice
                }
                if (+childDiv === 20 && +minPriceChildMemberC === 0) {
                  minPriceChildMemberC = childPrice
                } else if (+childDiv === 10 && +childPrice < minPriceChildMemberC) {
                  minPriceChildMemberC = childPrice
                }
                if (+childDiv === 30 && +minPriceChildMemberD === 0) {
                  minPriceChildMemberD = childPrice
                } else if (+childDiv === 30 && +childPrice < minPriceChildMemberD) {
                  minPriceChildMemberD = childPrice
                }
                if (+childDiv === 40 && +minPriceChildMemberE === 0) {
                  minPriceChildMemberE = childPrice
                } else if (+childDiv === 10 && +childPrice < minPriceChildMemberE) {
                  minPriceChildMemberE = childPrice
                }
                if (+childDiv === 50 && +minPriceChildMemberF === 0) {
                  minPriceChildMemberF = childPrice
                } else if (+childDiv === 50 && +childPrice < minPriceChildMemberF) {
                  minPriceChildMemberF = childPrice
                }
                if (+childDiv === 10 && +minPriceChildVisitA === 0) {
                  minPriceChildVisitA = childVisitPrice
                } else if (+childDiv === 10 && +childVisitPrice < minPriceChildVisitA) {
                  minPriceChildVisitA = childVisitPrice
                }
                if (+childDiv === 15 && +minPriceChildVisitB === 0) {
                  minPriceChildVisitB = childVisitPrice
                } else if (+childDiv === 15 && +childVisitPrice < minPriceChildVisitB) {
                  minPriceChildVisitB = childVisitPrice
                }
                if (+childDiv === 20 && +minPriceChildVisitC === 0) {
                  minPriceChildVisitC = childVisitPrice
                } else if (+childDiv === 20 && +childVisitPrice < minPriceChildVisitC) {
                  minPriceChildVisitC = childVisitPrice
                }
                if (+childDiv === 30 && +minPriceChildVisitD === 0) {
                  minPriceChildVisitD = childVisitPrice
                } else if (+childDiv === 30 && +childVisitPrice < minPriceChildVisitD) {
                  minPriceChildVisitD = childVisitPrice
                }
                if (+childDiv === 40 && +minPriceChildVisitE === 0) {
                  minPriceChildVisitE = childVisitPrice
                } else if (+childDiv === 40 && +childVisitPrice < minPriceChildVisitE) {
                  minPriceChildVisitE = childVisitPrice
                }
                if (+childDiv === 50 && +minPriceChildVisitF === 0) {
                  minPriceChildVisitF = childVisitPrice
                } else if (+childDiv === 50 && +childVisitPrice < minPriceChildVisitF) {
                  minPriceChildVisitF = childVisitPrice
                }
              })
            }
          })
          this.arrPriceMin = [
            {
              title: '会員１人あたりの料金  　税込 ',
              value: minPriceAdult,
              totalPerson: this.stayAdults
            },
            {
              title: 'ビジター1人あたりの料金  　税込 ',
              value: minPriceVisitor,
              totalPerson: this.stayAdults
            },
            {
              title: '子ども 小学生高学年1人あたりの料金　税込 ',
              value: minPriceChildMemberA,
              totalPerson: this.attachChildren.childrenType10
            },
            {
              title: '子ども 小学生低学年1人あたりの料金　税込 ',
              value: minPriceChildMemberB,
              totalPerson: this.attachChildren.childrenType15
            },
            {
              title: '子ども 幼児食事・布団付1人あたりの料金　税込 ',
              value: minPriceChildMemberC,
              totalPerson: this.attachChildren.childrenType20
            },
            {
              title: '子ども 幼児食事のみ1人あたりの料金　税込 ',
              value: minPriceChildMemberD,
              totalPerson: this.attachChildren.childrenType30
            },
            {
              title: '子ども 幼児布団のみ1人あたりの料金　税込 ',
              value: minPriceChildMemberE,
              totalPerson: this.attachChildren.childrenType40
            },
            {
              title: '子ども 幼児食事・布団不要1人あたりの料金　税込 ',
              value: minPriceChildMemberF,
              totalPerson: this.attachChildren.childrenType50
            },
            {
              title: 'ビジター子ども 小学生高学年1人あたりの料金　税込 ',
              value: minPriceChildVisitA,
              totalPerson: this.attachChildren.childrenType10
            },
            {
              title: 'ビジター子ども 小学生低学年1人あたりの料金　税込 ',
              value: minPriceChildVisitB,
              totalPerson: this.attachChildren.childrenType15
            },
            {
              title: 'ビジター子ども 幼児食事・布団付1人あたりの料金　税込 ',
              value: minPriceChildVisitC,
              totalPerson: this.attachChildren.childrenType20
            },
            {
              title: 'ビジター子ども 幼児食事のみ1人あたりの料金　税込 ',
              value: minPriceChildVisitD,
              totalPerson: this.attachChildren.childrenType30
            },
            {
              title: 'ビジター子ども 幼児布団のみ1人あたりの料金　税込 ',
              value: minPriceChildVisitE,
              totalPerson: this.attachChildren.childrenType40
            },
            {
              title: 'ビジター子ども 幼児食事・布団不要1人あたりの料金　税込 ',
              value: minPriceChildVisitF,
              totalPerson: this.attachChildren.childrenType50
            }
          ]
        }
      }
    },
    async getAcptDtlNo() {
      this.$repositories('order')
        .getOrderAcptDtlNo()
        .then((response) => {
          this.acptDtlNo = response.acptDtlNo
        })
    },
    async getSubsidyCoupons() {
      const today = moment().startOf('days') // 日付比較のため.startOf('days')で時間設定を00:00:00にする
      const stayNights = this.stayNights || 1
      // stayDay
      const checkInDay = this.getDataMoment(this.tmpVariables.stayDay, this.stayDay)
      const checkOutDay =
        stayNights >= 0
          ? checkInDay.clone().add(stayNights, 'days')
          : checkInDay.clone().add(1, 'days')

      let subsidyAvailables = await this.$repositories('coupon')
        .getSubsidyCouponList({
          reserveDateFrom: today.format('YYYY-MM-DD'),
          reserveDateTo: today.format('YYYY-MM-DD'),
          useDateFrom: checkInDay.format('YYYY-MM-DD'),
          useDateTo: checkOutDay.add(-1, 'days').format('YYYY-MM-DD'),
          personAccompanyFlag: null,
          displayDiv: '2'
        })
        .catch((error) => {
          return error
        })
      if (!subsidyAvailables || !Array.isArray(subsidyAvailables)) {
        subsidyAvailables = []
      }

      // 保有枚数0枚の補助金は取り除く（nullの場合は利用可）
      subsidyAvailables = subsidyAvailables.filter(data => data.availableRemainingCount !== 0);

      // 保有枚数0枚の補助金は取り除く（nullの場合は利用可）
      subsidyAvailables = subsidyAvailables.filter(data => data.availableRemainingAmount !== 0);

      subsidyAvailables = subsidyAvailables.filter(
        (s) => {
          const receptionCheck = moment(s.availableData.receptionDateFrom).isSameOrBefore(today) &&
            moment(s.availableData.receptionDateTo).isSameOrAfter(today);
          const start = moment(s.availableData.applicableDateFrom);
          const end = moment(s.availableData.applicableDateTo);
          const lastNight = checkOutDay.clone().add(-1, 'days');

          const checkInDayCheck = checkInDay.isBetween(start, end, 'day', '[]');
          const checkOutDayCheck = lastNight.isBetween(start, end, 'day', '[]');
          const startCheck = start.isBetween(checkInDay, checkOutDay, 'day', '[)');
          const endCheck = end.isBetween(checkInDay, checkOutDay, 'day', '[)');
          const limit = this.checkWithinLimApplicableDate(s.availableData.priceList, checkInDay, checkOutDay);
          return receptionCheck && (checkInDayCheck || checkOutDayCheck || startCheck || endCheck) && limit;
        }
      )
      // ĐẶT TRƯỚC 7 NGÀY ĐỐI VỚI COUPON BẢO HIỂM
      if (!moment().add(7, 'days').isSameOrBefore(this.tmpVariables.stayDay, 'day')) {
        subsidyAvailables = subsidyAvailables.filter(
          (s) => s.availableData.fiveDaysAgoControlFlg === "0"
        )
      }

      if (subsidyAvailables.length) {
        const subsidyIds = subsidyAvailables
          .map((s) => s.availableData.subsidyId)
          .join('-')
        const params = {
          id: subsidyIds, // 0: subsidy, 1: cafe
          targetType: 0, // 0: subsidy, 1: cafe
          catLrgClassCd: get(
            this.planDetail,
            'menuInformation.categoryInfomation.catLrgClassCd',
            ''
          ),
          catMidClassCd: get(
            this.planDetail,
            'menuInformation.categoryInfomation.catMidClassCd',
            ''
          ),
          catSmlClassCd: get(
            this.planDetail,
            'menuInformation.categoryInfomation.catSmlClassCd',
            ''
          ),
          menuNo: get(this.planDetail, 'menuInformation.menuNo', ''),
          planId: get(this.planDetail, 'planBasicInfo.planId', ''),
          areaLrgClassCd: get(
            this.planDetail,
            'menuInformation.areaInfomation.areaLrgClassCd',
            ''
          ),
          areaMidClassCd: get(
            this.planDetail,
            'menuInformation.areaInfomation.areaMidClassCd',
            ''
          ),
          areaSmlClassCd: get(
            this.planDetail,
            'menuInformation.areaInfomation.areaSmlClassCd',
            ''
          ),
          areaDtlClassCd: get(
            this.planDetail,
            'menuInformation.areaInfomation.areaDtlClassCd',
            ''
          ),
          // receivableFlag: get(this.planDetail, 'planUsage.usageDetail.receivableFlag', ''),
          receivableFlag: '1',
          ticketExclusionFlag: get(
            this.planDetail,
            'planUsage.usageDetail.ticketExclusionFlag',
            ''
          ),
          buppanExclusionFlag: get(
            this.planDetail,
            'planUsage.usageDetail.buppanExclusionFlag',
            ''
          ),
          famiExclusionFlag: get(
            this.planDetail,
            'planUsage.usageDetail.famiExclusionFlag',
            ''
          )
        }
        const stationMapping = await this.$repositories('coupon')
          .getStationMapping(params)
          .catch((error) => {
            return error
        })
        if (stationMapping && stationMapping.bsSubsidyMappingArray) {
          const bsSubsidyIdMappings = stationMapping.bsSubsidyMappingArray.map(
            (e) => e.subsidyId
          )
          subsidyAvailables = subsidyAvailables.filter((c) =>
            bsSubsidyIdMappings.includes(c.availableData.subsidyId)
          )
        } else {
          // ステマAPI実行時にエラーが発生した場合、補助金情報を返さない #77940
          subsidyAvailables = []
        }

        const subsidyList = subsidyAvailables
          .filter(
            (c) => (c) =>
              +c.availableData.useStopFlg === 0 &&
              c.availableData.subsidyType === '01' &&
              (c.availableRemainingCount === null || +c.availableRemainingCount > 0) &&
              (c.availableRemainingAmount === null || +c.availableRemainingAmount > 0)
          )
          .map((s) => {
            if (Array.isArray(s.availableData.priceList)) {
              // find coupons owner
              const priceList = s.availableData.priceList.filter(
                (e) => e.priceType === COUPON_PRICE_TYPE.OWNER
              )
              if (priceList.length) {
                s['listPrice'] = priceList
              } else if (s.availableData.priceList.length) {
                s['listPrice'] = s.availableData.priceList
              }
            }
            return s
          })
        this.subsidyList = subsidyList.filter((s) => s.listPrice)

        // 受付期間のToが早い順にする
        this.subsidyList.sort((a, b) => {
          return new Date(a.availableData.receptionDateTo) - new Date(b.availableData.receptionDateTo)
        })

        this.subsidyCouponList = this.subsidyList.filter(subsidy => subsidy.availableData.groupInfo == null)
        this.subsidyCouponGroupList = this.subsidyList.filter(subsidy => subsidy.availableData.groupInfo != null)
                                        .sort((prev, next) => {
                                          // グループidごとに昇順でソート(ソート順で要望は決まってないため昇順に設定)
                                          if (prev.availableData.groupInfo.groupId !== next.availableData.groupInfo.groupId) {
                                            if (prev.availableData.groupInfo.groupId > next.availableData.groupInfo.groupId)
                                              return 1;
                                            if (prev.availableData.groupInfo.groupId < next.availableData.groupInfo.groupId)
                                              return -1;
                                          }
                                        })
        // グループ補助金情報を先頭表示判別のためのフラグを追加
        let groupId = '';
        let firstGroupId = '';
        this.subsidyCouponGroupList.forEach((val, idx) => {
          val.displayGroupInfoFlg = false;
          if (val.availableData.groupInfo.groupId != groupId) {
            val.displayGroupInfoFlg = true;
            groupId = val.availableData.groupInfo.groupId;
          }
          if (idx == 0) { firstGroupId = val.availableData.groupInfo.groupId;}
          if (firstGroupId == val.availableData.groupInfo.groupId) {
            val.dispFlag = true;
          } else {
            val.dispFlag = false;
          }
        })
        // グループ情報のみを抽出
        this.subsidyGroupList = this.subsidyCouponGroupList.map((subsidy) => { return subsidy.availableData.groupInfo })
        this.subsidyGroupList = this.subsidyGroupList.filter(
          (element, index, group) => group.findIndex((e) => e.groupId === element.groupId) === index
        )

        this.getSubsidyIcon(this.subsidyList);
      }
    },
    /**
     * 宿泊日が限定適用期間内か判定する
     */
    checkWithinLimApplicableDate(priceList, checkInDay, checkOutDay) {
      if (priceList && priceList.length > 0) {
        // 1つでも宿泊日を含む限定適用期間があれば利用可能と判定する
        const len = priceList.length
        for (let i = 0; i < len; i++) {
          const price = priceList[i];
          const start = moment(price.limApplicableDateFrom);
          const end = moment(price.limApplicableDateTo);
          const lastNight = checkOutDay.clone().add(-1, 'days');

          const checkInDayCheck = checkInDay.isBetween(start, end, 'day', '[]');
          const checkOutDayCheck = lastNight.isBetween(start, end, 'day', '[]');
          const startCheck = start.isBetween(checkInDay, checkOutDay, 'day', '[)');
          const endCheck = end.isBetween(checkInDay, checkOutDay, 'day', '[)');

          if (checkInDayCheck || checkOutDayCheck || startCheck || endCheck) {
            return true;
          }
        }
      }
      return false;
    },

    /**
    * 在庫取得 *MNのAPI仕様上,checkInDateの月の当日~月末の単位でしか取得できないため月またぎの場合を考慮して実装
    */
    async getStock(query){
      // MNへ検索するパラメータの取得
      const { menuNo, planId, roomId } = this.$route.params;
      let checkInDate = this.getDataMoment(_.get(query, 'checkInDate')).format('YYYY/MM/DD');
      // checkOutDateをcheckInDate＋宿泊日で定義
      let checkOutDate = this.getDataMoment(checkInDate).add(_.get(query, 'stayNights'), 'days').format('YYYY/MM/DD');

      // 検索条件をqueryから取得　値がなければ検索初期値をセット
      let queryParams = {
        checkInDay: checkInDate,
        checkOutDay: checkOutDate,
        roomCnt: _.get(query, 'roomCnt') || 1,
        adultHeadCnt: _.get(query, 'adultHeadCnt') || 2,
        exUpperGradesHeadCnt: _.get(query, 'exUpperGradesHeadCnt') || 0,
        exLowerGradesHeadCnt: _.get(query, 'exLowerGradesHeadCnt') || 0,
        youjiAHeadCnt: _.get(query, 'youjiAHeadCnt') || 0,
        youjiBHeadCnt: _.get(query, 'youjiBHeadCnt') || 0,
        youjiCHeadCnt: _.get(query, 'youjiCHeadCnt') || 0,
        youjiDHeadCnt: _.get(query, 'youjiDHeadCnt') || 0,
      };

      // MNへ検索するパラメータの定義
      let vacancyData = {menuNo,planId,roomId,queryParams};

      // MNへ在庫取得処理APIをコール
      let thisMonthStocks = await this.$repositories('plan')
      .getVacancyCalendar(vacancyData)
        .then(
          (res) => {
            return res.vacancyCalendars;
          }
        )
        .catch((error) => {
          if (+error.status === 401) {
            this.errorType = 'plan'
            this.showModalError = true
          } else if(+error.status === 404) {
            this.errorType = "outOfStock"
            this.showModalError = true
          } else if( +error.statuscode === 500) {
            if (!this.isRakuten) { // 楽天以外 の場合、エラーへ遷移
              // 申込できるメニュープランがありません。
              this.errorType = 'appliy'
              this.showModalError = true
            }
          }
        });

      // 月またぎの場合、パラメータを変更して再度在庫取得APIコール
      if (moment(checkInDate).month() != moment(checkOutDate).month()) {
        // 次月の月初日付をcheckInDayにセット
        vacancyData.queryParams.checkInDay = moment(checkOutDate).startOf('month').format('YYYY/MM/DD');
        let twoMonthStocks = await this.$repositories('plan')
          .getVacancyCalendar(vacancyData)
            .then(
              (res) => {
                return thisMonthStocks.concat(res.vacancyCalendars);
              }
            )
            .catch((error) => {
              if (+error.status === 401) {
                this.errorType = 'plan'
                this.showModalError = true
              } else if(+error.status === 404) {
                this.showModalError = true
              }
            });
        return twoMonthStocks;
      }
      return thisMonthStocks;
    },
    /**
    * 検索条件「指定日」の在庫チェック
    */
    async isStockOnCheckInDay(query) {
      let isStock = true;
      // 在庫データ取得
      const stocks = await this.getStock(query);
      //指定日に在庫が存在するかチェック
      let checkInDate = moment(_.get(query, 'checkInDate')).format('YYYY/MM/DD');
      let stayNights = _.get(query, 'stayNights');
      // checkindate~宿泊日分の日付全てに在庫があるかチェック
      // １つでも在庫がない日付があればFALSE
      for (let i = 0; i<stayNights ;i++) {
        if(i > 0) {
          checkInDate = this.getDataMoment(checkInDate).add(1,'day').format('YYYY/MM/DD');
        }
        isStock = stocks.some(function(arr){ return arr.stayDay == checkInDate });
        if (!isStock) {
          return false;
        }
      }
      return true;
    },

    /**
    * カレンダー情報取得
    */
    async getVacancyCalendar(
      options = { onInit: false, nextMonth: false, prevMonth: false, loading: true },
      callback = null
    ) {
      const { menuNo, planId, roomId } = this.$route.params
      const { companyCd } = this.$route.query

      // 初回画面表示時はthis.changeControl.initがtrueで、その後はずっとfalse、initで呼び出す関数からはoptions.onInitがtrueで呼ばれる。
      if (!options.onInit && this.changeControl.init) {
        return
      }
      const checkInDay = this.getDataMoment(this.tmpVariables.stayDay, this.stayDay).format('YYYY/MM/DD')
      let checkOutDay = this.getDataMoment(this.tmpVariables.stayDay, this.stayDay)
        .add(this.tmpVariables.stayNights, 'days')
        .format('YYYY/MM/DD')
      const endOfMonth = moment(this.tmpVariables.stayDay)
          .endOf('month')
          .format('YYYY/MM/DD')
      if (this.getDataMoment(this.tmpVariables.stayDay, this.stayDay).isBefore(endOfMonth, 'day')) {
        checkOutDay = endOfMonth;
      }

      const queryParams = {
        companyCd,
        checkInDay,
        checkOutDay,
        roomCnt: this.tmpVariables.stayRooms,
        adultHeadCnt: this.tmpVariables.stayAdults,
        exUpperGradesHeadCnt: get(
          this.tmpVariables.memberChldDetails,
          'childrenType10',
          0
        ),
        exLowerGradesHeadCnt: get(
          this.tmpVariables.memberChldDetails,
          'childrenType15',
          0
        ),
        youjiAHeadCnt: get(this.tmpVariables.memberChldDetails, 'childrenType20', 0),
        youjiBHeadCnt: get(this.tmpVariables.memberChldDetails, 'childrenType30', 0),
        youjiCHeadCnt: get(this.tmpVariables.memberChldDetails, 'childrenType40', 0),
        youjiDHeadCnt: get(this.tmpVariables.memberChldDetails, 'childrenType50', 0)
      }

      const vacancyData = {
        menuNo,
        planId,
        roomId,
        queryParams
      }

      // this.vacancyCalendar = null
      if (options.loading) {
        this.$loading.show()
      }

      // 幼児修正
      const editYoujiCalendar = async function (params, result) {
        const query = params.queryParams;
        const upperG = query.exUpperGradesHeadCnt === 0 ? null : '10' // 子供・高学年
        const LowerG = query.exLowerGradesHeadCnt === 0 ? null : '15' // 子供・低学年
        const youjiA = query.youjiAHeadCnt === 0 ? null : '20' // 幼児食事・布団付
        const youjiB = query.youjiBHeadCnt === 0 ? null : '30' // 幼児食事のみ
        const youjiC = query.youjiCHeadCnt === 0 ? null : '40' // 幼児布団のみ
        const youjiD = query.youjiDHeadCnt === 0 ? null : '50' // 幼児食事・布団不要


        if (!upperG &&!LowerG &&!youjiA && !youjiB && !youjiC && !youjiD) {
          // パラメータに子供・幼児系の値が存在しない場合は、処理終了
          return result ;
        }

        const vacancyCalendars = result.vacancyCalendars
        // #79654修正 空室が無い場合はcalendarが存在しないのではなく空配列となる
        if (!Array.isArray(vacancyCalendars) || vacancyCalendars.length === 0){
          // カレンダーまたは空室が存在しない場合は、処理終了
          return result ;
        }

        // 内容判定関数
        const noClildDiv = function (table, childDiv) {
          return (
            childDiv &&
            table.findIndex((object) => object.childDiv === childDiv) === -1
          )
        }

        const roomChargePlanFlag = vacancyCalendars[0].roomPrice ? true : false;
        if(roomChargePlanFlag === true){
          // ルームチャージプランの場合、受け入れ可以外のパラメータが存在するかを判定
          const childInfos=result.childPriceInfo.childInfos;
          // 受け入れ可の子供タイプリスト
          const childDivs = [];
          childInfos.forEach((childInfo) => {
            childDivs.push(childInfo.childDiv);
          });
          // 選択された子供が受け入れ可か判定
          const childSelectList = [upperG,LowerG,youjiA,youjiB,youjiC,youjiD];
          childSelectList.forEach((childType) => {
            if(childType && !childDivs.includes(childType) ){
              // 受け入れ不可のタイプの子供ある場合、全日程在庫なしとする
              vacancyCalendars.length = 0;
              return result;
            }
          })
        }else{
          // ルームチャージプランではない場合、子供料金の設定があるか判定
          // 日付毎に判定
          for (let i = vacancyCalendars.length - 1; i >= 0; i--) {
            const vacancyCalendar = vacancyCalendars[i]
            if (!vacancyCalendar) continue

            // 子供料金設定なし -> 削除
            const childrenPriceTable = vacancyCalendar.childrenPriceTable;
            if (!childrenPriceTable) {
              vacancyCalendars.splice(i, 1)
              continue
            }

            // 子供・幼児パラメータ毎の判定 と 削除 ////////////////
            if (noClildDiv(childrenPriceTable, upperG)) {
              vacancyCalendars.splice(i, 1)
              continue
            }

            if (noClildDiv(childrenPriceTable, LowerG)) {
              vacancyCalendars.splice(i, 1)
              continue
            }

            if (noClildDiv(childrenPriceTable, youjiA)) {
              vacancyCalendars.splice(i, 1)
              continue
            }

            if (noClildDiv(childrenPriceTable, youjiB)) {
              vacancyCalendars.splice(i, 1)
              continue
            }

            if (noClildDiv(childrenPriceTable, youjiC)) {
              vacancyCalendars.splice(i, 1)
              continue
            }

            if (noClildDiv(childrenPriceTable, youjiD)) {
              vacancyCalendars.splice(i, 1)
              continue
            }
            ////////////////////////////////////////////////////////
          }
        }

        return result;
      }

      let result = null;
      try {
        result = await this.$repositories('plan')
        .getVacancyCalendar(vacancyData)
          .then(
            (res) => {
              return editYoujiCalendar(vacancyData,res)
            }
          )
          .catch((error) => {
            throw error
          })
        let hasVacancyCalendars = result?.vacancyCalendars?.length > 0;
        if(options.onInit && !hasVacancyCalendars) {
          this.skipWatchStayDay = true;
          let i = 0;
          const queryParamsNext = _.cloneDeep(queryParams)
          do {
            queryParamsNext.checkInDay = moment(queryParamsNext.checkInDay).add(1, 'M').startOf('month').format('YYYY/MM/DD');
            queryParamsNext.checkOutDay = moment(queryParamsNext.checkOutDay).add(1, 'M').endOf('month').format('YYYY/MM/DD');
            const vacancyDataNext = {
                menuNo,
                planId,
                roomId,
                queryParams: queryParamsNext,
                idx: i
            }
            result = await this.$repositories('plan')
            .getVacancyCalendar(vacancyDataNext)
            .then(
              (res) => {
                return editYoujiCalendar(vacancyDataNext,res)
              }
            )
            .catch((error) => {
              throw error
            })
            hasVacancyCalendars = result?.vacancyCalendars?.length > 0;
            i++;
          } while (i < 6 && !hasVacancyCalendars);
        } 
      } catch(error) {
        if (options.onInit) {
          // 初回画面表示時のみエラーを返却する
          return error
        }
      }

      if (!result || result.error || result.data?.errorCode) {
        if (options.loading) {
          this.$loading.hide()
        }
        this.skipWatchStayDay = false;
        this.vacancyCalendar = null
        this.applyChange()
        // this.displayVacancyCalendarがnullの場合typeErrorとなるので条件を追加
        if(this.displayVacancyCalendar&&this.displayVacancyCalendar.vacancyCalendars){
          this.displayVacancyCalendar.vacancyCalendars = [];
        }
        return
      }
      const clonedResult = _.cloneDeep(result)
      if (this.enableNextMonth || options.nextMonth) {
        // call next month
        vacancyData.queryParams.checkInDay = this.getDataMoment(this.tmpVariables.stayDay, this.stayDay)
        .add(this.tmpVariables.stayNights, 'days')
          .startOf('month')
          .format('YYYY/MM/DD')
        vacancyData.queryParams.checkOutDay = this.getDataMoment(this.tmpVariables.stayDay, this.stayDay)
          .add(this.tmpVariables.stayNights, 'days')
          .format('YYYY/MM/DD')
          const result2 = await this.$repositories('plan')
          .getVacancyCalendar(vacancyData)
          .then(
            (res) => {
              return editYoujiCalendar(vacancyData,res)
            }
          )
          .catch((error) => {
            return error
          })
        if (!result2 || result2.error) {
          if (options.loading) {
            this.$loading.hide()
          }
          this.applyChange()
          return
        }
        clonedResult.vacancyCalendars = clonedResult.vacancyCalendars.concat(
          result2.vacancyCalendars
        )
      }
      if (options.loading) {
        this.$loading.hide()
      }
      // add spec round to decimal for adultPrice, childPrice, price
      clonedResult?.vacancyCalendars?.map((item) => {
        item.price = Math.round(item.price)
        item.adultPrice = Math.round(item.adultPrice)
        item?.childrenPriceTable?.map((child) => {
          child.price = Math.round(child.price)
          child.childPrice = Math.round(child.childPrice)
          child.boneSubsidy = Math.round(child.boneSubsidy)
        })
      })

      this.displayVacancyCalendar = _.cloneDeep(clonedResult)
      this.vacancyCalendar = clonedResult
      this.childPriceInfo['childInfos'] =
        _.get(clonedResult, 'childPriceInfo.childInfos', null) || []
      this.childPriceInfo['childInfos'] = this.childPriceInfo['childInfos'].filter(e => {
        return e.priceReference != null;
      }).map((e) => {
        const priceReference = this.$filters.formatInteger(e.price)
        e.childDivLabel = this.chldTypeLabel(e.childDiv)
        e.priceReference = `${priceReference}${e.priceUnit}`
        return e
      })
      this.changeControl.init = false
      this.applyChange()
      this.loadInstockDays();
      this.handleUnavableCheckInDate();

      if (
        this.vacancyCalendar &&
        Array.isArray(this.vacancyCalendar.vacancyCalendars) &&
        this.vacancyCalendar.vacancyCalendars.length
      ) {
        if (_.get(this.vacancyCalendar, 'vacancyCalendars[0].roomPrice', null)) {
          this.baseOnPrice = PLAN_BASE_ON_PRICE.ROOM
          // SET BASE ON ROOM PRICE
          this.$store.dispatch(BASE_ON_PRICE, PLAN_BASE_ON_PRICE.ROOM)
        } else {
          this.baseOnPrice = PLAN_BASE_ON_PRICE.PEOPLE
          // SET BASE ON PEOPLE PRICE
          this.$store.dispatch(BASE_ON_PRICE, PLAN_BASE_ON_PRICE.PEOPLE)
        }
      }
      this.getPriceMin()
      this.calculateStayAmount()
      if (callback) {
        callback(clonedResult)
      }
      return clonedResult
    },
    applyChange() {
      this.stayDay = this.getDataMoment(this.tmpVariables.stayDay, this.stayDay)
      this.stayNights = this.tmpVariables.stayNights || 1
      this.stayRooms = this.tmpVariables.stayRooms
      this.stayAdults = this.tmpVariables.stayAdults
      this.memberAdults = this.tmpVariables.memberAdults
      this.visitorAdults = this.tmpVariables.visitorAdults
      this.attachChildren = _.cloneDeep(this.tmpVariables.attachChildren)
      this.memberChldDetails = _.cloneDeep(this.tmpVariables.memberChldDetails)
      this.visitorChldDetails = _.cloneDeep(this.tmpVariables.visitorChldDetails)

      this.updateQueryParams({
        checkInDate: this.stayDay ? moment(this.stayDay).format(this.dateFormat2) : null,
        stayNights: this.stayNights || 1,
        roomCnt: this.stayRooms,
        adultHeadCnt: this.stayAdults,
        exUpperGradesHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType10),
        exLowerGradesHeadCnt: _.cloneDeep(this.tmpVariables.memberChldDetails?.childrenType15),
        youjiAHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType20),
        youjiBHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType30),
        youjiCHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType40),
        youjiDHeadCnt: _.cloneDeep(this.tmpVariables?.memberChldDetails?.childrenType50),
        numPeople: this.countPeople,
      })
    },
    isOutstockDay(date) {
      if (date && this.instockDayMap[date.format(this.dateFormat)]) {
        return false
      }
      return true
    },
    isFilterClosedDays(checkingDate) {
      // 子コンポーネントのCalendarに同じロジックがあるのでできれば共通化
      if (
        this.filterCloseDays &&
        Array.isArray(this.filterCloseDays) &&
        this.filterCloseDays.includes(checkingDate)
      ) {
        return true
      }
      return false
    },
    getOpenDays() {
      // 在庫カレンダー定義（表示月）
      let vacancyCalendars =
        this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
          ? this.displayVacancyCalendar.vacancyCalendars
          : []
      ;
      // 在庫4以上の在庫でフィルター
      vacancyCalendars = vacancyCalendars.filter(
        (e) => (e.stock > 4 || e.stock === 0) && e.stock >= this.stayRooms
      );
      // 在庫日付のみで配列定義
      const instockDays = [];
      vacancyCalendars.forEach((el) => {
        instockDays.push(el.stayDay)
      });

      // プラン販売開始日・終了日を取得
      let start = instockDays.findIndex((e) => {return e === this.planBasicInfo?.planSaleEndDt});
      let end = instockDays.findIndex((e) => {return e === this.planBasicInfo?.planSaleSttDt});

      // プラン申込開始日・終了日が当月に存在しない場合、vacancyCalendarsの範囲とする
      if (start === -1) start = 0;
      if (end === -1) end = instockDays.length;
      return instockDays.slice(start, end);
    },
    getFewDays() {
      this.fewLeftDayMap = {}
      let vacancyCalendars =
        this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
          ? this.displayVacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter(
        (e) => e.stock > 0 && e.stock <= 4 && e.stock >= this.stayRooms
      )
      const fewLeftDays = []
      vacancyCalendars.forEach((el) => {
        this.fewLeftDayMap[el.stayDay] = el.stock
        fewLeftDays.push(el.stayDay)
      })
      return fewLeftDays
    },
    loadInstockDays() {
      this.instockDayMap = {}
      let vacancyCalendars =
        this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
          ? this.displayVacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter(
        (e) => (e.stock === 0 || e.stock >= 1) && e.stock >= this.stayRooms
      )
      const instockDays = []
      vacancyCalendars.forEach((el) => {
        this.instockDayMap[el.stayDay] = true
        instockDays.push(el.stayDay)
      })
      return instockDays
    },
    checkFewLeftDay(date) {
      if (this.fewLeftDayMap[date.format(this.dateFormat)]) {
        return this.fewLeftDayMap[date.format(this.dateFormat)]
      }
      return 0
    },
    getMaxAvailableRooms() {
      let maxAvailableRooms = null
      for (let i = 0; i < this.tmpVariables.stayNights; i++) {
        const checkDay = this.getDataMoment(this.stayDay).add(i, 'days')
        if (this.checkFewLeftDay(checkDay)) {
          if (
            maxAvailableRooms === null ||
            maxAvailableRooms > this.fewLeftDayMap[checkDay.format(this.dateFormat)]
          ) {
            maxAvailableRooms = +this.fewLeftDayMap[checkDay.format(this.dateFormat)]
          }
        }
      }
      return maxAvailableRooms
    },
    onChangePeoplePlan($event) {
      if (
        +$event.memberAdults + +$event.visitorAdults !==
        +this.tmpVariables.stayAdults
      ) {
        this.tmpVariables.stayAdults = +$event.memberAdults + +$event.visitorAdults
      }
      this.tmpVariables.memberAdults = $event.memberAdults
      this.tmpVariables.visitorAdults = $event.visitorAdults
      this.tmpVariables.memberChldDetails = $event.memberChldDetails
      this.tmpVariables.visitorChldDetails = $event.visitorChldDetails
      // member, visitorどちらもchild設定があるとき
      if (!_.isEmpty(this.tmpVariables.memberChldDetails) && !_.isEmpty(this.tmpVariables.visitorChldDetails)) {
        this.tmpVariables.attachChildren = {
          childrenType10:
            this.tmpVariables.memberChldDetails.childrenType10 +
            this.tmpVariables.visitorChldDetails.childrenType10,
          childrenType15:
            this.tmpVariables.memberChldDetails.childrenType15 +
            this.tmpVariables.visitorChldDetails.childrenType15,
          childrenType20:
            this.tmpVariables.memberChldDetails.childrenType20 +
            this.tmpVariables.visitorChldDetails.childrenType20,
          childrenType30:
            this.tmpVariables.memberChldDetails.childrenType30 +
            this.tmpVariables.visitorChldDetails.childrenType30,
          childrenType40:
            this.tmpVariables.memberChldDetails.childrenType40 +
            this.tmpVariables.visitorChldDetails.childrenType40,
          childrenType50:
            this.tmpVariables.memberChldDetails.childrenType50 +
            this.tmpVariables.visitorChldDetails.childrenType50
        }
      // visitorchildが空で、memberchildが値があるとき
      } else if (!_.isEmpty(this.tmpVariables.memberChldDetails)) {
        this.tmpVariables.attachChildren = {
          childrenType10: this.tmpVariables.memberChldDetails.childrenType10,
          childrenType15: this.tmpVariables.memberChldDetails.childrenType15,
          childrenType20: this.tmpVariables.memberChldDetails.childrenType20,
          childrenType30: this.tmpVariables.memberChldDetails.childrenType30,
          childrenType40: this.tmpVariables.memberChldDetails.childrenType40,
          childrenType50: this.tmpVariables.memberChldDetails.childrenType50,
        }
      // memberchildが空で、visitorchildが値があるとき
      } else {
        this.tmpVariables.attachChildren = {
          childrenType10: this.tmpVariables.visitorChldDetails.childrenType10,
          childrenType15: this.tmpVariables.visitorChldDetails.childrenType15,
          childrenType20: this.tmpVariables.visitorChldDetails.childrenType20,
          childrenType30: this.tmpVariables.visitorChldDetails.childrenType30,
          childrenType40: this.tmpVariables.visitorChldDetails.childrenType40,
          childrenType50: this.tmpVariables.visitorChldDetails.childrenType50,
        } 
      }
      this.getVacancyCalendar()
      this.getStayParam()
      // getVacancyCalendar()内でqueryを更新しているため、大人だけしか更新されていないこちらは削除
      //const query = _.cloneDeep(this.$route.query)
      //query.adultHeadCnt = this.tmpVariables.stayAdults
      //this.$router.replace({ query }).catch(() => {})
    },
    checkValidStayPeople() {
      const totalSlot = +this.stayAdults
      const maxAvailableRooms = this.getMaxAvailableRooms()
      if (
        maxAvailableRooms !== null &&
        totalSlot / this.maxStayCapacity > maxAvailableRooms
      ) {
        return true
      }
      return false
    },
    checkValidStayRoom() {
      const maxAvailableRooms = this.getMaxAvailableRooms()
      if (maxAvailableRooms !== null && this.stayRooms > maxAvailableRooms) {
        return true
      }
      return false
    },
    /**
     * checkInDate
     * stayNights
     * roomCnt
     * adultHeadCnt
     */
    updateQueryParams(newQuery) {
      let query = _.cloneDeep(this.$route.query)

      // 比較用に再帰的に文字列に変換する内部関数
      const stringifyValues = (obj) => {
        const stringify = (value) => {
          if (_.isArray(value)) {
            return value.map(stringify)
          } else if(_.isObject(value)) {
            return _.mapValues(value, stringify)
          }
          return String(value)
        }

        return stringify(obj)
      }

      // fromR=1パラメータを削除
      if (query.fromR) {
        delete query.fromR
      }
      // 比較用の変数
      const filterdQuery = _.pick(query, Object.keys(newQuery))
      const stringNewQuery = stringifyValues(newQuery)

      // queryの内容が更新されている場合のみ実行
      if(!isEqual(filterdQuery, stringNewQuery)){
        query = { ...query, ...newQuery }
        
        // ページ情報をリセット、パンくずのリンクを最新化
        if (query.page){
          delete query.page
        }
        if (query.planPage){
          delete query.planPage
        }
        sessionStorage.setItem('previousUrl', JSON.stringify(query))
      }
      const options ={
        checkInDate: this.stayDay ? moment(this.stayDay).format(this.dateFormat2) : null,
        stayNights: this.stayNights || 1,
        roomCnt: this.stayRooms,
        adultHeadCnt: this.stayAdults,
        exUpperGradesHeadCnt: _.cloneDeep(this.tmpVariables.memberChldDetails.childrenType10),
        exLowerGradesHeadCnt: _.cloneDeep(this.tmpVariables.memberChldDetails.childrenType15),
        youjiAHeadCnt: _.cloneDeep(this.tmpVariables.memberChldDetails.childrenType20),
        youjiBHeadCnt: _.cloneDeep(this.tmpVariables.memberChldDetails.childrenType30),
        youjiCHeadCnt: _.cloneDeep(this.tmpVariables.memberChldDetails.childrenType40),
        youjiDHeadCnt: _.cloneDeep(this.tmpVariables.memberChldDetails.childrenType50)
      }
      document.cookie = createSetCookie('selected_option_plan',JSON.stringify(options))
      // top宿泊画面用の検索条件保持クッキー追加
      document.cookie = createSetCookie('stay_search_conditions', encodeURIComponent(JSON.stringify(query)), undefined, true)
      this.$router.replace({ query }).catch(() => {})
    },
    validateOK() {
      // CHECK DAY SELECTED IS INSTOCK
      let hasOutStockDay = false
      for (let i = 0; i < this.stayNights; i++) {
        const checkDay = this.getDataMoment(this.stayDay).add(i, 'days')
        if (this.isOutstockDay(checkDay) && this.getReservationDiv() !== "20") {
          this.$toasted.clear()
          this.$toasted.error(
            'ご指定された条件ではご利用いただけません。<br>日程またはご利用人数を設定し直すか、他のプランをご利用ください。',
            TOAST_OPTION
          )
          hasOutStockDay = true
          break
        }
      }
      if (hasOutStockDay) {
        // this.$toasted.error('空室がない日付を選択しました。')
        return false
      }

      // Số phòng còn lại của khách hàng
      const minStayStock = this.getMinRoomStock(this.selectedDaysInfo)
      if (minStayStock !== null && this.stayRooms > minStayStock) {
        if (this.getReservationDiv() !== "20") {
          this.$toasted.error('選択された部屋の数が、空室な部屋の数を超えました。')
          return false
        }
      }

      // check min & max plan stay nighs capacity
      // stayLimitMax: null
      // stayLimitMin: null
      const stayLimitMin = _.get(this.planUsage, 'usageDetailStay.stayLimitMin', null)
      const stayLimitMax = this.checkStayLimitMax(_.get(this.planUsage, 'usageDetailStay.stayLimitMax', null))
      if (stayLimitMin !== null && +this.stayNights < +stayLimitMin) {
        this.$toasted.error(
          `こちらのプランをご利用するには最低${stayLimitMin}泊が必要です。`
        )
        return false
      }
      if (stayLimitMax !== null && +this.stayNights > +stayLimitMax) {
        this.$toasted.error(
          `こちらのプランには最大${stayLimitMax}泊までご使用いただけます。`
        )
        return false
      }

      if (this.countPeople === 0) {
        this.$toasted.error('選択された人数は、1部屋あたり最低1人に達していません。')
        return false
      }

      if (this.countPeople < +this.minStayCapacity) {
        this.$toasted.error(`一部屋ごとの最低利用人数を満たしておりません。${this.minStayCapacity}名以上で設定してください。`)
        return false
      }

      if (this.countPeople > +this.maxStayCapacity) {
        this.$toasted.error('選択された人数が最大数を超えました。')
        return false
      }

      if ((this.stayAdults + this.countTotalChildren) * this.stayRooms > 19) {
        this.$toasted.error('1度の申込で予約可能な最大人数は19名となります。')
        return false
      }

      return true
    },
    checkDayOpen() {
      return true
    },
    checkDayFewLeft() {
      return true
    },
    checkDayClose() {
      return true
    },
    checkFiveDay() {
      const countDay = moment().diff(moment(this.planRcSttDt, 'DD/MM/YYYY'), 'days')
      if (countDay > 0 && countDay <= 5) {
        return true
      }
      return false
    },
    checkDisabledDate($event, options = {}) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
          ? this.displayVacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars
        .filter((e) => e.stock && e.stock >= this.stayRooms)
        .map((e) => e.stayDay)

      if (options && options.mode === 'year') {
        return $event.isBefore(now, 'month')
      }
      else if (
        moment(this.planBasicInfo.planSaleEndDt).isBefore($event.format(this.dateFormat)) ||
        moment(this.planBasicInfo.planSaleSttDt).isAfter($event.format(this.dateFormat))
      ){
        return $event.format(this.dateFormat)
      }
      else if ($event.isBefore(now, 'day')) {
        return $event.format(this.dateFormat)
      }
      else if (
        !inStockDays.includes($event.format(this.dateFormat)) &&
        this.getReservationDiv() !== "20") {
        return $event.format(this.dateFormat)
      }
    },
    dayOpenDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
          ? _.cloneDeep(this.displayVacancyCalendar.vacancyCalendars)
          : []
      const instockDays = vacancyCalendars
        .filter((e) => e.stock > 4 || e.stock === 0)
        .map((el) => el.stayDay)

      if(
        moment(this.planBasicInfo.planSaleEndDt).isBefore($event.format(this.dateFormat)) ||
        moment(this.planBasicInfo.planSaleSttDt).isAfter($event.format(this.dateFormat))
      ){
        return  !$event.isBefore(now, 'day')
        ? '-'
        : ''
      }
      else if (this.status != null && this.status == "CC") {
        return !$event.isBefore(now, 'day') &&
          instockDays.includes($event.format(this.dateFormat))
          ? vacancyCalendars
              .filter((e) => e.stayDay === $event.format(this.dateFormat))
              .map((el) => el.stock)
              .toString()
          : ''
      }
      return !$event.isBefore(now, 'day') &&
        instockDays.includes($event.format(this.dateFormat))
        ? '○'
        : ''
    },
    fewLeftDecorator($event) {
      const now = moment(new Date())
      let vacancyCalendars =
        this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
          ? this.displayVacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter(
        (e) => e.stock > 0 && e.stock <= 4 && e.stayDay === $event.format('YYYY/MM/DD')
      )

      if (this.status != null && this.status == "CC") {
        return !$event.isBefore(now, 'day')
          ? vacancyCalendars
              .filter((e) => e.stayDay === $event.format(this.dateFormat))
              .map((el) => el.stock)
              .toString()
          : ''
      }

      return !$event.isBefore(now, 'day') ? vacancyCalendars[0].stock : ''
    },
    dayClosedDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
          ? this.displayVacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars
        .filter((e) => e.stock && e.stock >= this.stayRooms)
        .map((e) => e.stayDay)

      if(
        moment(this.planBasicInfo.planSaleEndDt).isBefore($event.format(this.dateFormat)) ||
        moment(this.planBasicInfo.planSaleSttDt).isAfter($event.format(this.dateFormat))
      ){
        return  !$event.isBefore(now, 'day')
        ? '-'
        : ''
      }
      else if (this.status != null && this.status == "CC") {
        return !$event.isBefore(now, 'day') &&
          !inStockDays.includes($event.format(this.dateFormat))
          ? '0'
          : ''
      }

      if ($event.isBefore(now, 'day')) {
        return ''
      } else {
        const vacancyCalendars =
          this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
            ? this.displayVacancyCalendar.vacancyCalendars
            : []

        const inStockDays = vacancyCalendars
          .filter((e) => e.stayDay === $event.format(this.dateFormat))

        if(inStockDays.length == 1) {
          if (inStockDays[0].reservationDiv == "20") {
            return 'R'
          }
        } else {
          return '×'
        }
        return '×'
      }

      // return !$event.isBefore(now, 'day') &&
      //   !inStockDays.includes($event.format(this.dateFormat))
      //   ? '×'
      //   : ''
    },
    dateCellExtraContent(date) {
      let day = null
      const vacancyCalendars = _.get(this.vacancyCalendar, 'vacancyCalendars') || []
      if (vacancyCalendars.length) {
        const filterVacancy = vacancyCalendars.filter(
          (item) =>
            moment(item.stayDay).isSame(moment(date), 'day') &&
            item.stock &&
            item.stock >= this.stayRooms
        )
        day = filterVacancy.length ? filterVacancy[0] : null
      }

      if(
        moment(this.planBasicInfo.planSaleEndDt).isBefore(date) ||
        moment(this.planBasicInfo.planSaleSttDt).isAfter(date)
      ){
          return ''
      }
      if (
        day &&
        moment().isSameOrBefore(date, 'day') &&
        this.stayDay.isSame(date, 'month')
      ) {
        return this.$filters.formatCurrency(day.price)
      } else if (
        !day &&
        moment().isSame(date, 'month') &&
        moment().isSameOrBefore(date, 'day') &&
        this.stayDay.isSame(date, 'month')
      ) {
        return ''
      } else if (
        moment().isBefore(date, 'month') &&
        ((moment().isSame(this.stayDay) && this.enableNextMonth) ||
          (moment().isBefore(this.stayDay) && this.stayDay.isSame(date, 'month')))
      ) {
        return ''
      }
      return ''
    },
    calculateStayAmount() {
      const selectedDaysTemp = []
      const selectedDays = _.cloneDeep(this.getSelectedDays)
      selectedDays.splice(-1)
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      let netAmount = 0

      selectedDays.forEach((day) => {
        const dayInfo = {
          stayDay: day,
          childTypePrice: {},
          roomPrice: null,
          price: null,
          adultPrice: null,
          boneSubsidy: null,
          stock: null,
          reservationDiv: null,
          childrenPriceTable: []
        }
        vacancyCalendars.forEach((vacancy) => {
          if (moment(day).isSame(moment(vacancy.stayDay), 'day')) {
            const memberPrice = vacancy.price ? vacancy.price : 0
            const roomPrice = vacancy.roomPrice ? vacancy.roomPrice : 0
            netAmount += this.stayAdults * memberPrice + this.stayRooms * roomPrice
            dayInfo['childTypePrice'] = {}
            if (!roomPrice) {
              dayInfo['childTypePrice']['childrenType10'] = this.getMemberChildPrice(
                'a',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType15'] = this.getMemberChildPrice(
                'b',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType20'] = this.getMemberChildPrice(
                'c',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType30'] = this.getMemberChildPrice(
                'd',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType40'] = this.getMemberChildPrice(
                'e',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType50'] = this.getMemberChildPrice(
                'f',
                vacancy.childrenPriceTable
              )

              dayInfo['childTypePrice']['visitorType10'] = this.getVisitorChildPrice(
                'a',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType15'] = this.getVisitorChildPrice(
                'b',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType20'] = this.getVisitorChildPrice(
                'c',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType30'] = this.getVisitorChildPrice(
                'd',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType40'] = this.getVisitorChildPrice(
                'e',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType50'] = this.getVisitorChildPrice(
                'f',
                vacancy.childrenPriceTable
              )

              Object.keys(this.memberChldDetails).forEach((key) => {
                if (this.memberChldDetails[key]) {
                  netAmount +=
                    this.memberChldDetails[key] *
                    this.getMemberChildPrice(key, vacancy.childrenPriceTable) *
                    this.stayRooms
                }
              })
              Object.keys(this.visitorChldDetails).forEach((key) => {
                if (this.visitorChldDetails[key]) {
                  netAmount +=
                    this.visitorChldDetails[key] *
                    this.getVisitorChildPrice(key, vacancy.childrenPriceTable) *
                    this.stayRooms
                }
              })
            }
            dayInfo.adultPrice = vacancy.adultPrice
            dayInfo.boneSubsidy = vacancy.boneSubsidy
            dayInfo.price = vacancy.price
            dayInfo.roomPrice = vacancy.roomPrice
            dayInfo.stock = vacancy.stock
            dayInfo.reservationDiv = vacancy.reservationDiv
            dayInfo.childrenPriceTable = vacancy.childrenPriceTable
          }
        })
        selectedDaysTemp.push(dayInfo)
      })
      this.selectedDaysInfo = selectedDaysTemp
      return netAmount
    },
    showPhotoGallery() {
      const { menuNo } = this.$route.params
      const query = this.$route.query
      this.$router.push({ path: `/menus/${menuNo}/photo-gallery`, query })
    },
    chldTypeLabel(type) {
      switch (type) {
        case '10':
          return '小学生・高学年'
        case '15':
          return '小学生・低学年'
        case '20':
          return '幼児・食事布団付き'
        case '30':
          return '幼児・食事のみ'
        case '40':
          return '幼児・布団のみ'
        case '50':
          return '幼児・食事布団不要'
      }
    },
    backPath() {
      const { menuNo } = this.$route.params
      let query = _.cloneDeep(this.$route.query)
      query = { ...query, numPeople: this.countPeople }
      // top宿泊画面用の検索条件保持クッキー追加
      document.cookie = createSetCookie('stay_search_conditions', encodeURIComponent(JSON.stringify(query)), undefined, true)
      this.$router.push({ path: `/menus/${menuNo}/plans`, query })
    },
    previewPlanImage(imgInfo) {
      if (imgInfo) {
        this.previewImage = imgInfo
        this.showPreviewImg = true
      }
    },
    copyShareURL() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('コピーしました')
    },
    copyError() {
      this.$toasted.error('コピーできません')
    },
    handleOpenIntro() {
      window.open(
        `${process.env.VUE_APP_BS_BENEFIT_DOMAIN}/bs/pages/bo/template.faces?ih=/contents/bs_base/goriyou/`
      )
    },
    // openTaxLink() {
    //   window.open(
    //     `${process.env.VUE_APP_BS_BENEFIT_DOMAIN}/bs/pages/bs/stay/stayTax.faces?menuNo=162372`
    //   )
    // },
    savePlanData(callback = null) {
      const query = this.$route.query
      // const queryParams = {
      //   ...this.$route.params,
      //   ...query
      // }
      const data = {
        acptDtlNo: this.acptDtlNo,
        stayDay: this.stayDay.format('YYYY/MM/DD'),
        stayDayJP: this.stayDay.format('YYYY年MM月DD日から'),
        stayNights: +this.stayNights || 1,
        stayRooms: +this.stayRooms,
        stayAdults: +this.stayAdults,
        memberAdults: this.memberAdults,
        visitorAdults: this.visitorAdults,
        memberChldDetails: this.memberChldDetails,
        visitorChldDetails: this.visitorChldDetails,
        attachChildren: this.attachChildren,
        countTotalChildren: this.countTotalChildren,
        netAmount: this.calculateStayAmount(), // Tổng chi phí (gồm thuế),
        detailDays: this.selectedDaysInfo,
        maxStayCapacity: this.maxStayCapacity,
        minStayCapacity: this.minStayCapacity,
        vacancyCalendar: this.vacancyCalendar,
        subsidyList: this.subsidyList,
        toPlanDetailFrom: true,
        extSystemCd: _.get(this.menuInformation, 'extSystemCd', null),
        applLimits: this.applLimits,
        yearCrosses: this.yearCrosses,
        menuNo: this.menuNo,  // MN 宿泊在庫引当解除 対応の為に追加。必要なくなれば、削除
        roomId: this.roomId,  // MN 宿泊在庫引当解除 対応の為に追加。必要なくなれば、削除
        reserveId: this.reserveId,
        limitNights: this.limitNights
      }

      this.$store.dispatch(SAVE_CUSTOMER_PLAN, data).then(() => {
        // if (this.checkConditionBookRoom) {
        //   this.$router.push({ path: '/register-rooms', query: queryParams })
        // }
        if (callback) {
          callback()
        }
      })
    },
    async checkLitmitStay() {
      const formatDate = 'YYYY-MM-DD'
      let applLimits = this.applLimits
      if (applLimits) {
        applLimits = applLimits[0]
        const usageLimitCnt = applLimits.usageLimitCnt
        let roomLimitDiv = applLimits.usageLimitCnt
        const usageLimitCont = applLimits.usageLimitCont
        const usageLimitTermDiv = applLimits.usageLimitTermDiv
        const usageLimitTermStt = moment(applLimits.usageLimitTermStt).format(formatDate)
        const usageLimitTermEnd = moment(applLimits.usageLimitTermEnd).format(formatDate)
        let roomLimitFrom = usageLimitTermStt
        let roomLimitTo = usageLimitTermEnd
        let roomLimitYear = moment(usageLimitTermStt).year()

        if (usageLimitTermDiv === '2') {
          roomLimitDiv = 0
          roomLimitFrom = null
          roomLimitTo = null
        } else if (usageLimitTermDiv === '1') {
          roomLimitDiv = 1
          roomLimitYear = null
        }
        const { menuNo, planId } = this.$route.params
        const stayDay = moment(this.stayDay)
        const data = {
          menuNo,
          planId,
          customerNo: _.get(this.userInfo, 'ssoCustomerNo', null),
          aplyNum: this.stayRooms,
          useDate: moment(stayDay).format(formatDate),
          nightCnt: this.stayNights || 1,
          roomLimitList: [
            {
              roomLimitCnt: usageLimitCnt,
              roomLimitDiv,
              roomLimitYear,
              roomLimitFrom,
              roomLimitTo
            }
          ]
        }
        const limitRoomStatus = await this.checkRoomLimit(data)
        if (limitRoomStatus === 200) {
          return true
        } else {
          this.$toasted.error(usageLimitCont)
          return false
        }
      } else {
        return true
      }
    },
    async checkIsLogin() {
      return await this.$repositories('user').getUser()
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        });
    },
    async goNext() {
      // 認証が切れていた場合、エラー画面に遷移
      if (!await this.checkIsLogin()) {
        this.$router.push('/session-time-out-to-top')
        return;
      }
      if ((this.tmpVariables.stayNights < 1 || !this.tmpVariables.stayDay) && this.getReservationDiv() !== "20") {
        this.$nextTick(() => {
          this.$toasted.clear()
          this.$toasted.error(
            'ご指定された条件ではご利用いただけません。<br>日程またはご利用人数を設定し直すか、他のプランをご利用ください。',
            TOAST_OPTION
          )
        })
        return
      } else {
        this.$toasted.clear()
      }
      // 申込時の楽天アクセストークンチェック
      if (this.isRakuten) {
        try {
          const response = await this.$repositories('login').checkLoginRakuten()
          this.isLoginedRakuten = Boolean(get(response, 'data.login'))
          if (!this.isLoginedRakuten) {
            this.setConfirm(true);
            return;
          }
        } catch (error) {
          console.log('楽天アクセストークンチェックエラー')
        }
      }
      let isExistBooking = false
      let checkoutTm = ''
      checkoutTm = moment(this.stayDay).add(this.stayNights, 'days').subtract(1, "days").format('YYYY-MM-DD')
      const params = {
        reserveSts: 1,
        searchDiv: 0,
        dateFrom: this.stayDay.format('YYYY-MM-DD'),
        dateTo: checkoutTm,
      };

      try{
        const res = await this.$repositories('order').getOrderHistory(params)
        const orderInfoListExist =_.get(res, 'orderInfoList', [])
        if(await this.checkOrderInfoExist(orderInfoListExist)){
          isExistBooking = true
          this.$toasted.error(
            '既に同一の「利用日」で申込みされていますので、お申込みできません。',
            TOAST_OPTION
          )
          return
        }
      }catch(error){
        isExistBooking = true
        this.$toasted.error(
            '問題が発生しました。申し訳ございませんが、サイトトップからやり直してください。',
            TOAST_OPTION
          )
        return
      }
      this.$store.dispatch('order/setOriginCalendar', this.vacancyCalendar?.vacancyCalendars)

      const errCode = await this.checkInfoUserOrder()
      const hasCode = _.map(this.identificationType, 'code').includes(errCode)
      if (hasCode) {
        this.setConfirmNotice(errCode)
        this.showPopUp = true
        return
      }
      if (!this.validateOK()) {
        return
      }

      const limitStay = await this.checkLitmitStay()
      if (!limitStay) {
        return
      }

      const query = this.$route.query
      const queryParams = {
        ...this.$route.params,
        ...query
      }

      this.savePlanData(() => {
        if (this.checkConditionBookRoom) {
          this.$router.push({ path: '/register-rooms', query: queryParams })
        } else {
          this.$toasted.error('大人1名以上が必要です。')
        }
      })

      // const data = {
      //   acptDtlNo: this.acptDtlNo,
      //   stayDay: this.stayDay.format('YYYY/MM/DD'),
      //   stayDayJP: this.stayDay.format('YYYY年MM月DD日から'),
      //   stayNights: +this.stayNights,
      //   stayRooms: +this.stayRooms,
      //   stayAdults: +this.stayAdults,
      //   memberAdults: this.memberAdults,
      //   visitorAdults: this.visitorAdults,
      //   memberChldDetails: this.memberChldDetails,
      //   visitorChldDetails: this.visitorChldDetails,
      //   attachChildren: this.attachChildren,
      //   countTotalChildren: this.countTotalChildren,
      //   netAmount: this.calculateStayAmount(), // Tổng chi phí (gồm thuế),
      //   detailDays: this.selectedDaysInfo,
      //   maxStayCapacity: this.maxStayCapacity,
      //   minStayCapacity: this.minStayCapacity,
      //   vacancyCalendar: this.vacancyCalendar,
      //   subsidyList: this.subsidyList
      // }
      // this.$store.dispatch(SAVE_CUSTOMER_PLAN, data).then(() => {
      //   this.$router.push({path: '/register-rooms', query: queryParams})
      // })
    },
    openChildrenPolicy() {
      window.open(
        'https://bs.benefit-one.co.jp/bs/pages/bs/stay/stayTax.faces?menuNo=162372'
      )
    },
    async loginRakuten() {
      let isExistBooking = false
      let checkoutTm = ''
      checkoutTm = moment(this.stayDay).add(this.stayNights, 'days').subtract(1, "days").format('YYYY-MM-DD')
      const params = {
        reserveSts: 1,
        searchDiv: 0,
        dateFrom: this.stayDay.format('YYYY-MM-DD'),
        dateTo: checkoutTm,
      };

      try{
        const res = await this.$repositories('order').getOrderHistory(params)
        const orderInfoListExist =_.get(res, 'orderInfoList', [])
        if(await this.checkOrderInfoExist(orderInfoListExist)){
          isExistBooking = true
          this.$toasted.error(
            '既に同一の「利用日」で申込みされていますので、お申込みできません。',
            TOAST_OPTION
          )
          return
        }
      }catch(error){
        isExistBooking = true
        this.$toasted.error(
            '問題が発生しました。申し訳ございませんが、サイトトップからやり直してください。',
            TOAST_OPTION
          )
        return
      }

      sessionStorage.setItem('rakutenLoginCallBackUrl', location.href);
      const urlPage = location.href.replace(location.search, '?fromR=1');
      // 楽天側がOMNI UI新システムのログインになったことからセッション時間が10分になったため、リフレッシュトークンの有効期限を570秒（9分30秒）にすることで片落ち制御。楽天側のセッションが直り次第削除。
      const maxAge = 570;
      // location.href = `https://app.rakuten.co.jp/engine/authorize?response_type=code&client_id=rakutentravel_beneone&redirect_uri=${process.env.VUE_APP_API_URL}/v1/stay/rakuten/callback?url=${urlPage}&scope=travel_booking_book,travel_booking_cancel,travel_booking_refer,1Hour@Access&service_id=t22`
      location.href = `${process.env.VUE_APP_RAKUTEN_LOGIN_DOMAIN}/sso/authorize?response_type=code&client_id=rakutentravel_beneone_jp&redirect_uri=${process.env.VUE_APP_API_URL}/v1/stay/rakuten/login&state=${urlPage}&scope=openid+travel_booking_book+travel_booking_cancel+travel_booking_refer&service_id=t22&ui_locales=ja-JP&max_age=${maxAge}`

    },
    gotoCalendar() {
      try {
        this.$smoothScroll({
          scrollTo: this.$refs['calendar'],
          offset: -100
        })
      } catch (e) {
        this.$loading.hide()
      }
    },
    openChildrenNotification() {
      // 同タブ遷移に変更
      this.$router.push('/children-notification')
    },
    navigateTo(route, query = {}) {
      // save plan data
      this.savePlanData(() => {
        this.$router.push({ path: route, query })
      })
    },
    async getGrantedBenepoStay(billingAmount) {
      // #71362 calc=1の子どもだけ算出していたため、大人＋子どもの総人数で算出するよう改修
      const benepoReturnDiv = this.totalPeopleCnt == 1 ? this.planDetail?.benepoReturnInfo?.benepoReturnDiv1:
      this.totalPeopleCnt > 1 ? this.planDetail?.benepoReturnInfo?.benepoReturnDiv2 : null;
      const benepoReturnFixed = this.totalPeopleCnt == 1 ? this.planDetail?.benepoReturnInfo?.benepoReturnFixed1:
      this.totalPeopleCnt > 1 ? this.planDetail?.benepoReturnInfo?.benepoReturnFixed2 : 0;
      const { menuNo, planId, roomId } = this.$route.params
      const params = {
                adultHeadCnt: this.tmpVariables?.stayAdults,
                exUpperGradesHeadCnt: this.attachChildren.childrenType10,
                exLowerGradesHeadCnt: this.attachChildren.childrenType15,
                youjiAHeadCnt: this.attachChildren.childrenType20,
                youjiBHeadCnt: this.attachChildren.childrenType30,
                youjiCHeadCnt: this.attachChildren.childrenType40,
                youjiDHeadCnt: this.attachChildren.childrenType50
      }
      if(!benepoReturnDiv) {
        this.grantedBenepo = null;
      }else if(benepoReturnDiv==='10'){
        this.$repositories('plan')
          .getGrantedBenepoStay({ menuNo, planId, billingAmount ,params })
          .then(
            (response) => {
              this.grantedBenepo = response.grantedBenepo

              }
          )
          .catch((err) => {
            console.error('getGrantedBenepoStay', err)
          })
       // this.grantedBenepo = billingAmount * benepoReturnRate / 100;
      }else if(benepoReturnDiv==='20') this.grantedBenepo = benepoReturnFixed
    },
    getStayParam() {
      const { adultHeadCnt } = this.$route.query
      const { menuNo, planId, roomId } = this.$route.params
      const stayNights = this.tmpVariables.stayNights || _.get(this.$route.query, 'stayNights') || 1
      const checkInDay = this.getDataMoment(this.tmpVariables.stayDay,this.stayDay).format('YYYY/MM/DD')
      const checkOutDay = this.getDataMoment(this.tmpVariables.stayDay,this.stayDay)
        .add(stayNights, 'days')
        .format('YYYY/MM/DD')
      const params = {
        checkInDay,
        checkOutDay,
        adultHeadCnt: adultHeadCnt || 1,
        exUpperGradesHeadCnt: get(
          this.tmpVariables.memberChldDetails,
          'childrenType10',
          0
        ),
        exLowerGradesHeadCnt: get(
          this.tmpVariables.memberChldDetails,
          'childrenType15',
          0
        ),
        youjiAHeadCnt: get(this.tmpVariables.memberChldDetails, 'childrenType20', 0),
        youjiBHeadCnt: get(this.tmpVariables.memberChldDetails, 'childrenType30', 0),
        youjiCHeadCnt: get(this.tmpVariables.memberChldDetails, 'childrenType40', 0),
        youjiDHeadCnt: get(this.tmpVariables.memberChldDetails, 'childrenType50', 0)
      }
      this.$repositories('plan')
        .getStayParams({
          menuNo,
          planId,
          roomId,
          params
        })
        .then(
          (result) => {
            this.payMthdInfo = result.payMthdInfo
          },
          (error) => {}
        )
    },
    setConfirmNotice(errCode) {
      this.$nextTick(() => {
        this.identificationNotice = this.identificationType.find(
          (item) => item.code === errCode
        )
        this.identificationNotice.familySerialNumber = this.familySerialNumber
      })
    },
    async checkInfoUserOrder() {
      // CRM汎用独自対応
      await this.$repositories("order").putProfile();
      const response = await this.$repositories("order").getProfile();
      const res = response.data;

      // if (this.profileMe) {
      //   const hostFlag =
      //     this.profileMe.familySerialNumber && this.profileMe.familySerialNumber !== '0'
      //   this.familySerialNumber = !hostFlag
      //   let errCode = 0
      //   const email = this.profileMe.email
      //   const tel = this.profileMe.tel

      if (res) {
        const hostFlag =
          res.familySerialNumber && res.familySerialNumber !== '0'
        this.familySerialNumber = !hostFlag
        let errCode = 0
        const email = res.email
        const tel = res.tel
        const profileName = res.familyName + res.firstName;
        // 名前を設定しなかった場合に入るデフォルト名
        const defaultName = process.env.VUE_APP_DEFAULT_REGISTRANT_NAME;
        if (!email && !tel && profileName == defaultName) {
          errCode = 7;
        } else if (!email && !tel) {
          errCode = 3;
        } else if (!email && profileName == defaultName) {
          errCode = 6;
        } else if (!tel && profileName == defaultName) {
          errCode = 5;
        } else if (!email) {
          errCode = 1;
        } else if (!tel) {
          errCode = 2;
        } else if (profileName == defaultName) {
          errCode = 4;
        }
        console.log(errCode)
        // const tel = this.profileMe.tel
        // if (!email && !tel) {
        //   errCode = 3
        // } else if (email && !tel) {
        //   errCode = 2
        // } else if (!email && tel) {
        //   errCode = 1
        // }
        // if (!email) {
        //   errCode = 1
        // }
        return errCode
      } else {
        this.$router.push('/error')
      }
    },
    checkRsvReceptEnd() {
      const applFlag = this.applFlag
      if (applFlag !== '1') {
        // NOTE comment this redirect on local environment
        this.errorType = 'plan'
        this.showModalError = true
      }
    },
    checkOutOfPlanRcDt() {
      const planRcSttDt = this.planBasicInfo?.planRcSttDt
      const planRcEndDt = this.planBasicInfo?.planRcEndDt
      if (!planRcSttDt && !planRcEndDt) return
      const isBefore = moment().isBefore(moment(planRcSttDt))
      const isAfter = moment().isAfter(moment(planRcEndDt))
      // NOTE comment this redirect on local environment
      if (isBefore || isAfter) {
        this.errorType = 'plan'
        this.showModalError = true
      }
    },
    //auto select nearest avaible date
    handleUnavableCheckInDate(){
      // 選択日に在庫があるか
      if(this.isUnavaibleCheckInDate){
        // 在庫がある日を探す
        let nearestDay= Object.keys(this.instockDayMap)?.find(day=>day>= moment().format(this.dateFormat))
        let query = _.cloneDeep(this.$route.query)
        if (nearestDay == null) {
          // 在庫がない
          this.tmpVariables.stayDay = null
          if (this.getReservationDiv() == "20") {
            const checkInDate = _.get(query, 'checkInDate');
            if(checkInDate && moment(checkInDate,this.dateFormat).isValid()) {
              nearestDay = moment(checkInDate, this.dateFormat2);
            }
            nearestDay = moment();
            this.stayDay = moment(nearestDay, this.dateFormat);
            this.tmpVariables.stayDay = moment(nearestDay, this.dateFormat);
          }
        } else {
          // 別日に在庫がある
          this.stayDay = moment(nearestDay);
          this.tmpVariables.stayDay=moment(nearestDay);
        }

        query = {...query, checkInDate: moment(nearestDay).format(this.dateFormat2)}
        // top宿泊画面用の検索条件保持クッキー追加（検索条件が変わっていた場合のみ）
        document.cookie = createSetCookie('stay_search_conditions', encodeURIComponent(JSON.stringify(query)), undefined, true)
        this.$router.push({path: this.$route.path, query });
      }
    },
    isDisplayBenepoTamaru(label) {
      // Notice: This is terrible code.Please fix.
      if (label === "ベネポ貯まる" && !this.isTargetGrantedBenepo) {
        return false
      }
      return true
    },

    // カフェアイコンの取得
    async getCafeIcon() {
      this.planDetail.planIcons = (this.planDetail.planIcons || []).filter(v => v)
      const params = {
        idData: this.makeIconReqParamsCafeInfo(),
        iconData: this.makeIconReqParamsPlanInfo(this.planData)
      };
      const res = await this.$repositories('coupon').getIcons(params);
      if (res.data.availableIcon) {
        this.planDetail.planIcons.push(res.data.availableIcon[0]);
      }
    },

    // 補助クーポンアイコンの取得
    async getSubsidyIcon(subsidyList) {
      // 補助クーポンリスト なし -> 終了
      if (!subsidyList || subsidyList.length === 0 ) return ;

      var iconNm = "補助クーポン"

      // 既に存在している場合 -> 終了
      this.planDetail.planIcons = this.planDetail.planIcons.filter(i => i) ; // undefined を削除
      if ( this.planDetail.planIcons.some(i => i.iconNm === iconNm)) return ;

      // アイコン登録
      this.planDetail.planIcons.push({ iconCD : "subsidy", iconNm, iconSuppl : null });
    },
    makeIconReqParamsPlanInfo() {
      const iconData = [
        {
          no: 0,
          catLrgClassCd: get(
            this.planDetail,
            'menuInformation.categoryInfomation.catLrgClassCd',
            ''
          ),
          catMidClassCd: get(
            this.planDetail,
            'menuInformation.categoryInfomation.catMidClassCd',
            ''
          ),
          catSmlClassCd: get(
            this.planDetail,
            'menuInformation.categoryInfomation.catSmlClassCd',
            ''
          ),
          menuNo: get(this.planDetail, 'menuInformation.menuNo', ''),
          planId: get(this.planDetail, 'planBasicInfo.planId', ''),
          areaLrgClassCd: get(
            this.planDetail,
            'menuInformation.areaInfomation.areaLrgClassCd',
            ''
          ),
          areaMidClassCd: get(
            this.planDetail,
            'menuInformation.areaInfomation.areaMidClassCd',
            ''
          ),
          areaSmlClassCd: get(
            this.planDetail,
            'menuInformation.areaInfomation.areaSmlClassCd',
            ''
          ),
          areaDtlClassCd: get(
            this.planDetail,
            'menuInformation.areaInfomation.areaDtlClassCd',
            ''
          ),
          receivableFlag: '1',
          ticketExclusionFlag: get(
            this.planDetail,
            'planUsage.usageDetail.ticketExclusionFlag',
            ''
          ),
          buppanExclusionFlag: get(
            this.planDetail,
            'planUsage.usageDetail.buppanExclusionFlag',
            ''
          ),
          famiExclusionFlag: get(
            this.planDetail,
            'planUsage.usageDetail.famiExclusionFlag',
            ''
          )
        }
      ];
      return iconData;
    },
    makeIconReqParamsCafeInfo() {
      const idData = [
        {
          no: "0",
          targetType: "1",
          id: "0000000" // 仮の値の為、BFFでカフェの契約IDをセットすること
        }
      ];
      return idData;
    },

    //SP Reservation Input
    stayDecrement() { //SP screen to match XD
      let nights = Number(this.tmpVariables.stayNights);
      if (nights > 0) {
        this.onChangeStayNights(nights - 1)
      }
    },

    //ボタン削除に伴い不要か？
    stayIncrement() { //SP screen to match XD
      let nights = Number(this.tmpVariables.stayNights);
      if (nights < 6 ) {
        this.onChangeStayNights(nights + 1);
      }
    },

    roomDecrement() { //SP screen to match XD
      let rooms = Number(this.tmpVariables.stayRooms);
      if (rooms > 1) {
        this.tmpVariables.stayRooms = rooms - 1;
        this.onChangeStayRoom(rooms);
      }
    },
    roomIncrement() { //SP screen to match XD
      let rooms = Number(this.tmpVariables.stayRooms);
      if (rooms < 10) {
        this.tmpVariables.stayRooms = rooms + 1;
        this.onChangeStayRoom(rooms);
      }
    },
    /**
    * 企業補助金か判定する
    */
    isCorporate(availableData) {
      if ( availableData.requestType == this.CONST_DATA.SUBSIDY_REQUEST_TYPE.CORPORATE) {
        return true
      }
      return false
    },
    /**
    * 画面表示用：上限枚数を取得
    * @arg     object[subsidyList]
    * @return: array
    */
    remainingCountLabel(subsidy) {
      let countLabelArr = subsidy?.scrennDisplayItemList?.remainingCountLabel?.value?.split(',') || []
      let countLabel = []
      countLabelArr.forEach((val) => {
        if (!val.includes('上限回数') && !val.includes('|null')) {
          countLabel.push(val.replace('|', '：'))
        }
      })
      return countLabel
    },
    /**
    * 画面表示用：上限金額を取得
    * @arg     object[subsidyList]
    * @return  array
    */
    remainingAmountLabel(subsidy) {
      let amountLabelArr = subsidy.scrennDisplayItemList?.remainingAmountLabel?.value?.split(',') || []
      let amountLabel = []
      amountLabelArr.forEach((val) => {
        if (!val.includes('上限金額') && !val.includes('|null')) {
          amountLabel.push(val.replace('|', '：'))
        }
      })
      return amountLabel
    },
    infoGroupTexts(subsidy) {
      let message = [];

      // 利用制限期間
      if (subsidy.availableData.groupInfo.usedLimTerm === "01") {
        message.push("上記適用期間内での制限適用となります");
      } else {
        message.push("月の利用制限となります");
      }

      // 利用上限総額（数）
      if (
        subsidy.availableData.groupInfo.usedMaxCnt > 0 &&
        subsidy.availableData.groupInfo.usedMaxTotalAmt > 0
      ) {
        message.push(`所属団体様内で先着${this.$filters.formatInteger(subsidy.availableData.groupInfo.usedMaxCnt)}枚まで/※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。`);
      } else if (
        subsidy.availableData.groupInfo.usedMaxCnt > 0 &&
        !subsidy.availableData.groupInfo.usedMaxTotalAmt
      ) {
        message.push(`所属団体様内で先着${this.$filters.formatInteger(subsidy.availableData.groupInfo.usedMaxCnt)}枚まで`);
      } else if (
        !subsidy.availableData.groupInfo.usedMaxCnt &&
        subsidy.availableData.groupInfo.usedMaxTotalAmt > 0
      ) {
        message.push("※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。");
      }

      return message.join('/');
    },
    isStayRequest() {
      const vacancyCalendars =
        this.displayVacancyCalendar && this.displayVacancyCalendar.vacancyCalendars
          ? this.displayVacancyCalendar.vacancyCalendars
          : []
      const isStayRequestDays = vacancyCalendars
        .filter((e) => e.reservationDiv === "20");
      if(isStayRequestDays.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    async checkOrderInfoExist(orderInfoList) {
      if(!orderInfoList) return false ;
      if(orderInfoList.length === 0) return false ;

      for (const orderInfo of orderInfoList) {
        // 大カテ
        if(orderInfo.catLrgClassCd !== '101' ) continue; // トラベル以外なら、continue

        // 中カテ
        if(orderInfo.catMidClassCd === '201' ){
          // 国内の宿
          if(orderInfo.catSmlClassCd === '310' ) continue; // その他国内の宿 の場合、continue
          if(orderInfo.catSmlClassCd === '311' ) continue; // 予約サイト の場合、continue

          return true;
        } else
        if(orderInfo.catMidClassCd === '202' ){
          // 国内の宿（ベネ楽）
          return true;
        }
        else {
          // 上記以外
          continue;
        }
      }
      return false;
    },
    checkStayLimitMax(stayLimitMax) {
      // 最長連泊数が６より大きいor値が無い場合は６を返す
      if(+stayLimitMax > 6 || stayLimitMax === null || stayLimitMax === "" || stayLimitMax === undefined) {
        return 6;
      }
      return +stayLimitMax;
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.box-coupons {
  margin-bottom: unset;
}
::v-deep.accommodation-tax {
  .box-viewmore {
    &:not(.open) {
      .box-content {
        max-height: 125px;
      }
    }
  }
}

.content {
  &__element {
    .t-col {
      width: 160px !important;
      padding: 2px !important;
      &:nth-of-type(even) {
        font-weight: bold;
      }
    }
  }
}
.available-coupon-balloon {
  font-size: 0.875rem;
  font-weight: bold;
  text-align: center;
  color: #fff;
  background-color: #259bee;
  border-radius: 4px;
  padding: 9px 55px;
  margin: 1rem auto -1rem;
  position: relative;
  width: 100%;
  @include mq() {
    max-width: none;
    padding: 9px 0;
    text-align: center;
    width: 100%;
    > p {
      margin-bottom: 0;
    }
  }
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5.5px solid transparent;
    border-top: 5px solid #259bee;
    @include mq() {
      content: "";
      position: absolute;
      top: 100%;
      right: 50%;
      transform: translateX(50%);
      border: 5.5px solid transparent;
      border-top: 5px solid #259bee;
    }
  }
}

.pnl-title {
  .two-lines-ellipsis {
    font-size: 1.25rem;
  }
}

.main {
  &-plan {
    .main-demo {
      margin-bottom: 2rem;
      padding-bottom: 2rem;
      border-bottom: 1px solid #dcdee0;
    }
  }
  &-availability {
    margin-bottom: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid #dcdee0;
    .menu-item {
      &__point {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: .75rem;
        &--point {
          font-weight: bold;
          color: #E60021;
          margin-right: 4px;
        }
        &--number {
          font-size: 1rem;
        }
        &--rakuten {
          display: flex;
          align-items: center;
          margin-left: .5rem;
        }
      }
    }
  }
}

.plan-detail {
  &__iconWrap {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;
  }
  &__iconList {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
    .tag-yellow {
      background: #FFD966;
    }
    .plan-icon {
      &:hover {
        opacity: 1;
      }
    }
    .online-payment-icon {
      color: #ffffff !important;
      background-color: #f58700 !important;
    }
  }
  &__planId {
    flex-shrink: 0;
    margin-left: auto;
    color: #63666a;
  }
  &__couponSocial {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0 1rem;
    width: 100%;
    margin-left: auto;
    ::v-deep .c-btn {
      margin-top: 1rem;
    }
  }
  &__basicInfo {
    font-size: .875rem;
  }
}

::v-deep .box-view-more {
  &__button-wrap {
    display: flex;
    font-size: .875rem;
  }
}

@media (max-width: $contentWidthS) {
  .content {
    &__element {
      .t-col {
        width: 25% !important;
        padding: .375rem !important;
        &:nth-of-type(even) {
          font-weight: normal;
        }
      }
    }

    &__info {
      .col-left,
      .col-right {
        padding-left: 8px !important;
      }
    }
  }

  .pnl-title {
    margin-bottom: 1rem;
  }

  .main {
    &-plan {
      margin-bottom: 1rem;
      padding-bottom: 1rem;
      border-bottom: 1px solid #dcdee0;
      .menu-carousel {
        margin-bottom: 0;
      }
      .main-demo {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
      }
    }
    &-availability {
      margin-bottom: 0;
      padding-bottom: 1rem;
      border-bottom: none;
    }
  }

  .plan-detail {
    &__iconWrap {
      flex-wrap: wrap;
    }
    &__iconList {
      margin-bottom: .5rem;
      .tag-yellow {
        background: #FFD966;
      }
    }
    &__planId {
      font-size: .625rem;
      text-align: right;
      width: 100%;
      margin-bottom: .5rem;
    }
    &__couponSocial {
      ::v-deep .mobile-share {
        margin-top: 0;
      }
    }
  }
}
</style>
